// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from "@tanstack/react-query";

import { client } from "../client.gen";
import {
  accessReviewInventory,
  apiKeyCreate,
  apiKeyListByOrg,
  apiKeyListByProject,
  apiKeyListByServiceAccount,
  apiKeyListByUser,
  apiKeyRevoke,
  apiKeyRotate,
  apiV1AudioSpeech,
  apiV1AudioTranscriptions,
  apiV1AudioTranslations,
  apiV1ChatCompletions,
  apiV1Completions,
  apiV1ContainersCreate,
  apiV1ContainersDelete,
  apiV1ContainersFileContent,
  apiV1ContainersFileDelete,
  apiV1ContainersFileGet,
  apiV1ContainersFileUpload,
  apiV1ContainersGet,
  apiV1ContainersList,
  apiV1ContainersListFiles,
  apiV1Embeddings,
  apiV1ImagesEdits,
  apiV1ImagesGenerations,
  apiV1ImagesVariations,
  apiV1Models,
  apiV1Responses,
  apiV1ResponsesCancel,
  apiV1ResponsesCompact,
  apiV1ResponsesDelete,
  apiV1ResponsesGet,
  apiV1VideosCharactersCreate,
  apiV1VideosCharactersRetrieve,
  apiV1VideosContent,
  apiV1VideosCreate,
  apiV1VideosDelete,
  apiV1VideosEdits,
  apiV1VideosExtensions,
  apiV1VideosList,
  apiV1VideosRemix,
  apiV1VideosRetrieve,
  auditLogGet,
  auditLogList,
  authDiscover,
  authMe,
  conversationAppendMessages,
  conversationCreate,
  conversationDelete,
  conversationGet,
  conversationListAccessibleForUser,
  conversationListByProject,
  conversationListByUser,
  conversationSetPin,
  conversationUpdate,
  dlqDelete,
  dlqGet,
  dlqList,
  dlqPrune,
  dlqPurge,
  dlqRetry,
  dlqStats,
  domainVerificationsCreate,
  domainVerificationsDelete,
  domainVerificationsGet,
  domainVerificationsGetInstructions,
  domainVerificationsList,
  domainVerificationsVerify,
  dynamicProviderCreate,
  dynamicProviderDelete,
  dynamicProviderGet,
  dynamicProviderListByOrg,
  dynamicProviderListByProject,
  dynamicProviderListByUser,
  dynamicProviderTest,
  dynamicProviderTestCredentials,
  dynamicProviderUpdate,
  fileDelete,
  fileGet,
  fileGetContent,
  fileList,
  fileUpload,
  getCircuitBreaker,
  getProviderHealth,
  getProviderStats,
  getProviderStatsHistory,
  healthCheck,
  healthLiveness,
  healthReadiness,
  listCircuitBreakers,
  listProviderHealth,
  listProviderStats,
  meApiKeysCreate,
  meApiKeysGet,
  meApiKeysList,
  meApiKeysRevoke,
  meApiKeysRotate,
  meBuiltInProvidersList,
  meDelete,
  meEligibleOwners,
  meExport,
  meProvidersCreate,
  meProvidersDelete,
  meProvidersGet,
  meProvidersList,
  meProvidersTest,
  meProvidersTestCredentials,
  meProvidersUpdate,
  meSessionsDeleteOne,
  meSessionsList,
  meUsageByDate,
  meUsageByDateModel,
  meUsageByDatePricingSource,
  meUsageByDateProvider,
  meUsageByModel,
  meUsageByPricingSource,
  meUsageByProvider,
  meUsageLogExport,
  meUsageLogList,
  meUsageSummary,
  modelPricingBulkUpsert,
  modelPricingCreate,
  modelPricingDelete,
  modelPricingGet,
  modelPricingListByOrg,
  modelPricingListByProject,
  modelPricingListByProvider,
  modelPricingListByUser,
  modelPricingListGlobal,
  modelPricingUpdate,
  modelPricingUpsert,
  oauthAuthorizationServerMetadata,
  oauthAuthorize,
  oauthPreflight,
  oauthToken,
  type Options,
  orgAccessReport,
  organizationCreate,
  organizationDelete,
  organizationGet,
  organizationList,
  organizationUpdate,
  orgMemberAdd,
  orgMemberList,
  orgMemberRemove,
  orgRbacPolicyCreate,
  orgRbacPolicyDelete,
  orgRbacPolicyGet,
  orgRbacPolicyList,
  orgRbacPolicyListVersions,
  orgRbacPolicyRollback,
  orgRbacPolicySimulate,
  orgRbacPolicyUpdate,
  orgRbacPolicyValidate,
  orgScimConfigCreate,
  orgScimConfigDelete,
  orgScimConfigGet,
  orgScimConfigRotateToken,
  orgScimConfigUpdate,
  orgSsoConfigCreate,
  orgSsoConfigDelete,
  orgSsoConfigGet,
  orgSsoConfigGetSpMetadata,
  orgSsoConfigParseSamlMetadata,
  orgSsoConfigUpdate,
  projectCreate,
  projectDelete,
  projectGet,
  projectList,
  projectMemberAdd,
  projectMemberList,
  projectMemberRemove,
  projectUpdate,
  serviceAccountCreate,
  serviceAccountDelete,
  serviceAccountGet,
  serviceAccountList,
  serviceAccountUpdate,
  sessionInfoGet,
  skillCreate,
  skillCreateVersion,
  skillDelete,
  skillDeleteVersion,
  skillGet,
  skillGetContent,
  skillGetVersion,
  skillGetVersionContent,
  skillList,
  skillListVersions,
  skillSetDefaultVersion,
  ssoConnectionGet,
  ssoConnectionsList,
  ssoGroupMappingCreate,
  ssoGroupMappingDelete,
  ssoGroupMappingExport,
  ssoGroupMappingGet,
  ssoGroupMappingImport,
  ssoGroupMappingList,
  ssoGroupMappingTest,
  ssoGroupMappingUpdate,
  staleAccessDetection,
  teamCreate,
  teamDelete,
  teamGet,
  teamList,
  teamMemberAdd,
  teamMemberList,
  teamMemberRemove,
  teamMemberUpdate,
  teamUpdate,
  templateCreate,
  templateDelete,
  templateGet,
  templateListByOrg,
  templateListByProject,
  templateListByTeam,
  templateListByUser,
  templateUpdate,
  usageGetByDate,
  usageGetByDateModel,
  usageGetByDatePricingSource,
  usageGetByDateProvider,
  usageGetByModel,
  usageGetByPricingSource,
  usageGetByProvider,
  usageGetByReferer,
  usageGetForecast,
  usageGetGlobalByDate,
  usageGetGlobalByDateModel,
  usageGetGlobalByDateOrg,
  usageGetGlobalByDatePricingSource,
  usageGetGlobalByDateProject,
  usageGetGlobalByDateProvider,
  usageGetGlobalByDateTeam,
  usageGetGlobalByDateUser,
  usageGetGlobalByModel,
  usageGetGlobalByOrg,
  usageGetGlobalByPricingSource,
  usageGetGlobalByProject,
  usageGetGlobalByProvider,
  usageGetGlobalByTeam,
  usageGetGlobalByUser,
  usageGetGlobalSummary,
  usageGetOrgByDate,
  usageGetOrgByDateModel,
  usageGetOrgByDatePricingSource,
  usageGetOrgByDateProject,
  usageGetOrgByDateProvider,
  usageGetOrgByDateTeam,
  usageGetOrgByDateUser,
  usageGetOrgByModel,
  usageGetOrgByPricingSource,
  usageGetOrgByProject,
  usageGetOrgByProvider,
  usageGetOrgByTeam,
  usageGetOrgByUser,
  usageGetOrgForecast,
  usageGetOrgSummary,
  usageGetProjectByDate,
  usageGetProjectByDateModel,
  usageGetProjectByDatePricingSource,
  usageGetProjectByDateProvider,
  usageGetProjectByDateUser,
  usageGetProjectByModel,
  usageGetProjectByPricingSource,
  usageGetProjectByProvider,
  usageGetProjectByUser,
  usageGetProjectForecast,
  usageGetProjectSummary,
  usageGetProviderByDate,
  usageGetProviderByModel,
  usageGetProviderForecast,
  usageGetProviderSummary,
  usageGetSummary,
  usageGetTeamByDate,
  usageGetTeamByDateModel,
  usageGetTeamByDatePricingSource,
  usageGetTeamByDateProject,
  usageGetTeamByDateProvider,
  usageGetTeamByDateUser,
  usageGetTeamByModel,
  usageGetTeamByPricingSource,
  usageGetTeamByProject,
  usageGetTeamByProvider,
  usageGetTeamByUser,
  usageGetTeamForecast,
  usageGetTeamSummary,
  usageGetUserByDate,
  usageGetUserByDateModel,
  usageGetUserByDatePricingSource,
  usageGetUserByDateProvider,
  usageGetUserByModel,
  usageGetUserByPricingSource,
  usageGetUserByProvider,
  usageGetUserForecast,
  usageGetUserSummary,
  usageLogExport,
  usageLogList,
  userAccessSummary,
  userCreate,
  userDelete,
  userExport,
  userGet,
  userList,
  userSessionsDeleteAll,
  userSessionsDeleteOne,
  userSessionsList,
  userUpdate,
  vectorStoreCreate,
  vectorStoreDelete,
  vectorStoreFileBatchCancel,
  vectorStoreFileBatchCreate,
  vectorStoreFileBatchGet,
  vectorStoreFileBatchListFiles,
  vectorStoreFileChunksList,
  vectorStoreFileCreate,
  vectorStoreFileDelete,
  vectorStoreFileGet,
  vectorStoreFileList,
  vectorStoreGet,
  vectorStoreList,
  vectorStoreModify,
  vectorStoreSearch,
  webFetch,
  webSearch,
} from "../sdk.gen";
import type {
  AccessReviewInventoryData,
  AccessReviewInventoryError,
  AccessReviewInventoryResponse,
  ApiKeyCreateData,
  ApiKeyCreateError,
  ApiKeyCreateResponse,
  ApiKeyListByOrgData,
  ApiKeyListByOrgError,
  ApiKeyListByOrgResponse,
  ApiKeyListByProjectData,
  ApiKeyListByProjectError,
  ApiKeyListByProjectResponse,
  ApiKeyListByServiceAccountData,
  ApiKeyListByServiceAccountError,
  ApiKeyListByServiceAccountResponse,
  ApiKeyListByUserData,
  ApiKeyListByUserError,
  ApiKeyListByUserResponse,
  ApiKeyRevokeData,
  ApiKeyRevokeError,
  ApiKeyRotateData,
  ApiKeyRotateError,
  ApiKeyRotateResponse,
  ApiV1AudioSpeechData,
  ApiV1AudioSpeechResponse,
  ApiV1AudioTranscriptionsData,
  ApiV1AudioTranscriptionsResponse,
  ApiV1AudioTranslationsData,
  ApiV1AudioTranslationsResponse,
  ApiV1ChatCompletionsData,
  ApiV1ChatCompletionsError,
  ApiV1CompletionsData,
  ApiV1CompletionsError,
  ApiV1ContainersCreateData,
  ApiV1ContainersCreateError,
  ApiV1ContainersDeleteData,
  ApiV1ContainersDeleteError,
  ApiV1ContainersDeleteResponse,
  ApiV1ContainersFileContentData,
  ApiV1ContainersFileContentError,
  ApiV1ContainersFileDeleteData,
  ApiV1ContainersFileDeleteError,
  ApiV1ContainersFileDeleteResponse,
  ApiV1ContainersFileGetData,
  ApiV1ContainersFileGetError,
  ApiV1ContainersFileUploadData,
  ApiV1ContainersFileUploadError,
  ApiV1ContainersGetData,
  ApiV1ContainersGetError,
  ApiV1ContainersListData,
  ApiV1ContainersListError,
  ApiV1ContainersListFilesData,
  ApiV1ContainersListFilesError,
  ApiV1EmbeddingsData,
  ApiV1EmbeddingsError,
  ApiV1ImagesEditsData,
  ApiV1ImagesEditsResponse,
  ApiV1ImagesGenerationsData,
  ApiV1ImagesGenerationsResponse,
  ApiV1ImagesVariationsData,
  ApiV1ImagesVariationsResponse,
  ApiV1ModelsData,
  ApiV1ModelsError,
  ApiV1ModelsResponse,
  ApiV1ResponsesCancelData,
  ApiV1ResponsesCancelError,
  ApiV1ResponsesCompactData,
  ApiV1ResponsesCompactError,
  ApiV1ResponsesData,
  ApiV1ResponsesDeleteData,
  ApiV1ResponsesDeleteError,
  ApiV1ResponsesError,
  ApiV1ResponsesGetData,
  ApiV1ResponsesGetError,
  ApiV1VideosCharactersCreateData,
  ApiV1VideosCharactersCreateResponse,
  ApiV1VideosCharactersRetrieveData,
  ApiV1VideosCharactersRetrieveResponse,
  ApiV1VideosContentData,
  ApiV1VideosCreateData,
  ApiV1VideosCreateResponse,
  ApiV1VideosDeleteData,
  ApiV1VideosDeleteResponse,
  ApiV1VideosEditsData,
  ApiV1VideosEditsResponse,
  ApiV1VideosExtensionsData,
  ApiV1VideosExtensionsResponse,
  ApiV1VideosListData,
  ApiV1VideosListResponse,
  ApiV1VideosRemixData,
  ApiV1VideosRemixResponse,
  ApiV1VideosRetrieveData,
  ApiV1VideosRetrieveResponse,
  AuditLogGetData,
  AuditLogGetError,
  AuditLogGetResponse,
  AuditLogListData,
  AuditLogListError,
  AuditLogListResponse2,
  AuthDiscoverData,
  AuthDiscoverError,
  AuthDiscoverResponse,
  AuthMeData,
  AuthMeError,
  AuthMeResponse,
  ConversationAppendMessagesData,
  ConversationAppendMessagesError,
  ConversationAppendMessagesResponse,
  ConversationCreateData,
  ConversationCreateError,
  ConversationCreateResponse,
  ConversationDeleteData,
  ConversationDeleteError,
  ConversationGetData,
  ConversationGetError,
  ConversationGetResponse,
  ConversationListAccessibleForUserData,
  ConversationListAccessibleForUserError,
  ConversationListAccessibleForUserResponse,
  ConversationListByProjectData,
  ConversationListByProjectError,
  ConversationListByProjectResponse,
  ConversationListByUserData,
  ConversationListByUserError,
  ConversationListByUserResponse,
  ConversationSetPinData,
  ConversationSetPinError,
  ConversationSetPinResponse,
  ConversationUpdateData,
  ConversationUpdateError,
  ConversationUpdateResponse,
  DlqDeleteData,
  DlqDeleteError,
  DlqGetData,
  DlqGetError,
  DlqGetResponse,
  DlqListData,
  DlqListError,
  DlqListResponse2,
  DlqPruneData,
  DlqPruneError,
  DlqPurgeData,
  DlqPurgeError,
  DlqRetryData,
  DlqRetryError,
  DlqRetryResponse2,
  DlqStatsData,
  DlqStatsError,
  DlqStatsResponse2,
  DomainVerificationsCreateData,
  DomainVerificationsCreateError,
  DomainVerificationsCreateResponse,
  DomainVerificationsDeleteData,
  DomainVerificationsDeleteError,
  DomainVerificationsGetData,
  DomainVerificationsGetError,
  DomainVerificationsGetInstructionsData,
  DomainVerificationsGetInstructionsError,
  DomainVerificationsGetInstructionsResponse,
  DomainVerificationsGetResponse,
  DomainVerificationsListData,
  DomainVerificationsListError,
  DomainVerificationsListResponse,
  DomainVerificationsVerifyData,
  DomainVerificationsVerifyError,
  DomainVerificationsVerifyResponse,
  DynamicProviderCreateData,
  DynamicProviderCreateError,
  DynamicProviderCreateResponse,
  DynamicProviderDeleteData,
  DynamicProviderDeleteError,
  DynamicProviderGetData,
  DynamicProviderGetError,
  DynamicProviderGetResponse,
  DynamicProviderListByOrgData,
  DynamicProviderListByOrgError,
  DynamicProviderListByOrgResponse,
  DynamicProviderListByProjectData,
  DynamicProviderListByProjectError,
  DynamicProviderListByProjectResponse,
  DynamicProviderListByUserData,
  DynamicProviderListByUserError,
  DynamicProviderListByUserResponse,
  DynamicProviderTestCredentialsData,
  DynamicProviderTestCredentialsError,
  DynamicProviderTestCredentialsResponse,
  DynamicProviderTestData,
  DynamicProviderTestError,
  DynamicProviderTestResponse,
  DynamicProviderUpdateData,
  DynamicProviderUpdateError,
  DynamicProviderUpdateResponse,
  FileDeleteData,
  FileDeleteError,
  FileDeleteResponse,
  FileGetContentData,
  FileGetContentError,
  FileGetContentResponse,
  FileGetData,
  FileGetError,
  FileGetResponse,
  FileListData,
  FileListError,
  FileListResponse2,
  FileUploadData,
  FileUploadError,
  FileUploadResponse,
  GetCircuitBreakerData,
  GetCircuitBreakerResponse,
  GetProviderHealthData,
  GetProviderHealthResponse,
  GetProviderStatsData,
  GetProviderStatsHistoryData,
  GetProviderStatsHistoryResponse,
  GetProviderStatsResponse,
  HealthCheckData,
  HealthCheckError,
  HealthCheckResponse,
  HealthLivenessData,
  HealthReadinessData,
  ListCircuitBreakersData,
  ListCircuitBreakersResponse,
  ListProviderHealthData,
  ListProviderHealthResponse,
  ListProviderStatsData,
  ListProviderStatsResponse,
  MeApiKeysCreateData,
  MeApiKeysCreateError,
  MeApiKeysCreateResponse,
  MeApiKeysGetData,
  MeApiKeysGetError,
  MeApiKeysGetResponse,
  MeApiKeysListData,
  MeApiKeysListError,
  MeApiKeysListResponse,
  MeApiKeysRevokeData,
  MeApiKeysRevokeError,
  MeApiKeysRotateData,
  MeApiKeysRotateError,
  MeApiKeysRotateResponse,
  MeBuiltInProvidersListData,
  MeBuiltInProvidersListResponse,
  MeDeleteData,
  MeDeleteError,
  MeDeleteResponse,
  MeEligibleOwnersData,
  MeEligibleOwnersError,
  MeEligibleOwnersResponse,
  MeExportData,
  MeExportError,
  MeExportResponse,
  MeProvidersCreateData,
  MeProvidersCreateError,
  MeProvidersCreateResponse,
  MeProvidersDeleteData,
  MeProvidersDeleteError,
  MeProvidersGetData,
  MeProvidersGetError,
  MeProvidersGetResponse,
  MeProvidersListData,
  MeProvidersListError,
  MeProvidersListResponse,
  MeProvidersTestCredentialsData,
  MeProvidersTestCredentialsError,
  MeProvidersTestCredentialsResponse,
  MeProvidersTestData,
  MeProvidersTestError,
  MeProvidersTestResponse,
  MeProvidersUpdateData,
  MeProvidersUpdateError,
  MeProvidersUpdateResponse,
  MeSessionsDeleteOneData,
  MeSessionsDeleteOneError,
  MeSessionsDeleteOneResponse,
  MeSessionsListData,
  MeSessionsListError,
  MeSessionsListResponse,
  MeUsageByDateData,
  MeUsageByDateError,
  MeUsageByDateModelData,
  MeUsageByDateModelResponse,
  MeUsageByDatePricingSourceData,
  MeUsageByDatePricingSourceResponse,
  MeUsageByDateProviderData,
  MeUsageByDateProviderResponse,
  MeUsageByDateResponse,
  MeUsageByModelData,
  MeUsageByModelError,
  MeUsageByModelResponse,
  MeUsageByPricingSourceData,
  MeUsageByPricingSourceResponse,
  MeUsageByProviderData,
  MeUsageByProviderError,
  MeUsageByProviderResponse,
  MeUsageLogExportData,
  MeUsageLogListData,
  MeUsageLogListResponse,
  MeUsageSummaryData,
  MeUsageSummaryError,
  MeUsageSummaryResponse,
  ModelPricingBulkUpsertData,
  ModelPricingBulkUpsertResponse,
  ModelPricingCreateData,
  ModelPricingCreateError,
  ModelPricingCreateResponse,
  ModelPricingDeleteData,
  ModelPricingDeleteError,
  ModelPricingGetData,
  ModelPricingGetError,
  ModelPricingGetResponse,
  ModelPricingListByOrgData,
  ModelPricingListByOrgError,
  ModelPricingListByOrgResponse,
  ModelPricingListByProjectData,
  ModelPricingListByProjectError,
  ModelPricingListByProjectResponse,
  ModelPricingListByProviderData,
  ModelPricingListByProviderError,
  ModelPricingListByProviderResponse,
  ModelPricingListByUserData,
  ModelPricingListByUserError,
  ModelPricingListByUserResponse,
  ModelPricingListGlobalData,
  ModelPricingListGlobalError,
  ModelPricingListGlobalResponse,
  ModelPricingUpdateData,
  ModelPricingUpdateError,
  ModelPricingUpdateResponse,
  ModelPricingUpsertData,
  ModelPricingUpsertResponse,
  OauthAuthorizationServerMetadataData,
  OauthAuthorizationServerMetadataError,
  OauthAuthorizationServerMetadataResponse,
  OauthAuthorizeData,
  OauthAuthorizeError,
  OauthAuthorizeResponse,
  OauthPreflightData,
  OauthPreflightError,
  OauthPreflightResponse,
  OauthTokenData,
  OauthTokenError,
  OauthTokenResponse,
  OrgAccessReportData,
  OrgAccessReportError,
  OrgAccessReportResponse2,
  OrganizationCreateData,
  OrganizationCreateError,
  OrganizationCreateResponse,
  OrganizationDeleteData,
  OrganizationDeleteError,
  OrganizationGetData,
  OrganizationGetError,
  OrganizationGetResponse,
  OrganizationListData,
  OrganizationListError,
  OrganizationListResponse2,
  OrganizationUpdateData,
  OrganizationUpdateError,
  OrganizationUpdateResponse,
  OrgMemberAddData,
  OrgMemberAddError,
  OrgMemberListData,
  OrgMemberListError,
  OrgMemberListResponse,
  OrgMemberRemoveData,
  OrgMemberRemoveError,
  OrgRbacPolicyCreateData,
  OrgRbacPolicyCreateError,
  OrgRbacPolicyCreateResponse,
  OrgRbacPolicyDeleteData,
  OrgRbacPolicyDeleteError,
  OrgRbacPolicyGetData,
  OrgRbacPolicyGetError,
  OrgRbacPolicyGetResponse,
  OrgRbacPolicyListData,
  OrgRbacPolicyListError,
  OrgRbacPolicyListResponse2,
  OrgRbacPolicyListVersionsData,
  OrgRbacPolicyListVersionsError,
  OrgRbacPolicyListVersionsResponse,
  OrgRbacPolicyRollbackData,
  OrgRbacPolicyRollbackError,
  OrgRbacPolicyRollbackResponse,
  OrgRbacPolicySimulateData,
  OrgRbacPolicySimulateError,
  OrgRbacPolicySimulateResponse,
  OrgRbacPolicyUpdateData,
  OrgRbacPolicyUpdateError,
  OrgRbacPolicyUpdateResponse,
  OrgRbacPolicyValidateData,
  OrgRbacPolicyValidateError,
  OrgRbacPolicyValidateResponse,
  OrgScimConfigCreateData,
  OrgScimConfigCreateError,
  OrgScimConfigCreateResponse,
  OrgScimConfigDeleteData,
  OrgScimConfigDeleteError,
  OrgScimConfigGetData,
  OrgScimConfigGetError,
  OrgScimConfigGetResponse,
  OrgScimConfigRotateTokenData,
  OrgScimConfigRotateTokenError,
  OrgScimConfigRotateTokenResponse,
  OrgScimConfigUpdateData,
  OrgScimConfigUpdateError,
  OrgScimConfigUpdateResponse,
  OrgSsoConfigCreateData,
  OrgSsoConfigCreateError,
  OrgSsoConfigCreateResponse,
  OrgSsoConfigDeleteData,
  OrgSsoConfigDeleteError,
  OrgSsoConfigGetData,
  OrgSsoConfigGetError,
  OrgSsoConfigGetResponse,
  OrgSsoConfigGetSpMetadataData,
  OrgSsoConfigGetSpMetadataError,
  OrgSsoConfigParseSamlMetadataData,
  OrgSsoConfigParseSamlMetadataError,
  OrgSsoConfigParseSamlMetadataResponse,
  OrgSsoConfigUpdateData,
  OrgSsoConfigUpdateError,
  OrgSsoConfigUpdateResponse,
  ProjectCreateData,
  ProjectCreateError,
  ProjectCreateResponse,
  ProjectDeleteData,
  ProjectDeleteError,
  ProjectGetData,
  ProjectGetError,
  ProjectGetResponse,
  ProjectListData,
  ProjectListError,
  ProjectListResponse2,
  ProjectMemberAddData,
  ProjectMemberAddError,
  ProjectMemberListData,
  ProjectMemberListError,
  ProjectMemberListResponse,
  ProjectMemberRemoveData,
  ProjectMemberRemoveError,
  ProjectUpdateData,
  ProjectUpdateError,
  ProjectUpdateResponse,
  ServiceAccountCreateData,
  ServiceAccountCreateError,
  ServiceAccountCreateResponse,
  ServiceAccountDeleteData,
  ServiceAccountDeleteError,
  ServiceAccountGetData,
  ServiceAccountGetError,
  ServiceAccountGetResponse,
  ServiceAccountListData,
  ServiceAccountListError,
  ServiceAccountListResponse2,
  ServiceAccountUpdateData,
  ServiceAccountUpdateError,
  ServiceAccountUpdateResponse,
  SessionInfoGetData,
  SessionInfoGetError,
  SessionInfoGetResponse,
  SkillCreateData,
  SkillCreateError,
  SkillCreateResponse,
  SkillCreateVersionData,
  SkillCreateVersionError,
  SkillCreateVersionResponse,
  SkillDeleteData,
  SkillDeleteError,
  SkillDeleteResponse,
  SkillDeleteVersionData,
  SkillDeleteVersionError,
  SkillDeleteVersionResponse,
  SkillGetContentData,
  SkillGetContentError,
  SkillGetContentResponse,
  SkillGetData,
  SkillGetError,
  SkillGetResponse,
  SkillGetVersionContentData,
  SkillGetVersionContentError,
  SkillGetVersionContentResponse,
  SkillGetVersionData,
  SkillGetVersionError,
  SkillGetVersionResponse,
  SkillListData,
  SkillListError,
  SkillListResponse,
  SkillListVersionsData,
  SkillListVersionsError,
  SkillListVersionsResponse,
  SkillSetDefaultVersionData,
  SkillSetDefaultVersionError,
  SkillSetDefaultVersionResponse,
  SsoConnectionGetData,
  SsoConnectionGetError,
  SsoConnectionGetResponse,
  SsoConnectionsListData,
  SsoConnectionsListError,
  SsoConnectionsListResponse,
  SsoGroupMappingCreateData,
  SsoGroupMappingCreateError,
  SsoGroupMappingCreateResponse,
  SsoGroupMappingDeleteData,
  SsoGroupMappingDeleteError,
  SsoGroupMappingExportData,
  SsoGroupMappingExportError,
  SsoGroupMappingGetData,
  SsoGroupMappingGetError,
  SsoGroupMappingGetResponse,
  SsoGroupMappingImportData,
  SsoGroupMappingImportError,
  SsoGroupMappingImportResponse,
  SsoGroupMappingListData,
  SsoGroupMappingListError,
  SsoGroupMappingListResponse2,
  SsoGroupMappingTestData,
  SsoGroupMappingTestError,
  SsoGroupMappingTestResponse,
  SsoGroupMappingUpdateData,
  SsoGroupMappingUpdateError,
  SsoGroupMappingUpdateResponse,
  StaleAccessDetectionData,
  StaleAccessDetectionError,
  StaleAccessDetectionResponse,
  TeamCreateData,
  TeamCreateError,
  TeamCreateResponse,
  TeamDeleteData,
  TeamDeleteError,
  TeamGetData,
  TeamGetError,
  TeamGetResponse,
  TeamListData,
  TeamListError,
  TeamListResponse2,
  TeamMemberAddData,
  TeamMemberAddError,
  TeamMemberAddResponse,
  TeamMemberListData,
  TeamMemberListError,
  TeamMemberListResponse2,
  TeamMemberRemoveData,
  TeamMemberRemoveError,
  TeamMemberUpdateData,
  TeamMemberUpdateError,
  TeamMemberUpdateResponse,
  TeamUpdateData,
  TeamUpdateError,
  TeamUpdateResponse,
  TemplateCreateData,
  TemplateCreateError,
  TemplateCreateResponse,
  TemplateDeleteData,
  TemplateDeleteError,
  TemplateGetData,
  TemplateGetError,
  TemplateGetResponse,
  TemplateListByOrgData,
  TemplateListByOrgError,
  TemplateListByOrgResponse,
  TemplateListByProjectData,
  TemplateListByProjectError,
  TemplateListByProjectResponse,
  TemplateListByTeamData,
  TemplateListByTeamError,
  TemplateListByTeamResponse,
  TemplateListByUserData,
  TemplateListByUserError,
  TemplateListByUserResponse,
  TemplateUpdateData,
  TemplateUpdateError,
  TemplateUpdateResponse,
  UsageGetByDateData,
  UsageGetByDateError,
  UsageGetByDateModelData,
  UsageGetByDateModelResponse,
  UsageGetByDatePricingSourceData,
  UsageGetByDatePricingSourceResponse,
  UsageGetByDateProviderData,
  UsageGetByDateProviderResponse,
  UsageGetByDateResponse,
  UsageGetByModelData,
  UsageGetByModelError,
  UsageGetByModelResponse,
  UsageGetByPricingSourceData,
  UsageGetByPricingSourceResponse,
  UsageGetByProviderData,
  UsageGetByProviderError,
  UsageGetByProviderResponse,
  UsageGetByRefererData,
  UsageGetByRefererError,
  UsageGetByRefererResponse,
  UsageGetForecastData,
  UsageGetForecastError,
  UsageGetForecastResponse,
  UsageGetGlobalByDateData,
  UsageGetGlobalByDateModelData,
  UsageGetGlobalByDateModelResponse,
  UsageGetGlobalByDateOrgData,
  UsageGetGlobalByDateOrgResponse,
  UsageGetGlobalByDatePricingSourceData,
  UsageGetGlobalByDatePricingSourceResponse,
  UsageGetGlobalByDateProjectData,
  UsageGetGlobalByDateProjectResponse,
  UsageGetGlobalByDateProviderData,
  UsageGetGlobalByDateProviderResponse,
  UsageGetGlobalByDateResponse,
  UsageGetGlobalByDateTeamData,
  UsageGetGlobalByDateTeamResponse,
  UsageGetGlobalByDateUserData,
  UsageGetGlobalByDateUserResponse,
  UsageGetGlobalByModelData,
  UsageGetGlobalByModelResponse,
  UsageGetGlobalByOrgData,
  UsageGetGlobalByOrgResponse,
  UsageGetGlobalByPricingSourceData,
  UsageGetGlobalByPricingSourceResponse,
  UsageGetGlobalByProjectData,
  UsageGetGlobalByProjectResponse,
  UsageGetGlobalByProviderData,
  UsageGetGlobalByProviderResponse,
  UsageGetGlobalByTeamData,
  UsageGetGlobalByTeamResponse,
  UsageGetGlobalByUserData,
  UsageGetGlobalByUserResponse,
  UsageGetGlobalSummaryData,
  UsageGetGlobalSummaryResponse,
  UsageGetOrgByDateData,
  UsageGetOrgByDateError,
  UsageGetOrgByDateModelData,
  UsageGetOrgByDateModelResponse,
  UsageGetOrgByDatePricingSourceData,
  UsageGetOrgByDatePricingSourceResponse,
  UsageGetOrgByDateProjectData,
  UsageGetOrgByDateProjectError,
  UsageGetOrgByDateProjectResponse,
  UsageGetOrgByDateProviderData,
  UsageGetOrgByDateProviderResponse,
  UsageGetOrgByDateResponse,
  UsageGetOrgByDateTeamData,
  UsageGetOrgByDateTeamError,
  UsageGetOrgByDateTeamResponse,
  UsageGetOrgByDateUserData,
  UsageGetOrgByDateUserError,
  UsageGetOrgByDateUserResponse,
  UsageGetOrgByModelData,
  UsageGetOrgByModelError,
  UsageGetOrgByModelResponse,
  UsageGetOrgByPricingSourceData,
  UsageGetOrgByPricingSourceResponse,
  UsageGetOrgByProjectData,
  UsageGetOrgByProjectError,
  UsageGetOrgByProjectResponse,
  UsageGetOrgByProviderData,
  UsageGetOrgByProviderError,
  UsageGetOrgByProviderResponse,
  UsageGetOrgByTeamData,
  UsageGetOrgByTeamError,
  UsageGetOrgByTeamResponse,
  UsageGetOrgByUserData,
  UsageGetOrgByUserError,
  UsageGetOrgByUserResponse,
  UsageGetOrgForecastData,
  UsageGetOrgForecastError,
  UsageGetOrgForecastResponse,
  UsageGetOrgSummaryData,
  UsageGetOrgSummaryError,
  UsageGetOrgSummaryResponse,
  UsageGetProjectByDateData,
  UsageGetProjectByDateError,
  UsageGetProjectByDateModelData,
  UsageGetProjectByDateModelResponse,
  UsageGetProjectByDatePricingSourceData,
  UsageGetProjectByDatePricingSourceResponse,
  UsageGetProjectByDateProviderData,
  UsageGetProjectByDateProviderResponse,
  UsageGetProjectByDateResponse,
  UsageGetProjectByDateUserData,
  UsageGetProjectByDateUserError,
  UsageGetProjectByDateUserResponse,
  UsageGetProjectByModelData,
  UsageGetProjectByModelError,
  UsageGetProjectByModelResponse,
  UsageGetProjectByPricingSourceData,
  UsageGetProjectByPricingSourceResponse,
  UsageGetProjectByProviderData,
  UsageGetProjectByProviderError,
  UsageGetProjectByProviderResponse,
  UsageGetProjectByUserData,
  UsageGetProjectByUserError,
  UsageGetProjectByUserResponse,
  UsageGetProjectForecastData,
  UsageGetProjectForecastError,
  UsageGetProjectForecastResponse,
  UsageGetProjectSummaryData,
  UsageGetProjectSummaryError,
  UsageGetProjectSummaryResponse,
  UsageGetProviderByDateData,
  UsageGetProviderByDateResponse,
  UsageGetProviderByModelData,
  UsageGetProviderByModelResponse,
  UsageGetProviderForecastData,
  UsageGetProviderForecastResponse,
  UsageGetProviderSummaryData,
  UsageGetProviderSummaryResponse,
  UsageGetSummaryData,
  UsageGetSummaryError,
  UsageGetSummaryResponse,
  UsageGetTeamByDateData,
  UsageGetTeamByDateError,
  UsageGetTeamByDateModelData,
  UsageGetTeamByDateModelResponse,
  UsageGetTeamByDatePricingSourceData,
  UsageGetTeamByDatePricingSourceResponse,
  UsageGetTeamByDateProjectData,
  UsageGetTeamByDateProjectError,
  UsageGetTeamByDateProjectResponse,
  UsageGetTeamByDateProviderData,
  UsageGetTeamByDateProviderResponse,
  UsageGetTeamByDateResponse,
  UsageGetTeamByDateUserData,
  UsageGetTeamByDateUserError,
  UsageGetTeamByDateUserResponse,
  UsageGetTeamByModelData,
  UsageGetTeamByModelError,
  UsageGetTeamByModelResponse,
  UsageGetTeamByPricingSourceData,
  UsageGetTeamByPricingSourceResponse,
  UsageGetTeamByProjectData,
  UsageGetTeamByProjectError,
  UsageGetTeamByProjectResponse,
  UsageGetTeamByProviderData,
  UsageGetTeamByProviderError,
  UsageGetTeamByProviderResponse,
  UsageGetTeamByUserData,
  UsageGetTeamByUserError,
  UsageGetTeamByUserResponse,
  UsageGetTeamForecastData,
  UsageGetTeamForecastError,
  UsageGetTeamForecastResponse,
  UsageGetTeamSummaryData,
  UsageGetTeamSummaryError,
  UsageGetTeamSummaryResponse,
  UsageGetUserByDateData,
  UsageGetUserByDateError,
  UsageGetUserByDateModelData,
  UsageGetUserByDateModelResponse,
  UsageGetUserByDatePricingSourceData,
  UsageGetUserByDatePricingSourceResponse,
  UsageGetUserByDateProviderData,
  UsageGetUserByDateProviderResponse,
  UsageGetUserByDateResponse,
  UsageGetUserByModelData,
  UsageGetUserByModelError,
  UsageGetUserByModelResponse,
  UsageGetUserByPricingSourceData,
  UsageGetUserByPricingSourceResponse,
  UsageGetUserByProviderData,
  UsageGetUserByProviderError,
  UsageGetUserByProviderResponse,
  UsageGetUserForecastData,
  UsageGetUserForecastError,
  UsageGetUserForecastResponse,
  UsageGetUserSummaryData,
  UsageGetUserSummaryError,
  UsageGetUserSummaryResponse,
  UsageLogExportData,
  UsageLogListData,
  UsageLogListResponse2,
  UserAccessSummaryData,
  UserAccessSummaryError,
  UserAccessSummaryResponse2,
  UserCreateData,
  UserCreateError,
  UserCreateResponse,
  UserDeleteData,
  UserDeleteError,
  UserDeleteResponse,
  UserExportData,
  UserExportError,
  UserExportResponse,
  UserGetData,
  UserGetError,
  UserGetResponse,
  UserListData,
  UserListError,
  UserListResponse2,
  UserSessionsDeleteAllData,
  UserSessionsDeleteAllError,
  UserSessionsDeleteAllResponse,
  UserSessionsDeleteOneData,
  UserSessionsDeleteOneError,
  UserSessionsDeleteOneResponse,
  UserSessionsListData,
  UserSessionsListError,
  UserSessionsListResponse,
  UserUpdateData,
  UserUpdateError,
  UserUpdateResponse,
  VectorStoreCreateData,
  VectorStoreCreateError,
  VectorStoreCreateResponse,
  VectorStoreDeleteData,
  VectorStoreDeleteError,
  VectorStoreDeleteResponse,
  VectorStoreFileBatchCancelData,
  VectorStoreFileBatchCancelError,
  VectorStoreFileBatchCreateData,
  VectorStoreFileBatchCreateError,
  VectorStoreFileBatchCreateResponse,
  VectorStoreFileBatchGetData,
  VectorStoreFileBatchGetError,
  VectorStoreFileBatchListFilesData,
  VectorStoreFileBatchListFilesError,
  VectorStoreFileChunksListData,
  VectorStoreFileChunksListError,
  VectorStoreFileChunksListResponse,
  VectorStoreFileCreateData,
  VectorStoreFileCreateError,
  VectorStoreFileCreateResponse,
  VectorStoreFileDeleteData,
  VectorStoreFileDeleteError,
  VectorStoreFileDeleteResponse,
  VectorStoreFileGetData,
  VectorStoreFileGetError,
  VectorStoreFileGetResponse,
  VectorStoreFileListData,
  VectorStoreFileListError,
  VectorStoreFileListResponse2,
  VectorStoreGetData,
  VectorStoreGetError,
  VectorStoreGetResponse,
  VectorStoreListData,
  VectorStoreListError,
  VectorStoreListResponse2,
  VectorStoreModifyData,
  VectorStoreModifyError,
  VectorStoreModifyResponse,
  VectorStoreSearchData,
  VectorStoreSearchError,
  VectorStoreSearchResponse2,
  WebFetchData,
  WebFetchResponse2,
  WebSearchData,
  WebSearchResponse2,
} from "../types.gen";

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const oauthAuthorizationServerMetadataQueryKey = (
  options?: Options<OauthAuthorizationServerMetadataData>
) => createQueryKey("oauthAuthorizationServerMetadata", options);

/**
 * Serve the OAuth 2.0 Authorization Server Metadata document.
 */
export const oauthAuthorizationServerMetadataOptions = (
  options?: Options<OauthAuthorizationServerMetadataData>
) =>
  queryOptions<
    OauthAuthorizationServerMetadataResponse,
    OauthAuthorizationServerMetadataError,
    OauthAuthorizationServerMetadataResponse,
    ReturnType<typeof oauthAuthorizationServerMetadataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await oauthAuthorizationServerMetadata({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: oauthAuthorizationServerMetadataQueryKey(options),
  });

export const accessReviewInventoryQueryKey = (options?: Options<AccessReviewInventoryData>) =>
  createQueryKey("accessReviewInventory", options);

/**
 * Get access inventory for compliance reviews
 *
 * Returns a comprehensive view of all users and their access rights across
 * organizations and projects. This endpoint supports compliance requirements
 * for access reviews (SOC 2, ISO 27001).
 *
 * The response includes:
 * - User details (id, email, name, external_id)
 * - Organization memberships with roles and grant dates
 * - Project memberships with roles and grant dates
 * - API key summary (active, revoked, expired counts)
 * - Last activity timestamp
 * - Summary statistics
 *
 * Use `format=csv` for CSV export suitable for auditors and spreadsheets.
 */
export const accessReviewInventoryOptions = (options?: Options<AccessReviewInventoryData>) =>
  queryOptions<
    AccessReviewInventoryResponse,
    AccessReviewInventoryError,
    AccessReviewInventoryResponse,
    ReturnType<typeof accessReviewInventoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accessReviewInventory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: accessReviewInventoryQueryKey(options),
  });

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const accessReviewInventoryInfiniteQueryKey = (
  options?: Options<AccessReviewInventoryData>
): QueryKey<Options<AccessReviewInventoryData>> =>
  createQueryKey("accessReviewInventory", options, true);

/**
 * Get access inventory for compliance reviews
 *
 * Returns a comprehensive view of all users and their access rights across
 * organizations and projects. This endpoint supports compliance requirements
 * for access reviews (SOC 2, ISO 27001).
 *
 * The response includes:
 * - User details (id, email, name, external_id)
 * - Organization memberships with roles and grant dates
 * - Project memberships with roles and grant dates
 * - API key summary (active, revoked, expired counts)
 * - Last activity timestamp
 * - Summary statistics
 *
 * Use `format=csv` for CSV export suitable for auditors and spreadsheets.
 */
export const accessReviewInventoryInfiniteOptions = (
  options?: Options<AccessReviewInventoryData>
) =>
  infiniteQueryOptions<
    AccessReviewInventoryResponse,
    AccessReviewInventoryError,
    InfiniteData<AccessReviewInventoryResponse>,
    QueryKey<Options<AccessReviewInventoryData>>,
    | number
    | Pick<QueryKey<Options<AccessReviewInventoryData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AccessReviewInventoryData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await accessReviewInventory({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: accessReviewInventoryInfiniteQueryKey(options),
    }
  );

export const staleAccessDetectionQueryKey = (options?: Options<StaleAccessDetectionData>) =>
  createQueryKey("staleAccessDetection", options);

/**
 * Detect stale access across the system
 *
 * Identifies users and API keys that haven't been active for a configurable
 * number of days. This helps identify:
 * - Users who haven't logged in or performed any actions
 * - API keys that haven't been used
 * - Users with access but no recorded activity
 *
 * This endpoint supports compliance requirements for periodic access reviews
 * (SOC 2, ISO 27001) by identifying potentially orphaned or unused access.
 *
 * Use `format=csv` for CSV export suitable for auditors and spreadsheets.
 */
export const staleAccessDetectionOptions = (options?: Options<StaleAccessDetectionData>) =>
  queryOptions<
    StaleAccessDetectionResponse,
    StaleAccessDetectionError,
    StaleAccessDetectionResponse,
    ReturnType<typeof staleAccessDetectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await staleAccessDetection({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: staleAccessDetectionQueryKey(options),
  });

/**
 * Create an API key
 *
 * Creates a new API key scoped to an organization, project, or user. The raw API key value
 * is returned only once in this response and cannot be retrieved later. Store it securely.
 */
export const apiKeyCreateMutation = (
  options?: Partial<Options<ApiKeyCreateData>>
): UseMutationOptions<ApiKeyCreateResponse, ApiKeyCreateError, Options<ApiKeyCreateData>> => {
  const mutationOptions: UseMutationOptions<
    ApiKeyCreateResponse,
    ApiKeyCreateError,
    Options<ApiKeyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiKeyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revoke an API key
 */
export const apiKeyRevokeMutation = (
  options?: Partial<Options<ApiKeyRevokeData>>
): UseMutationOptions<unknown, ApiKeyRevokeError, Options<ApiKeyRevokeData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiKeyRevokeError,
    Options<ApiKeyRevokeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiKeyRevoke({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Rotate an API key
 *
 * Creates a new API key with the same settings as the old key and sets a grace period
 * on the old key. During the grace period, both keys are valid. After the grace period
 * expires, only the new key works.
 *
 * The raw API key value for the new key is returned only once in this response.
 */
export const apiKeyRotateMutation = (
  options?: Partial<Options<ApiKeyRotateData>>
): UseMutationOptions<ApiKeyRotateResponse, ApiKeyRotateError, Options<ApiKeyRotateData>> => {
  const mutationOptions: UseMutationOptions<
    ApiKeyRotateResponse,
    ApiKeyRotateError,
    Options<ApiKeyRotateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiKeyRotate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const usageGetSummaryQueryKey = (options: Options<UsageGetSummaryData>) =>
  createQueryKey("usageGetSummary", options);

/**
 * Get usage summary for an API key
 */
export const usageGetSummaryOptions = (options: Options<UsageGetSummaryData>) =>
  queryOptions<
    UsageGetSummaryResponse,
    UsageGetSummaryError,
    UsageGetSummaryResponse,
    ReturnType<typeof usageGetSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetSummaryQueryKey(options),
  });

export const usageGetByDateQueryKey = (options: Options<UsageGetByDateData>) =>
  createQueryKey("usageGetByDate", options);

/**
 * Get usage by date for an API key
 */
export const usageGetByDateOptions = (options: Options<UsageGetByDateData>) =>
  queryOptions<
    UsageGetByDateResponse,
    UsageGetByDateError,
    UsageGetByDateResponse,
    ReturnType<typeof usageGetByDateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetByDate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetByDateQueryKey(options),
  });

export const usageGetByDateModelQueryKey = (options: Options<UsageGetByDateModelData>) =>
  createQueryKey("usageGetByDateModel", options);

/**
 * Get usage by date and model for an API key
 */
export const usageGetByDateModelOptions = (options: Options<UsageGetByDateModelData>) =>
  queryOptions<
    UsageGetByDateModelResponse,
    DefaultError,
    UsageGetByDateModelResponse,
    ReturnType<typeof usageGetByDateModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetByDateModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetByDateModelQueryKey(options),
  });

export const usageGetByDatePricingSourceQueryKey = (
  options: Options<UsageGetByDatePricingSourceData>
) => createQueryKey("usageGetByDatePricingSource", options);

/**
 * Get usage by date and pricing source for an API key
 */
export const usageGetByDatePricingSourceOptions = (
  options: Options<UsageGetByDatePricingSourceData>
) =>
  queryOptions<
    UsageGetByDatePricingSourceResponse,
    DefaultError,
    UsageGetByDatePricingSourceResponse,
    ReturnType<typeof usageGetByDatePricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetByDatePricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetByDatePricingSourceQueryKey(options),
  });

export const usageGetByDateProviderQueryKey = (options: Options<UsageGetByDateProviderData>) =>
  createQueryKey("usageGetByDateProvider", options);

/**
 * Get usage by date and provider for an API key
 */
export const usageGetByDateProviderOptions = (options: Options<UsageGetByDateProviderData>) =>
  queryOptions<
    UsageGetByDateProviderResponse,
    DefaultError,
    UsageGetByDateProviderResponse,
    ReturnType<typeof usageGetByDateProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetByDateProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetByDateProviderQueryKey(options),
  });

export const usageGetByModelQueryKey = (options: Options<UsageGetByModelData>) =>
  createQueryKey("usageGetByModel", options);

/**
 * Get usage by model for an API key
 */
export const usageGetByModelOptions = (options: Options<UsageGetByModelData>) =>
  queryOptions<
    UsageGetByModelResponse,
    UsageGetByModelError,
    UsageGetByModelResponse,
    ReturnType<typeof usageGetByModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetByModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetByModelQueryKey(options),
  });

export const usageGetByPricingSourceQueryKey = (options: Options<UsageGetByPricingSourceData>) =>
  createQueryKey("usageGetByPricingSource", options);

/**
 * Get usage by pricing source for an API key
 */
export const usageGetByPricingSourceOptions = (options: Options<UsageGetByPricingSourceData>) =>
  queryOptions<
    UsageGetByPricingSourceResponse,
    DefaultError,
    UsageGetByPricingSourceResponse,
    ReturnType<typeof usageGetByPricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetByPricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetByPricingSourceQueryKey(options),
  });

export const usageGetByProviderQueryKey = (options: Options<UsageGetByProviderData>) =>
  createQueryKey("usageGetByProvider", options);

/**
 * Get usage by provider for an API key
 */
export const usageGetByProviderOptions = (options: Options<UsageGetByProviderData>) =>
  queryOptions<
    UsageGetByProviderResponse,
    UsageGetByProviderError,
    UsageGetByProviderResponse,
    ReturnType<typeof usageGetByProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetByProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetByProviderQueryKey(options),
  });

export const usageGetByRefererQueryKey = (options: Options<UsageGetByRefererData>) =>
  createQueryKey("usageGetByReferer", options);

/**
 * Get usage by referer for an API key
 */
export const usageGetByRefererOptions = (options: Options<UsageGetByRefererData>) =>
  queryOptions<
    UsageGetByRefererResponse,
    UsageGetByRefererError,
    UsageGetByRefererResponse,
    ReturnType<typeof usageGetByRefererQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetByReferer({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetByRefererQueryKey(options),
  });

export const usageGetForecastQueryKey = (options: Options<UsageGetForecastData>) =>
  createQueryKey("usageGetForecast", options);

/**
 * Get cost forecast for an API key
 *
 * Uses historical usage data to predict when the budget will be exhausted.
 * Returns average daily spend, projected exhaustion date, and confidence intervals.
 */
export const usageGetForecastOptions = (options: Options<UsageGetForecastData>) =>
  queryOptions<
    UsageGetForecastResponse,
    UsageGetForecastError,
    UsageGetForecastResponse,
    ReturnType<typeof usageGetForecastQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetForecast({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetForecastQueryKey(options),
  });

export const auditLogListQueryKey = (options?: Options<AuditLogListData>) =>
  createQueryKey("auditLogList", options);

/**
 * List audit logs
 *
 * When neither `from` nor `to` is supplied, results default to the last
 * 7 days (the audit log is append-only and an unbounded scan would hit
 * the entire table). Pass an explicit `from` for older entries.
 */
export const auditLogListOptions = (options?: Options<AuditLogListData>) =>
  queryOptions<
    AuditLogListResponse2,
    AuditLogListError,
    AuditLogListResponse2,
    ReturnType<typeof auditLogListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await auditLogList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: auditLogListQueryKey(options),
  });

export const auditLogListInfiniteQueryKey = (
  options?: Options<AuditLogListData>
): QueryKey<Options<AuditLogListData>> => createQueryKey("auditLogList", options, true);

/**
 * List audit logs
 *
 * When neither `from` nor `to` is supplied, results default to the last
 * 7 days (the audit log is append-only and an unbounded scan would hit
 * the entire table). Pass an explicit `from` for older entries.
 */
export const auditLogListInfiniteOptions = (options?: Options<AuditLogListData>) =>
  infiniteQueryOptions<
    AuditLogListResponse2,
    AuditLogListError,
    InfiniteData<AuditLogListResponse2>,
    QueryKey<Options<AuditLogListData>>,
    | string
    | null
    | Pick<QueryKey<Options<AuditLogListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AuditLogListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await auditLogList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: auditLogListInfiniteQueryKey(options),
    }
  );

export const auditLogGetQueryKey = (options: Options<AuditLogGetData>) =>
  createQueryKey("auditLogGet", options);

/**
 * Get an audit log entry by ID
 */
export const auditLogGetOptions = (options: Options<AuditLogGetData>) =>
  queryOptions<
    AuditLogGetResponse,
    AuditLogGetError,
    AuditLogGetResponse,
    ReturnType<typeof auditLogGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await auditLogGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: auditLogGetQueryKey(options),
  });

/**
 * Create a new conversation
 */
export const conversationCreateMutation = (
  options?: Partial<Options<ConversationCreateData>>
): UseMutationOptions<
  ConversationCreateResponse,
  ConversationCreateError,
  Options<ConversationCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ConversationCreateResponse,
    ConversationCreateError,
    Options<ConversationCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await conversationCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a conversation
 */
export const conversationDeleteMutation = (
  options?: Partial<Options<ConversationDeleteData>>
): UseMutationOptions<unknown, ConversationDeleteError, Options<ConversationDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ConversationDeleteError,
    Options<ConversationDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await conversationDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const conversationGetQueryKey = (options: Options<ConversationGetData>) =>
  createQueryKey("conversationGet", options);

/**
 * Get a conversation by ID
 */
export const conversationGetOptions = (options: Options<ConversationGetData>) =>
  queryOptions<
    ConversationGetResponse,
    ConversationGetError,
    ConversationGetResponse,
    ReturnType<typeof conversationGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await conversationGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: conversationGetQueryKey(options),
  });

/**
 * Update a conversation
 *
 * Can also be used to move a conversation to a different project or user by providing the `owner` field.
 */
export const conversationUpdateMutation = (
  options?: Partial<Options<ConversationUpdateData>>
): UseMutationOptions<
  ConversationUpdateResponse,
  ConversationUpdateError,
  Options<ConversationUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ConversationUpdateResponse,
    ConversationUpdateError,
    Options<ConversationUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await conversationUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Append messages to a conversation
 */
export const conversationAppendMessagesMutation = (
  options?: Partial<Options<ConversationAppendMessagesData>>
): UseMutationOptions<
  ConversationAppendMessagesResponse,
  ConversationAppendMessagesError,
  Options<ConversationAppendMessagesData>
> => {
  const mutationOptions: UseMutationOptions<
    ConversationAppendMessagesResponse,
    ConversationAppendMessagesError,
    Options<ConversationAppendMessagesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await conversationAppendMessages({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set pin order for a conversation
 *
 * Set `pin_order` to a number to pin the conversation (0 = first, higher = lower in list).
 * Set `pin_order` to null to unpin the conversation.
 */
export const conversationSetPinMutation = (
  options?: Partial<Options<ConversationSetPinData>>
): UseMutationOptions<
  ConversationSetPinResponse,
  ConversationSetPinError,
  Options<ConversationSetPinData>
> => {
  const mutationOptions: UseMutationOptions<
    ConversationSetPinResponse,
    ConversationSetPinError,
    Options<ConversationSetPinData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await conversationSetPin({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Purge all DLQ entries.
 */
export const dlqPurgeMutation = (
  options?: Partial<Options<DlqPurgeData>>
): UseMutationOptions<unknown, DlqPurgeError, Options<DlqPurgeData>> => {
  const mutationOptions: UseMutationOptions<unknown, DlqPurgeError, Options<DlqPurgeData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await dlqPurge({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const dlqListQueryKey = (options?: Options<DlqListData>) =>
  createQueryKey("dlqList", options);

/**
 * List DLQ entries.
 */
export const dlqListOptions = (options?: Options<DlqListData>) =>
  queryOptions<
    DlqListResponse2,
    DlqListError,
    DlqListResponse2,
    ReturnType<typeof dlqListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dlqList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: dlqListQueryKey(options),
  });

export const dlqListInfiniteQueryKey = (
  options?: Options<DlqListData>
): QueryKey<Options<DlqListData>> => createQueryKey("dlqList", options, true);

/**
 * List DLQ entries.
 */
export const dlqListInfiniteOptions = (options?: Options<DlqListData>) =>
  infiniteQueryOptions<
    DlqListResponse2,
    DlqListError,
    InfiniteData<DlqListResponse2>,
    QueryKey<Options<DlqListData>>,
    string | null | Pick<QueryKey<Options<DlqListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<DlqListData>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await dlqList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: dlqListInfiniteQueryKey(options),
    }
  );

export const dlqPruneMutation = (
  options?: Partial<Options<DlqPruneData>>
): UseMutationOptions<unknown, DlqPruneError, Options<DlqPruneData>> => {
  const mutationOptions: UseMutationOptions<unknown, DlqPruneError, Options<DlqPruneData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await dlqPrune({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const dlqStatsQueryKey = (options?: Options<DlqStatsData>) =>
  createQueryKey("dlqStats", options);

/**
 * Get DLQ statistics.
 */
export const dlqStatsOptions = (options?: Options<DlqStatsData>) =>
  queryOptions<
    DlqStatsResponse2,
    DlqStatsError,
    DlqStatsResponse2,
    ReturnType<typeof dlqStatsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dlqStats({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: dlqStatsQueryKey(options),
  });

/**
 * Delete a DLQ entry.
 */
export const dlqDeleteMutation = (
  options?: Partial<Options<DlqDeleteData>>
): UseMutationOptions<unknown, DlqDeleteError, Options<DlqDeleteData>> => {
  const mutationOptions: UseMutationOptions<unknown, DlqDeleteError, Options<DlqDeleteData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await dlqDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const dlqGetQueryKey = (options: Options<DlqGetData>) => createQueryKey("dlqGet", options);

/**
 * Get a specific DLQ entry by ID.
 */
export const dlqGetOptions = (options: Options<DlqGetData>) =>
  queryOptions<DlqGetResponse, DlqGetError, DlqGetResponse, ReturnType<typeof dlqGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dlqGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: dlqGetQueryKey(options),
  });

/**
 * Retry a specific DLQ entry.
 */
export const dlqRetryMutation = (
  options?: Partial<Options<DlqRetryData>>
): UseMutationOptions<DlqRetryResponse2, DlqRetryError, Options<DlqRetryData>> => {
  const mutationOptions: UseMutationOptions<
    DlqRetryResponse2,
    DlqRetryError,
    Options<DlqRetryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dlqRetry({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a dynamic provider
 */
export const dynamicProviderCreateMutation = (
  options?: Partial<Options<DynamicProviderCreateData>>
): UseMutationOptions<
  DynamicProviderCreateResponse,
  DynamicProviderCreateError,
  Options<DynamicProviderCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    DynamicProviderCreateResponse,
    DynamicProviderCreateError,
    Options<DynamicProviderCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dynamicProviderCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Test credentials before creating a dynamic provider
 *
 * Accepts the same body as the create endpoint but does not persist anything.
 * Useful for validating API keys and endpoints before committing.
 */
export const dynamicProviderTestCredentialsMutation = (
  options?: Partial<Options<DynamicProviderTestCredentialsData>>
): UseMutationOptions<
  DynamicProviderTestCredentialsResponse,
  DynamicProviderTestCredentialsError,
  Options<DynamicProviderTestCredentialsData>
> => {
  const mutationOptions: UseMutationOptions<
    DynamicProviderTestCredentialsResponse,
    DynamicProviderTestCredentialsError,
    Options<DynamicProviderTestCredentialsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dynamicProviderTestCredentials({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a dynamic provider
 */
export const dynamicProviderDeleteMutation = (
  options?: Partial<Options<DynamicProviderDeleteData>>
): UseMutationOptions<unknown, DynamicProviderDeleteError, Options<DynamicProviderDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DynamicProviderDeleteError,
    Options<DynamicProviderDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dynamicProviderDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const dynamicProviderGetQueryKey = (options: Options<DynamicProviderGetData>) =>
  createQueryKey("dynamicProviderGet", options);

/**
 * Get a dynamic provider by ID
 */
export const dynamicProviderGetOptions = (options: Options<DynamicProviderGetData>) =>
  queryOptions<
    DynamicProviderGetResponse,
    DynamicProviderGetError,
    DynamicProviderGetResponse,
    ReturnType<typeof dynamicProviderGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dynamicProviderGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: dynamicProviderGetQueryKey(options),
  });

/**
 * Update a dynamic provider
 */
export const dynamicProviderUpdateMutation = (
  options?: Partial<Options<DynamicProviderUpdateData>>
): UseMutationOptions<
  DynamicProviderUpdateResponse,
  DynamicProviderUpdateError,
  Options<DynamicProviderUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    DynamicProviderUpdateResponse,
    DynamicProviderUpdateError,
    Options<DynamicProviderUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dynamicProviderUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Test connectivity for an existing dynamic provider
 *
 * Sends a lightweight request to the provider to verify the API key and endpoint are working.
 */
export const dynamicProviderTestMutation = (
  options?: Partial<Options<DynamicProviderTestData>>
): UseMutationOptions<
  DynamicProviderTestResponse,
  DynamicProviderTestError,
  Options<DynamicProviderTestData>
> => {
  const mutationOptions: UseMutationOptions<
    DynamicProviderTestResponse,
    DynamicProviderTestError,
    Options<DynamicProviderTestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await dynamicProviderTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete current user and all associated data (GDPR Article 17 - Right to Erasure)
 *
 * Permanently deletes the authenticated user and all associated data including:
 * - User record
 * - Organization and project memberships
 * - API keys owned by the user
 * - Conversations owned by the user
 * - Dynamic providers owned by the user
 * - Usage records for user's API keys
 *
 * This endpoint allows users to delete their own account without admin permissions.
 * The user is identified from the authenticated session.
 *
 * **Warning:** This operation is irreversible.
 */
export const meDeleteMutation = (
  options?: Partial<Options<MeDeleteData>>
): UseMutationOptions<MeDeleteResponse, MeDeleteError, Options<MeDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    MeDeleteResponse,
    MeDeleteError,
    Options<MeDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const meApiKeysListQueryKey = (options?: Options<MeApiKeysListData>) =>
  createQueryKey("meApiKeysList", options);

/**
 * List current user's API keys
 */
export const meApiKeysListOptions = (options?: Options<MeApiKeysListData>) =>
  queryOptions<
    MeApiKeysListResponse,
    MeApiKeysListError,
    MeApiKeysListResponse,
    ReturnType<typeof meApiKeysListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meApiKeysList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meApiKeysListQueryKey(options),
  });

export const meApiKeysListInfiniteQueryKey = (
  options?: Options<MeApiKeysListData>
): QueryKey<Options<MeApiKeysListData>> => createQueryKey("meApiKeysList", options, true);

/**
 * List current user's API keys
 */
export const meApiKeysListInfiniteOptions = (options?: Options<MeApiKeysListData>) =>
  infiniteQueryOptions<
    MeApiKeysListResponse,
    MeApiKeysListError,
    InfiniteData<MeApiKeysListResponse>,
    QueryKey<Options<MeApiKeysListData>>,
    | string
    | null
    | Pick<QueryKey<Options<MeApiKeysListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MeApiKeysListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await meApiKeysList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: meApiKeysListInfiniteQueryKey(options),
    }
  );

/**
 * Create an API key for the current user
 */
export const meApiKeysCreateMutation = (
  options?: Partial<Options<MeApiKeysCreateData>>
): UseMutationOptions<
  MeApiKeysCreateResponse,
  MeApiKeysCreateError,
  Options<MeApiKeysCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MeApiKeysCreateResponse,
    MeApiKeysCreateError,
    Options<MeApiKeysCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meApiKeysCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Revoke an API key (current user only)
 */
export const meApiKeysRevokeMutation = (
  options?: Partial<Options<MeApiKeysRevokeData>>
): UseMutationOptions<unknown, MeApiKeysRevokeError, Options<MeApiKeysRevokeData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    MeApiKeysRevokeError,
    Options<MeApiKeysRevokeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meApiKeysRevoke({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const meApiKeysGetQueryKey = (options: Options<MeApiKeysGetData>) =>
  createQueryKey("meApiKeysGet", options);

/**
 * Get an API key by ID (current user only)
 */
export const meApiKeysGetOptions = (options: Options<MeApiKeysGetData>) =>
  queryOptions<
    MeApiKeysGetResponse,
    MeApiKeysGetError,
    MeApiKeysGetResponse,
    ReturnType<typeof meApiKeysGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meApiKeysGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meApiKeysGetQueryKey(options),
  });

/**
 * Rotate an API key (current user only)
 *
 * Creates a new API key with the same settings as the old key and sets a grace period
 * on the old key. During the grace period, both keys are valid.
 */
export const meApiKeysRotateMutation = (
  options?: Partial<Options<MeApiKeysRotateData>>
): UseMutationOptions<
  MeApiKeysRotateResponse,
  MeApiKeysRotateError,
  Options<MeApiKeysRotateData>
> => {
  const mutationOptions: UseMutationOptions<
    MeApiKeysRotateResponse,
    MeApiKeysRotateError,
    Options<MeApiKeysRotateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meApiKeysRotate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const meBuiltInProvidersListQueryKey = (options?: Options<MeBuiltInProvidersListData>) =>
  createQueryKey("meBuiltInProvidersList", options);

/**
 * List built-in providers from the gateway configuration
 */
export const meBuiltInProvidersListOptions = (options?: Options<MeBuiltInProvidersListData>) =>
  queryOptions<
    MeBuiltInProvidersListResponse,
    DefaultError,
    MeBuiltInProvidersListResponse,
    ReturnType<typeof meBuiltInProvidersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meBuiltInProvidersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meBuiltInProvidersListQueryKey(options),
  });

export const meEligibleOwnersQueryKey = (options?: Options<MeEligibleOwnersData>) =>
  createQueryKey("meEligibleOwners", options);

/**
 * List the owners the current user can plausibly issue an API key for.
 *
 * This is a hint for the OAuth consent UI; the actual create-permission
 * check still runs server-side at consent time, so an owner appearing
 * here doesn't guarantee the create will succeed if RBAC denies it.
 */
export const meEligibleOwnersOptions = (options?: Options<MeEligibleOwnersData>) =>
  queryOptions<
    MeEligibleOwnersResponse,
    MeEligibleOwnersError,
    MeEligibleOwnersResponse,
    ReturnType<typeof meEligibleOwnersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meEligibleOwners({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meEligibleOwnersQueryKey(options),
  });

export const meExportQueryKey = (options?: Options<MeExportData>) =>
  createQueryKey("meExport", options);

/**
 * Export current user's data (GDPR Article 15 - Right of Access)
 *
 * Exports all personal data associated with the authenticated user including:
 * - User profile
 * - Organization and project memberships
 * - API keys (excluding sensitive hash)
 * - Conversations
 * - Usage summary
 * - Audit logs where user was the actor
 *
 * This endpoint allows users to export their own data without admin permissions.
 * The user is identified from the authenticated session.
 */
export const meExportOptions = (options?: Options<MeExportData>) =>
  queryOptions<
    MeExportResponse,
    MeExportError,
    MeExportResponse,
    ReturnType<typeof meExportQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meExport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meExportQueryKey(options),
  });

export const meProvidersListQueryKey = (options?: Options<MeProvidersListData>) =>
  createQueryKey("meProvidersList", options);

/**
 * List current user's dynamic providers
 */
export const meProvidersListOptions = (options?: Options<MeProvidersListData>) =>
  queryOptions<
    MeProvidersListResponse,
    MeProvidersListError,
    MeProvidersListResponse,
    ReturnType<typeof meProvidersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meProvidersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meProvidersListQueryKey(options),
  });

export const meProvidersListInfiniteQueryKey = (
  options?: Options<MeProvidersListData>
): QueryKey<Options<MeProvidersListData>> => createQueryKey("meProvidersList", options, true);

/**
 * List current user's dynamic providers
 */
export const meProvidersListInfiniteOptions = (options?: Options<MeProvidersListData>) =>
  infiniteQueryOptions<
    MeProvidersListResponse,
    MeProvidersListError,
    InfiniteData<MeProvidersListResponse>,
    QueryKey<Options<MeProvidersListData>>,
    | string
    | null
    | Pick<QueryKey<Options<MeProvidersListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MeProvidersListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await meProvidersList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: meProvidersListInfiniteQueryKey(options),
    }
  );

/**
 * Create a dynamic provider for the current user
 */
export const meProvidersCreateMutation = (
  options?: Partial<Options<MeProvidersCreateData>>
): UseMutationOptions<
  MeProvidersCreateResponse,
  MeProvidersCreateError,
  Options<MeProvidersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MeProvidersCreateResponse,
    MeProvidersCreateError,
    Options<MeProvidersCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meProvidersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Test credentials before creating a provider
 *
 * Accepts the same body as the create endpoint but does not persist anything.
 * Useful for validating API keys and endpoints before committing.
 */
export const meProvidersTestCredentialsMutation = (
  options?: Partial<Options<MeProvidersTestCredentialsData>>
): UseMutationOptions<
  MeProvidersTestCredentialsResponse,
  MeProvidersTestCredentialsError,
  Options<MeProvidersTestCredentialsData>
> => {
  const mutationOptions: UseMutationOptions<
    MeProvidersTestCredentialsResponse,
    MeProvidersTestCredentialsError,
    Options<MeProvidersTestCredentialsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meProvidersTestCredentials({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a dynamic provider (current user only)
 */
export const meProvidersDeleteMutation = (
  options?: Partial<Options<MeProvidersDeleteData>>
): UseMutationOptions<unknown, MeProvidersDeleteError, Options<MeProvidersDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    MeProvidersDeleteError,
    Options<MeProvidersDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meProvidersDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const meProvidersGetQueryKey = (options: Options<MeProvidersGetData>) =>
  createQueryKey("meProvidersGet", options);

/**
 * Get a dynamic provider by ID (current user only)
 */
export const meProvidersGetOptions = (options: Options<MeProvidersGetData>) =>
  queryOptions<
    MeProvidersGetResponse,
    MeProvidersGetError,
    MeProvidersGetResponse,
    ReturnType<typeof meProvidersGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meProvidersGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meProvidersGetQueryKey(options),
  });

/**
 * Update a dynamic provider (current user only)
 */
export const meProvidersUpdateMutation = (
  options?: Partial<Options<MeProvidersUpdateData>>
): UseMutationOptions<
  MeProvidersUpdateResponse,
  MeProvidersUpdateError,
  Options<MeProvidersUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    MeProvidersUpdateResponse,
    MeProvidersUpdateError,
    Options<MeProvidersUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meProvidersUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Test connectivity for a dynamic provider (current user only)
 *
 * Sends a lightweight request to the provider to verify the API key and endpoint are working.
 */
export const meProvidersTestMutation = (
  options?: Partial<Options<MeProvidersTestData>>
): UseMutationOptions<
  MeProvidersTestResponse,
  MeProvidersTestError,
  Options<MeProvidersTestData>
> => {
  const mutationOptions: UseMutationOptions<
    MeProvidersTestResponse,
    MeProvidersTestError,
    Options<MeProvidersTestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meProvidersTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const meSessionsListQueryKey = (options?: Options<MeSessionsListData>) =>
  createQueryKey("meSessionsList", options);

/**
 * List current user's active sessions.
 *
 * Returns an empty list if enhanced session management is not enabled.
 * The `enhanced_enabled` field indicates whether session tracking is active.
 */
export const meSessionsListOptions = (options?: Options<MeSessionsListData>) =>
  queryOptions<
    MeSessionsListResponse,
    MeSessionsListError,
    MeSessionsListResponse,
    ReturnType<typeof meSessionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meSessionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meSessionsListQueryKey(options),
  });

/**
 * Revoke a specific session belonging to the current user.
 *
 * Returns success even if the session doesn't exist (idempotent).
 * Returns 400 if the session belongs to a different user.
 */
export const meSessionsDeleteOneMutation = (
  options?: Partial<Options<MeSessionsDeleteOneData>>
): UseMutationOptions<
  MeSessionsDeleteOneResponse,
  MeSessionsDeleteOneError,
  Options<MeSessionsDeleteOneData>
> => {
  const mutationOptions: UseMutationOptions<
    MeSessionsDeleteOneResponse,
    MeSessionsDeleteOneError,
    Options<MeSessionsDeleteOneData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await meSessionsDeleteOne({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const meUsageSummaryQueryKey = (options?: Options<MeUsageSummaryData>) =>
  createQueryKey("meUsageSummary", options);

/**
 * Get current user's usage summary
 *
 * Returns usage data for the authenticated user. Does not require admin role.
 */
export const meUsageSummaryOptions = (options?: Options<MeUsageSummaryData>) =>
  queryOptions<
    MeUsageSummaryResponse,
    MeUsageSummaryError,
    MeUsageSummaryResponse,
    ReturnType<typeof meUsageSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageSummaryQueryKey(options),
  });

export const meUsageByDateQueryKey = (options?: Options<MeUsageByDateData>) =>
  createQueryKey("meUsageByDate", options);

/**
 * Get current user's usage by date
 */
export const meUsageByDateOptions = (options?: Options<MeUsageByDateData>) =>
  queryOptions<
    MeUsageByDateResponse,
    MeUsageByDateError,
    MeUsageByDateResponse,
    ReturnType<typeof meUsageByDateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageByDate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageByDateQueryKey(options),
  });

export const meUsageByDateModelQueryKey = (options?: Options<MeUsageByDateModelData>) =>
  createQueryKey("meUsageByDateModel", options);

/**
 * Get current user's usage by date and model
 */
export const meUsageByDateModelOptions = (options?: Options<MeUsageByDateModelData>) =>
  queryOptions<
    MeUsageByDateModelResponse,
    DefaultError,
    MeUsageByDateModelResponse,
    ReturnType<typeof meUsageByDateModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageByDateModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageByDateModelQueryKey(options),
  });

export const meUsageByDatePricingSourceQueryKey = (
  options?: Options<MeUsageByDatePricingSourceData>
) => createQueryKey("meUsageByDatePricingSource", options);

/**
 * Get current user's usage by date and pricing source
 */
export const meUsageByDatePricingSourceOptions = (
  options?: Options<MeUsageByDatePricingSourceData>
) =>
  queryOptions<
    MeUsageByDatePricingSourceResponse,
    DefaultError,
    MeUsageByDatePricingSourceResponse,
    ReturnType<typeof meUsageByDatePricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageByDatePricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageByDatePricingSourceQueryKey(options),
  });

export const meUsageByDateProviderQueryKey = (options?: Options<MeUsageByDateProviderData>) =>
  createQueryKey("meUsageByDateProvider", options);

/**
 * Get current user's usage by date and provider
 */
export const meUsageByDateProviderOptions = (options?: Options<MeUsageByDateProviderData>) =>
  queryOptions<
    MeUsageByDateProviderResponse,
    DefaultError,
    MeUsageByDateProviderResponse,
    ReturnType<typeof meUsageByDateProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageByDateProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageByDateProviderQueryKey(options),
  });

export const meUsageByModelQueryKey = (options?: Options<MeUsageByModelData>) =>
  createQueryKey("meUsageByModel", options);

/**
 * Get current user's usage by model
 */
export const meUsageByModelOptions = (options?: Options<MeUsageByModelData>) =>
  queryOptions<
    MeUsageByModelResponse,
    MeUsageByModelError,
    MeUsageByModelResponse,
    ReturnType<typeof meUsageByModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageByModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageByModelQueryKey(options),
  });

export const meUsageByPricingSourceQueryKey = (options?: Options<MeUsageByPricingSourceData>) =>
  createQueryKey("meUsageByPricingSource", options);

/**
 * Get current user's usage by pricing source
 */
export const meUsageByPricingSourceOptions = (options?: Options<MeUsageByPricingSourceData>) =>
  queryOptions<
    MeUsageByPricingSourceResponse,
    DefaultError,
    MeUsageByPricingSourceResponse,
    ReturnType<typeof meUsageByPricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageByPricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageByPricingSourceQueryKey(options),
  });

export const meUsageByProviderQueryKey = (options?: Options<MeUsageByProviderData>) =>
  createQueryKey("meUsageByProvider", options);

/**
 * Get current user's usage by provider
 */
export const meUsageByProviderOptions = (options?: Options<MeUsageByProviderData>) =>
  queryOptions<
    MeUsageByProviderResponse,
    MeUsageByProviderError,
    MeUsageByProviderResponse,
    ReturnType<typeof meUsageByProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageByProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageByProviderQueryKey(options),
  });

export const meUsageLogListQueryKey = (options?: Options<MeUsageLogListData>) =>
  createQueryKey("meUsageLogList", options);

/**
 * List current user's usage logs
 */
export const meUsageLogListOptions = (options?: Options<MeUsageLogListData>) =>
  queryOptions<
    MeUsageLogListResponse,
    DefaultError,
    MeUsageLogListResponse,
    ReturnType<typeof meUsageLogListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageLogList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageLogListQueryKey(options),
  });

export const meUsageLogListInfiniteQueryKey = (
  options?: Options<MeUsageLogListData>
): QueryKey<Options<MeUsageLogListData>> => createQueryKey("meUsageLogList", options, true);

/**
 * List current user's usage logs
 */
export const meUsageLogListInfiniteOptions = (options?: Options<MeUsageLogListData>) =>
  infiniteQueryOptions<
    MeUsageLogListResponse,
    DefaultError,
    InfiniteData<MeUsageLogListResponse>,
    QueryKey<Options<MeUsageLogListData>>,
    | string
    | null
    | Pick<QueryKey<Options<MeUsageLogListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MeUsageLogListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await meUsageLogList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: meUsageLogListInfiniteQueryKey(options),
    }
  );

export const meUsageLogExportQueryKey = (options?: Options<MeUsageLogExportData>) =>
  createQueryKey("meUsageLogExport", options);

/**
 * Export current user's usage logs
 */
export const meUsageLogExportOptions = (options?: Options<MeUsageLogExportData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof meUsageLogExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await meUsageLogExport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meUsageLogExportQueryKey(options),
  });

export const modelPricingListGlobalQueryKey = (options?: Options<ModelPricingListGlobalData>) =>
  createQueryKey("modelPricingListGlobal", options);

/**
 * List global model pricing
 */
export const modelPricingListGlobalOptions = (options?: Options<ModelPricingListGlobalData>) =>
  queryOptions<
    ModelPricingListGlobalResponse,
    ModelPricingListGlobalError,
    ModelPricingListGlobalResponse,
    ReturnType<typeof modelPricingListGlobalQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await modelPricingListGlobal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: modelPricingListGlobalQueryKey(options),
  });

export const modelPricingListGlobalInfiniteQueryKey = (
  options?: Options<ModelPricingListGlobalData>
): QueryKey<Options<ModelPricingListGlobalData>> =>
  createQueryKey("modelPricingListGlobal", options, true);

/**
 * List global model pricing
 */
export const modelPricingListGlobalInfiniteOptions = (
  options?: Options<ModelPricingListGlobalData>
) =>
  infiniteQueryOptions<
    ModelPricingListGlobalResponse,
    ModelPricingListGlobalError,
    InfiniteData<ModelPricingListGlobalResponse>,
    QueryKey<Options<ModelPricingListGlobalData>>,
    | string
    | null
    | Pick<QueryKey<Options<ModelPricingListGlobalData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ModelPricingListGlobalData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await modelPricingListGlobal({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: modelPricingListGlobalInfiniteQueryKey(options),
    }
  );

/**
 * Create a new model pricing entry
 */
export const modelPricingCreateMutation = (
  options?: Partial<Options<ModelPricingCreateData>>
): UseMutationOptions<
  ModelPricingCreateResponse,
  ModelPricingCreateError,
  Options<ModelPricingCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ModelPricingCreateResponse,
    ModelPricingCreateError,
    Options<ModelPricingCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await modelPricingCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk upsert model pricing entries
 */
export const modelPricingBulkUpsertMutation = (
  options?: Partial<Options<ModelPricingBulkUpsertData>>
): UseMutationOptions<
  ModelPricingBulkUpsertResponse,
  DefaultError,
  Options<ModelPricingBulkUpsertData>
> => {
  const mutationOptions: UseMutationOptions<
    ModelPricingBulkUpsertResponse,
    DefaultError,
    Options<ModelPricingBulkUpsertData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await modelPricingBulkUpsert({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const modelPricingListByProviderQueryKey = (
  options: Options<ModelPricingListByProviderData>
) => createQueryKey("modelPricingListByProvider", options);

/**
 * List all pricing for a specific provider (across all scopes)
 */
export const modelPricingListByProviderOptions = (
  options: Options<ModelPricingListByProviderData>
) =>
  queryOptions<
    ModelPricingListByProviderResponse,
    ModelPricingListByProviderError,
    ModelPricingListByProviderResponse,
    ReturnType<typeof modelPricingListByProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await modelPricingListByProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: modelPricingListByProviderQueryKey(options),
  });

export const modelPricingListByProviderInfiniteQueryKey = (
  options: Options<ModelPricingListByProviderData>
): QueryKey<Options<ModelPricingListByProviderData>> =>
  createQueryKey("modelPricingListByProvider", options, true);

/**
 * List all pricing for a specific provider (across all scopes)
 */
export const modelPricingListByProviderInfiniteOptions = (
  options: Options<ModelPricingListByProviderData>
) =>
  infiniteQueryOptions<
    ModelPricingListByProviderResponse,
    ModelPricingListByProviderError,
    InfiniteData<ModelPricingListByProviderResponse>,
    QueryKey<Options<ModelPricingListByProviderData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ModelPricingListByProviderData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ModelPricingListByProviderData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await modelPricingListByProvider({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: modelPricingListByProviderInfiniteQueryKey(options),
    }
  );

/**
 * Upsert model pricing (create or update based on owner/provider/model)
 */
export const modelPricingUpsertMutation = (
  options?: Partial<Options<ModelPricingUpsertData>>
): UseMutationOptions<
  ModelPricingUpsertResponse,
  DefaultError,
  Options<ModelPricingUpsertData>
> => {
  const mutationOptions: UseMutationOptions<
    ModelPricingUpsertResponse,
    DefaultError,
    Options<ModelPricingUpsertData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await modelPricingUpsert({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a model pricing entry
 */
export const modelPricingDeleteMutation = (
  options?: Partial<Options<ModelPricingDeleteData>>
): UseMutationOptions<unknown, ModelPricingDeleteError, Options<ModelPricingDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ModelPricingDeleteError,
    Options<ModelPricingDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await modelPricingDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const modelPricingGetQueryKey = (options: Options<ModelPricingGetData>) =>
  createQueryKey("modelPricingGet", options);

/**
 * Get a model pricing entry by ID
 */
export const modelPricingGetOptions = (options: Options<ModelPricingGetData>) =>
  queryOptions<
    ModelPricingGetResponse,
    ModelPricingGetError,
    ModelPricingGetResponse,
    ReturnType<typeof modelPricingGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await modelPricingGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: modelPricingGetQueryKey(options),
  });

/**
 * Update a model pricing entry
 */
export const modelPricingUpdateMutation = (
  options?: Partial<Options<ModelPricingUpdateData>>
): UseMutationOptions<
  ModelPricingUpdateResponse,
  ModelPricingUpdateError,
  Options<ModelPricingUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ModelPricingUpdateResponse,
    ModelPricingUpdateError,
    Options<ModelPricingUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await modelPricingUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Issue an authorization code after explicit user consent.
 *
 * The browser calls this endpoint from the consent page when the user clicks
 * "Allow". The endpoint:
 *
 * 1. Validates the requested scopes and key name shape (mirroring the
 * self-service API key endpoint), so we reject obvious mistakes before
 * issuing the code.
 * 2. Validates the callback URL scheme and host against
 * `auth.oauth_pkce.allowed_domains` / `denied_domains`.
 * 3. Persists a single-use authorization code bound to the current user
 * and the supplied PKCE challenge.
 * 4. Returns the redirect URL the page should send the browser to.
 */
export const oauthAuthorizeMutation = (
  options?: Partial<Options<OauthAuthorizeData>>
): UseMutationOptions<OauthAuthorizeResponse, OauthAuthorizeError, Options<OauthAuthorizeData>> => {
  const mutationOptions: UseMutationOptions<
    OauthAuthorizeResponse,
    OauthAuthorizeError,
    Options<OauthAuthorizeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await oauthAuthorize({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const oauthPreflightQueryKey = (options: Options<OauthPreflightData>) =>
  createQueryKey("oauthPreflight", options);

/**
 * Validate a `callback_url` against the deployment's OAuth PKCE policy
 * without issuing a code. The consent UI calls this on mount and refuses
 * to render if the URL is rejected — closing the gap where a "Deny"
 * click could otherwise redirect to a host the operator denied.
 */
export const oauthPreflightOptions = (options: Options<OauthPreflightData>) =>
  queryOptions<
    OauthPreflightResponse,
    OauthPreflightError,
    OauthPreflightResponse,
    ReturnType<typeof oauthPreflightQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await oauthPreflight({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: oauthPreflightQueryKey(options),
  });

export const organizationListQueryKey = (options?: Options<OrganizationListData>) =>
  createQueryKey("organizationList", options);

/**
 * List all organizations
 */
export const organizationListOptions = (options?: Options<OrganizationListData>) =>
  queryOptions<
    OrganizationListResponse2,
    OrganizationListError,
    OrganizationListResponse2,
    ReturnType<typeof organizationListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: organizationListQueryKey(options),
  });

export const organizationListInfiniteQueryKey = (
  options?: Options<OrganizationListData>
): QueryKey<Options<OrganizationListData>> => createQueryKey("organizationList", options, true);

/**
 * List all organizations
 */
export const organizationListInfiniteOptions = (options?: Options<OrganizationListData>) =>
  infiniteQueryOptions<
    OrganizationListResponse2,
    OrganizationListError,
    InfiniteData<OrganizationListResponse2>,
    QueryKey<Options<OrganizationListData>>,
    | string
    | null
    | Pick<QueryKey<Options<OrganizationListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await organizationList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: organizationListInfiniteQueryKey(options),
    }
  );

/**
 * Create an organization
 */
export const organizationCreateMutation = (
  options?: Partial<Options<OrganizationCreateData>>
): UseMutationOptions<
  OrganizationCreateResponse,
  OrganizationCreateError,
  Options<OrganizationCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationCreateResponse,
    OrganizationCreateError,
    Options<OrganizationCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const orgAccessReportQueryKey = (options: Options<OrgAccessReportData>) =>
  createQueryKey("orgAccessReport", options);

/**
 * Get access report for a specific organization
 *
 * Returns a comprehensive access report for the specified organization including:
 * - All org members with their roles and project access
 * - All API keys scoped to the organization or its projects
 * - Recent access grant history from audit logs
 * - Summary statistics
 *
 * Use `format=csv` for CSV export suitable for auditors and spreadsheets.
 */
export const orgAccessReportOptions = (options: Options<OrgAccessReportData>) =>
  queryOptions<
    OrgAccessReportResponse2,
    OrgAccessReportError,
    OrgAccessReportResponse2,
    ReturnType<typeof orgAccessReportQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await orgAccessReport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: orgAccessReportQueryKey(options),
  });

export const apiKeyListByOrgQueryKey = (options: Options<ApiKeyListByOrgData>) =>
  createQueryKey("apiKeyListByOrg", options);

/**
 * List API keys by organization
 */
export const apiKeyListByOrgOptions = (options: Options<ApiKeyListByOrgData>) =>
  queryOptions<
    ApiKeyListByOrgResponse,
    ApiKeyListByOrgError,
    ApiKeyListByOrgResponse,
    ReturnType<typeof apiKeyListByOrgQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiKeyListByOrg({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiKeyListByOrgQueryKey(options),
  });

export const apiKeyListByOrgInfiniteQueryKey = (
  options: Options<ApiKeyListByOrgData>
): QueryKey<Options<ApiKeyListByOrgData>> => createQueryKey("apiKeyListByOrg", options, true);

/**
 * List API keys by organization
 */
export const apiKeyListByOrgInfiniteOptions = (options: Options<ApiKeyListByOrgData>) =>
  infiniteQueryOptions<
    ApiKeyListByOrgResponse,
    ApiKeyListByOrgError,
    InfiniteData<ApiKeyListByOrgResponse>,
    QueryKey<Options<ApiKeyListByOrgData>>,
    | string
    | null
    | Pick<QueryKey<Options<ApiKeyListByOrgData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApiKeyListByOrgData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiKeyListByOrg({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: apiKeyListByOrgInfiniteQueryKey(options),
    }
  );

export const dynamicProviderListByOrgQueryKey = (options: Options<DynamicProviderListByOrgData>) =>
  createQueryKey("dynamicProviderListByOrg", options);

/**
 * List dynamic providers by organization
 */
export const dynamicProviderListByOrgOptions = (options: Options<DynamicProviderListByOrgData>) =>
  queryOptions<
    DynamicProviderListByOrgResponse,
    DynamicProviderListByOrgError,
    DynamicProviderListByOrgResponse,
    ReturnType<typeof dynamicProviderListByOrgQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dynamicProviderListByOrg({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: dynamicProviderListByOrgQueryKey(options),
  });

export const dynamicProviderListByOrgInfiniteQueryKey = (
  options: Options<DynamicProviderListByOrgData>
): QueryKey<Options<DynamicProviderListByOrgData>> =>
  createQueryKey("dynamicProviderListByOrg", options, true);

/**
 * List dynamic providers by organization
 */
export const dynamicProviderListByOrgInfiniteOptions = (
  options: Options<DynamicProviderListByOrgData>
) =>
  infiniteQueryOptions<
    DynamicProviderListByOrgResponse,
    DynamicProviderListByOrgError,
    InfiniteData<DynamicProviderListByOrgResponse>,
    QueryKey<Options<DynamicProviderListByOrgData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<DynamicProviderListByOrgData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<DynamicProviderListByOrgData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await dynamicProviderListByOrg({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: dynamicProviderListByOrgInfiniteQueryKey(options),
    }
  );

export const orgMemberListQueryKey = (options: Options<OrgMemberListData>) =>
  createQueryKey("orgMemberList", options);

/**
 * List organization members
 */
export const orgMemberListOptions = (options: Options<OrgMemberListData>) =>
  queryOptions<
    OrgMemberListResponse,
    OrgMemberListError,
    OrgMemberListResponse,
    ReturnType<typeof orgMemberListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await orgMemberList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: orgMemberListQueryKey(options),
  });

export const orgMemberListInfiniteQueryKey = (
  options: Options<OrgMemberListData>
): QueryKey<Options<OrgMemberListData>> => createQueryKey("orgMemberList", options, true);

/**
 * List organization members
 */
export const orgMemberListInfiniteOptions = (options: Options<OrgMemberListData>) =>
  infiniteQueryOptions<
    OrgMemberListResponse,
    OrgMemberListError,
    InfiniteData<OrgMemberListResponse>,
    QueryKey<Options<OrgMemberListData>>,
    | string
    | null
    | Pick<QueryKey<Options<OrgMemberListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrgMemberListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await orgMemberList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: orgMemberListInfiniteQueryKey(options),
    }
  );

/**
 * Add a member to an organization
 */
export const orgMemberAddMutation = (
  options?: Partial<Options<OrgMemberAddData>>
): UseMutationOptions<unknown, OrgMemberAddError, Options<OrgMemberAddData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    OrgMemberAddError,
    Options<OrgMemberAddData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgMemberAdd({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove a member from an organization
 */
export const orgMemberRemoveMutation = (
  options?: Partial<Options<OrgMemberRemoveData>>
): UseMutationOptions<unknown, OrgMemberRemoveError, Options<OrgMemberRemoveData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    OrgMemberRemoveError,
    Options<OrgMemberRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgMemberRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const modelPricingListByOrgQueryKey = (options: Options<ModelPricingListByOrgData>) =>
  createQueryKey("modelPricingListByOrg", options);

/**
 * List model pricing for an organization
 */
export const modelPricingListByOrgOptions = (options: Options<ModelPricingListByOrgData>) =>
  queryOptions<
    ModelPricingListByOrgResponse,
    ModelPricingListByOrgError,
    ModelPricingListByOrgResponse,
    ReturnType<typeof modelPricingListByOrgQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await modelPricingListByOrg({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: modelPricingListByOrgQueryKey(options),
  });

export const modelPricingListByOrgInfiniteQueryKey = (
  options: Options<ModelPricingListByOrgData>
): QueryKey<Options<ModelPricingListByOrgData>> =>
  createQueryKey("modelPricingListByOrg", options, true);

/**
 * List model pricing for an organization
 */
export const modelPricingListByOrgInfiniteOptions = (options: Options<ModelPricingListByOrgData>) =>
  infiniteQueryOptions<
    ModelPricingListByOrgResponse,
    ModelPricingListByOrgError,
    InfiniteData<ModelPricingListByOrgResponse>,
    QueryKey<Options<ModelPricingListByOrgData>>,
    | string
    | null
    | Pick<QueryKey<Options<ModelPricingListByOrgData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ModelPricingListByOrgData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await modelPricingListByOrg({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: modelPricingListByOrgInfiniteQueryKey(options),
    }
  );

export const projectListQueryKey = (options: Options<ProjectListData>) =>
  createQueryKey("projectList", options);

/**
 * List projects in an organization
 */
export const projectListOptions = (options: Options<ProjectListData>) =>
  queryOptions<
    ProjectListResponse2,
    ProjectListError,
    ProjectListResponse2,
    ReturnType<typeof projectListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectListQueryKey(options),
  });

export const projectListInfiniteQueryKey = (
  options: Options<ProjectListData>
): QueryKey<Options<ProjectListData>> => createQueryKey("projectList", options, true);

/**
 * List projects in an organization
 */
export const projectListInfiniteOptions = (options: Options<ProjectListData>) =>
  infiniteQueryOptions<
    ProjectListResponse2,
    ProjectListError,
    InfiniteData<ProjectListResponse2>,
    QueryKey<Options<ProjectListData>>,
    | string
    | null
    | Pick<QueryKey<Options<ProjectListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ProjectListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: projectListInfiniteQueryKey(options),
    }
  );

/**
 * Create a project in an organization
 */
export const projectCreateMutation = (
  options?: Partial<Options<ProjectCreateData>>
): UseMutationOptions<ProjectCreateResponse, ProjectCreateError, Options<ProjectCreateData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectCreateResponse,
    ProjectCreateError,
    Options<ProjectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a project
 */
export const projectDeleteMutation = (
  options?: Partial<Options<ProjectDeleteData>>
): UseMutationOptions<unknown, ProjectDeleteError, Options<ProjectDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ProjectDeleteError,
    Options<ProjectDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const projectGetQueryKey = (options: Options<ProjectGetData>) =>
  createQueryKey("projectGet", options);

/**
 * Get a project by slug
 */
export const projectGetOptions = (options: Options<ProjectGetData>) =>
  queryOptions<
    ProjectGetResponse,
    ProjectGetError,
    ProjectGetResponse,
    ReturnType<typeof projectGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectGetQueryKey(options),
  });

/**
 * Update a project
 */
export const projectUpdateMutation = (
  options?: Partial<Options<ProjectUpdateData>>
): UseMutationOptions<ProjectUpdateResponse, ProjectUpdateError, Options<ProjectUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    ProjectUpdateResponse,
    ProjectUpdateError,
    Options<ProjectUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiKeyListByProjectQueryKey = (options: Options<ApiKeyListByProjectData>) =>
  createQueryKey("apiKeyListByProject", options);

/**
 * List API keys by project
 */
export const apiKeyListByProjectOptions = (options: Options<ApiKeyListByProjectData>) =>
  queryOptions<
    ApiKeyListByProjectResponse,
    ApiKeyListByProjectError,
    ApiKeyListByProjectResponse,
    ReturnType<typeof apiKeyListByProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiKeyListByProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiKeyListByProjectQueryKey(options),
  });

export const apiKeyListByProjectInfiniteQueryKey = (
  options: Options<ApiKeyListByProjectData>
): QueryKey<Options<ApiKeyListByProjectData>> =>
  createQueryKey("apiKeyListByProject", options, true);

/**
 * List API keys by project
 */
export const apiKeyListByProjectInfiniteOptions = (options: Options<ApiKeyListByProjectData>) =>
  infiniteQueryOptions<
    ApiKeyListByProjectResponse,
    ApiKeyListByProjectError,
    InfiniteData<ApiKeyListByProjectResponse>,
    QueryKey<Options<ApiKeyListByProjectData>>,
    | string
    | null
    | Pick<QueryKey<Options<ApiKeyListByProjectData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApiKeyListByProjectData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiKeyListByProject({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: apiKeyListByProjectInfiniteQueryKey(options),
    }
  );

export const conversationListByProjectQueryKey = (
  options: Options<ConversationListByProjectData>
) => createQueryKey("conversationListByProject", options);

/**
 * List conversations by project
 */
export const conversationListByProjectOptions = (options: Options<ConversationListByProjectData>) =>
  queryOptions<
    ConversationListByProjectResponse,
    ConversationListByProjectError,
    ConversationListByProjectResponse,
    ReturnType<typeof conversationListByProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await conversationListByProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: conversationListByProjectQueryKey(options),
  });

export const conversationListByProjectInfiniteQueryKey = (
  options: Options<ConversationListByProjectData>
): QueryKey<Options<ConversationListByProjectData>> =>
  createQueryKey("conversationListByProject", options, true);

/**
 * List conversations by project
 */
export const conversationListByProjectInfiniteOptions = (
  options: Options<ConversationListByProjectData>
) =>
  infiniteQueryOptions<
    ConversationListByProjectResponse,
    ConversationListByProjectError,
    InfiniteData<ConversationListByProjectResponse>,
    QueryKey<Options<ConversationListByProjectData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ConversationListByProjectData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ConversationListByProjectData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await conversationListByProject({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: conversationListByProjectInfiniteQueryKey(options),
    }
  );

export const dynamicProviderListByProjectQueryKey = (
  options: Options<DynamicProviderListByProjectData>
) => createQueryKey("dynamicProviderListByProject", options);

/**
 * List dynamic providers by project
 */
export const dynamicProviderListByProjectOptions = (
  options: Options<DynamicProviderListByProjectData>
) =>
  queryOptions<
    DynamicProviderListByProjectResponse,
    DynamicProviderListByProjectError,
    DynamicProviderListByProjectResponse,
    ReturnType<typeof dynamicProviderListByProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dynamicProviderListByProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: dynamicProviderListByProjectQueryKey(options),
  });

export const dynamicProviderListByProjectInfiniteQueryKey = (
  options: Options<DynamicProviderListByProjectData>
): QueryKey<Options<DynamicProviderListByProjectData>> =>
  createQueryKey("dynamicProviderListByProject", options, true);

/**
 * List dynamic providers by project
 */
export const dynamicProviderListByProjectInfiniteOptions = (
  options: Options<DynamicProviderListByProjectData>
) =>
  infiniteQueryOptions<
    DynamicProviderListByProjectResponse,
    DynamicProviderListByProjectError,
    InfiniteData<DynamicProviderListByProjectResponse>,
    QueryKey<Options<DynamicProviderListByProjectData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<DynamicProviderListByProjectData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<DynamicProviderListByProjectData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await dynamicProviderListByProject({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: dynamicProviderListByProjectInfiniteQueryKey(options),
    }
  );

export const projectMemberListQueryKey = (options: Options<ProjectMemberListData>) =>
  createQueryKey("projectMemberList", options);

/**
 * List project members
 */
export const projectMemberListOptions = (options: Options<ProjectMemberListData>) =>
  queryOptions<
    ProjectMemberListResponse,
    ProjectMemberListError,
    ProjectMemberListResponse,
    ReturnType<typeof projectMemberListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await projectMemberList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: projectMemberListQueryKey(options),
  });

export const projectMemberListInfiniteQueryKey = (
  options: Options<ProjectMemberListData>
): QueryKey<Options<ProjectMemberListData>> => createQueryKey("projectMemberList", options, true);

/**
 * List project members
 */
export const projectMemberListInfiniteOptions = (options: Options<ProjectMemberListData>) =>
  infiniteQueryOptions<
    ProjectMemberListResponse,
    ProjectMemberListError,
    InfiniteData<ProjectMemberListResponse>,
    QueryKey<Options<ProjectMemberListData>>,
    | string
    | null
    | Pick<QueryKey<Options<ProjectMemberListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ProjectMemberListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await projectMemberList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: projectMemberListInfiniteQueryKey(options),
    }
  );

/**
 * Add a member to a project
 */
export const projectMemberAddMutation = (
  options?: Partial<Options<ProjectMemberAddData>>
): UseMutationOptions<unknown, ProjectMemberAddError, Options<ProjectMemberAddData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ProjectMemberAddError,
    Options<ProjectMemberAddData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectMemberAdd({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove a member from a project
 */
export const projectMemberRemoveMutation = (
  options?: Partial<Options<ProjectMemberRemoveData>>
): UseMutationOptions<unknown, ProjectMemberRemoveError, Options<ProjectMemberRemoveData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ProjectMemberRemoveError,
    Options<ProjectMemberRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await projectMemberRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const modelPricingListByProjectQueryKey = (
  options: Options<ModelPricingListByProjectData>
) => createQueryKey("modelPricingListByProject", options);

/**
 * List model pricing for a project
 */
export const modelPricingListByProjectOptions = (options: Options<ModelPricingListByProjectData>) =>
  queryOptions<
    ModelPricingListByProjectResponse,
    ModelPricingListByProjectError,
    ModelPricingListByProjectResponse,
    ReturnType<typeof modelPricingListByProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await modelPricingListByProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: modelPricingListByProjectQueryKey(options),
  });

export const modelPricingListByProjectInfiniteQueryKey = (
  options: Options<ModelPricingListByProjectData>
): QueryKey<Options<ModelPricingListByProjectData>> =>
  createQueryKey("modelPricingListByProject", options, true);

/**
 * List model pricing for a project
 */
export const modelPricingListByProjectInfiniteOptions = (
  options: Options<ModelPricingListByProjectData>
) =>
  infiniteQueryOptions<
    ModelPricingListByProjectResponse,
    ModelPricingListByProjectError,
    InfiniteData<ModelPricingListByProjectResponse>,
    QueryKey<Options<ModelPricingListByProjectData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ModelPricingListByProjectData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ModelPricingListByProjectData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await modelPricingListByProject({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: modelPricingListByProjectInfiniteQueryKey(options),
    }
  );

export const templateListByProjectQueryKey = (options: Options<TemplateListByProjectData>) =>
  createQueryKey("templateListByProject", options);

/**
 * List templates by project
 */
export const templateListByProjectOptions = (options: Options<TemplateListByProjectData>) =>
  queryOptions<
    TemplateListByProjectResponse,
    TemplateListByProjectError,
    TemplateListByProjectResponse,
    ReturnType<typeof templateListByProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateListByProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: templateListByProjectQueryKey(options),
  });

export const templateListByProjectInfiniteQueryKey = (
  options: Options<TemplateListByProjectData>
): QueryKey<Options<TemplateListByProjectData>> =>
  createQueryKey("templateListByProject", options, true);

/**
 * List templates by project
 */
export const templateListByProjectInfiniteOptions = (options: Options<TemplateListByProjectData>) =>
  infiniteQueryOptions<
    TemplateListByProjectResponse,
    TemplateListByProjectError,
    InfiniteData<TemplateListByProjectResponse>,
    QueryKey<Options<TemplateListByProjectData>>,
    | string
    | null
    | Pick<QueryKey<Options<TemplateListByProjectData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TemplateListByProjectData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await templateListByProject({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: templateListByProjectInfiniteQueryKey(options),
    }
  );

export const usageGetProjectSummaryQueryKey = (options: Options<UsageGetProjectSummaryData>) =>
  createQueryKey("usageGetProjectSummary", options);

/**
 * Get usage summary for a project
 */
export const usageGetProjectSummaryOptions = (options: Options<UsageGetProjectSummaryData>) =>
  queryOptions<
    UsageGetProjectSummaryResponse,
    UsageGetProjectSummaryError,
    UsageGetProjectSummaryResponse,
    ReturnType<typeof usageGetProjectSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectSummaryQueryKey(options),
  });

export const usageGetProjectByDateQueryKey = (options: Options<UsageGetProjectByDateData>) =>
  createQueryKey("usageGetProjectByDate", options);

/**
 * Get usage by date for a project
 */
export const usageGetProjectByDateOptions = (options: Options<UsageGetProjectByDateData>) =>
  queryOptions<
    UsageGetProjectByDateResponse,
    UsageGetProjectByDateError,
    UsageGetProjectByDateResponse,
    ReturnType<typeof usageGetProjectByDateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectByDate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectByDateQueryKey(options),
  });

export const usageGetProjectByDateModelQueryKey = (
  options: Options<UsageGetProjectByDateModelData>
) => createQueryKey("usageGetProjectByDateModel", options);

/**
 * Get usage by date and model for a project
 */
export const usageGetProjectByDateModelOptions = (
  options: Options<UsageGetProjectByDateModelData>
) =>
  queryOptions<
    UsageGetProjectByDateModelResponse,
    DefaultError,
    UsageGetProjectByDateModelResponse,
    ReturnType<typeof usageGetProjectByDateModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectByDateModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectByDateModelQueryKey(options),
  });

export const usageGetProjectByDatePricingSourceQueryKey = (
  options: Options<UsageGetProjectByDatePricingSourceData>
) => createQueryKey("usageGetProjectByDatePricingSource", options);

/**
 * Get usage by date and pricing source for a project
 */
export const usageGetProjectByDatePricingSourceOptions = (
  options: Options<UsageGetProjectByDatePricingSourceData>
) =>
  queryOptions<
    UsageGetProjectByDatePricingSourceResponse,
    DefaultError,
    UsageGetProjectByDatePricingSourceResponse,
    ReturnType<typeof usageGetProjectByDatePricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectByDatePricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectByDatePricingSourceQueryKey(options),
  });

export const usageGetProjectByDateProviderQueryKey = (
  options: Options<UsageGetProjectByDateProviderData>
) => createQueryKey("usageGetProjectByDateProvider", options);

/**
 * Get usage by date and provider for a project
 */
export const usageGetProjectByDateProviderOptions = (
  options: Options<UsageGetProjectByDateProviderData>
) =>
  queryOptions<
    UsageGetProjectByDateProviderResponse,
    DefaultError,
    UsageGetProjectByDateProviderResponse,
    ReturnType<typeof usageGetProjectByDateProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectByDateProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectByDateProviderQueryKey(options),
  });

export const usageGetProjectByDateUserQueryKey = (
  options: Options<UsageGetProjectByDateUserData>
) => createQueryKey("usageGetProjectByDateUser", options);

/**
 * Get usage by date and user for a project
 */
export const usageGetProjectByDateUserOptions = (options: Options<UsageGetProjectByDateUserData>) =>
  queryOptions<
    UsageGetProjectByDateUserResponse,
    UsageGetProjectByDateUserError,
    UsageGetProjectByDateUserResponse,
    ReturnType<typeof usageGetProjectByDateUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectByDateUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectByDateUserQueryKey(options),
  });

export const usageGetProjectByModelQueryKey = (options: Options<UsageGetProjectByModelData>) =>
  createQueryKey("usageGetProjectByModel", options);

/**
 * Get usage by model for a project
 */
export const usageGetProjectByModelOptions = (options: Options<UsageGetProjectByModelData>) =>
  queryOptions<
    UsageGetProjectByModelResponse,
    UsageGetProjectByModelError,
    UsageGetProjectByModelResponse,
    ReturnType<typeof usageGetProjectByModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectByModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectByModelQueryKey(options),
  });

export const usageGetProjectByPricingSourceQueryKey = (
  options: Options<UsageGetProjectByPricingSourceData>
) => createQueryKey("usageGetProjectByPricingSource", options);

/**
 * Get usage by pricing source for a project
 */
export const usageGetProjectByPricingSourceOptions = (
  options: Options<UsageGetProjectByPricingSourceData>
) =>
  queryOptions<
    UsageGetProjectByPricingSourceResponse,
    DefaultError,
    UsageGetProjectByPricingSourceResponse,
    ReturnType<typeof usageGetProjectByPricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectByPricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectByPricingSourceQueryKey(options),
  });

export const usageGetProjectByProviderQueryKey = (
  options: Options<UsageGetProjectByProviderData>
) => createQueryKey("usageGetProjectByProvider", options);

/**
 * Get usage by provider for a project
 */
export const usageGetProjectByProviderOptions = (options: Options<UsageGetProjectByProviderData>) =>
  queryOptions<
    UsageGetProjectByProviderResponse,
    UsageGetProjectByProviderError,
    UsageGetProjectByProviderResponse,
    ReturnType<typeof usageGetProjectByProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectByProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectByProviderQueryKey(options),
  });

export const usageGetProjectByUserQueryKey = (options: Options<UsageGetProjectByUserData>) =>
  createQueryKey("usageGetProjectByUser", options);

/**
 * Get usage by user for a project
 */
export const usageGetProjectByUserOptions = (options: Options<UsageGetProjectByUserData>) =>
  queryOptions<
    UsageGetProjectByUserResponse,
    UsageGetProjectByUserError,
    UsageGetProjectByUserResponse,
    ReturnType<typeof usageGetProjectByUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectByUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectByUserQueryKey(options),
  });

export const usageGetProjectForecastQueryKey = (options: Options<UsageGetProjectForecastData>) =>
  createQueryKey("usageGetProjectForecast", options);

/**
 * Get cost forecast for a project
 *
 * Uses historical usage data across all API keys in the project to predict future spending.
 * Returns average daily spend, confidence intervals, and time series forecasts.
 */
export const usageGetProjectForecastOptions = (options: Options<UsageGetProjectForecastData>) =>
  queryOptions<
    UsageGetProjectForecastResponse,
    UsageGetProjectForecastError,
    UsageGetProjectForecastResponse,
    ReturnType<typeof usageGetProjectForecastQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProjectForecast({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProjectForecastQueryKey(options),
  });

export const orgRbacPolicyListQueryKey = (options: Options<OrgRbacPolicyListData>) =>
  createQueryKey("orgRbacPolicyList", options);

/**
 * List RBAC policies for an organization
 */
export const orgRbacPolicyListOptions = (options: Options<OrgRbacPolicyListData>) =>
  queryOptions<
    OrgRbacPolicyListResponse2,
    OrgRbacPolicyListError,
    OrgRbacPolicyListResponse2,
    ReturnType<typeof orgRbacPolicyListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await orgRbacPolicyList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: orgRbacPolicyListQueryKey(options),
  });

export const orgRbacPolicyListInfiniteQueryKey = (
  options: Options<OrgRbacPolicyListData>
): QueryKey<Options<OrgRbacPolicyListData>> => createQueryKey("orgRbacPolicyList", options, true);

/**
 * List RBAC policies for an organization
 */
export const orgRbacPolicyListInfiniteOptions = (options: Options<OrgRbacPolicyListData>) =>
  infiniteQueryOptions<
    OrgRbacPolicyListResponse2,
    OrgRbacPolicyListError,
    InfiniteData<OrgRbacPolicyListResponse2>,
    QueryKey<Options<OrgRbacPolicyListData>>,
    | string
    | null
    | Pick<QueryKey<Options<OrgRbacPolicyListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrgRbacPolicyListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await orgRbacPolicyList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: orgRbacPolicyListInfiniteQueryKey(options),
    }
  );

/**
 * Create a new RBAC policy for an organization
 */
export const orgRbacPolicyCreateMutation = (
  options?: Partial<Options<OrgRbacPolicyCreateData>>
): UseMutationOptions<
  OrgRbacPolicyCreateResponse,
  OrgRbacPolicyCreateError,
  Options<OrgRbacPolicyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgRbacPolicyCreateResponse,
    OrgRbacPolicyCreateError,
    Options<OrgRbacPolicyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgRbacPolicyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Simulate policy evaluation for an organization
 *
 * Tests what decision would be made for a given subject and context.
 * Evaluates both system policies (from config) and organization policies (from database),
 * matching the runtime authorization flow.
 *
 * ## Evaluation Order
 *
 * 1. Check if RBAC is disabled → return allow with `rbac_enabled: false`
 * 2. Evaluate system policies (from config file) first
 * 3. If a system policy matches → return that decision
 * 4. Evaluate organization policies (from database)
 * 5. If an org policy matches → return that decision
 * 6. No policy matched → apply configured `default_effect`
 */
export const orgRbacPolicySimulateMutation = (
  options?: Partial<Options<OrgRbacPolicySimulateData>>
): UseMutationOptions<
  OrgRbacPolicySimulateResponse,
  OrgRbacPolicySimulateError,
  Options<OrgRbacPolicySimulateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgRbacPolicySimulateResponse,
    OrgRbacPolicySimulateError,
    Options<OrgRbacPolicySimulateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgRbacPolicySimulate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete an RBAC policy
 */
export const orgRbacPolicyDeleteMutation = (
  options?: Partial<Options<OrgRbacPolicyDeleteData>>
): UseMutationOptions<unknown, OrgRbacPolicyDeleteError, Options<OrgRbacPolicyDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    OrgRbacPolicyDeleteError,
    Options<OrgRbacPolicyDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgRbacPolicyDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const orgRbacPolicyGetQueryKey = (options: Options<OrgRbacPolicyGetData>) =>
  createQueryKey("orgRbacPolicyGet", options);

/**
 * Get an RBAC policy by ID
 */
export const orgRbacPolicyGetOptions = (options: Options<OrgRbacPolicyGetData>) =>
  queryOptions<
    OrgRbacPolicyGetResponse,
    OrgRbacPolicyGetError,
    OrgRbacPolicyGetResponse,
    ReturnType<typeof orgRbacPolicyGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await orgRbacPolicyGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: orgRbacPolicyGetQueryKey(options),
  });

/**
 * Update an RBAC policy
 */
export const orgRbacPolicyUpdateMutation = (
  options?: Partial<Options<OrgRbacPolicyUpdateData>>
): UseMutationOptions<
  OrgRbacPolicyUpdateResponse,
  OrgRbacPolicyUpdateError,
  Options<OrgRbacPolicyUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgRbacPolicyUpdateResponse,
    OrgRbacPolicyUpdateError,
    Options<OrgRbacPolicyUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgRbacPolicyUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Rollback an RBAC policy to a previous version
 */
export const orgRbacPolicyRollbackMutation = (
  options?: Partial<Options<OrgRbacPolicyRollbackData>>
): UseMutationOptions<
  OrgRbacPolicyRollbackResponse,
  OrgRbacPolicyRollbackError,
  Options<OrgRbacPolicyRollbackData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgRbacPolicyRollbackResponse,
    OrgRbacPolicyRollbackError,
    Options<OrgRbacPolicyRollbackData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgRbacPolicyRollback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const orgRbacPolicyListVersionsQueryKey = (
  options: Options<OrgRbacPolicyListVersionsData>
) => createQueryKey("orgRbacPolicyListVersions", options);

/**
 * List version history for an RBAC policy
 */
export const orgRbacPolicyListVersionsOptions = (options: Options<OrgRbacPolicyListVersionsData>) =>
  queryOptions<
    OrgRbacPolicyListVersionsResponse,
    OrgRbacPolicyListVersionsError,
    OrgRbacPolicyListVersionsResponse,
    ReturnType<typeof orgRbacPolicyListVersionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await orgRbacPolicyListVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: orgRbacPolicyListVersionsQueryKey(options),
  });

export const orgRbacPolicyListVersionsInfiniteQueryKey = (
  options: Options<OrgRbacPolicyListVersionsData>
): QueryKey<Options<OrgRbacPolicyListVersionsData>> =>
  createQueryKey("orgRbacPolicyListVersions", options, true);

/**
 * List version history for an RBAC policy
 */
export const orgRbacPolicyListVersionsInfiniteOptions = (
  options: Options<OrgRbacPolicyListVersionsData>
) =>
  infiniteQueryOptions<
    OrgRbacPolicyListVersionsResponse,
    OrgRbacPolicyListVersionsError,
    InfiniteData<OrgRbacPolicyListVersionsResponse>,
    QueryKey<Options<OrgRbacPolicyListVersionsData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<OrgRbacPolicyListVersionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrgRbacPolicyListVersionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await orgRbacPolicyListVersions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: orgRbacPolicyListVersionsInfiniteQueryKey(options),
    }
  );

/**
 * Delete the SCIM configuration for an organization
 */
export const orgScimConfigDeleteMutation = (
  options?: Partial<Options<OrgScimConfigDeleteData>>
): UseMutationOptions<unknown, OrgScimConfigDeleteError, Options<OrgScimConfigDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    OrgScimConfigDeleteError,
    Options<OrgScimConfigDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgScimConfigDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const orgScimConfigGetQueryKey = (options: Options<OrgScimConfigGetData>) =>
  createQueryKey("orgScimConfigGet", options);

/**
 * Get the SCIM configuration for an organization
 */
export const orgScimConfigGetOptions = (options: Options<OrgScimConfigGetData>) =>
  queryOptions<
    OrgScimConfigGetResponse,
    OrgScimConfigGetError,
    OrgScimConfigGetResponse,
    ReturnType<typeof orgScimConfigGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await orgScimConfigGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: orgScimConfigGetQueryKey(options),
  });

/**
 * Update the SCIM configuration for an organization
 */
export const orgScimConfigUpdateMutation = (
  options?: Partial<Options<OrgScimConfigUpdateData>>
): UseMutationOptions<
  OrgScimConfigUpdateResponse,
  OrgScimConfigUpdateError,
  Options<OrgScimConfigUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgScimConfigUpdateResponse,
    OrgScimConfigUpdateError,
    Options<OrgScimConfigUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgScimConfigUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a new SCIM configuration for an organization
 *
 * Each organization can have at most one SCIM configuration. Creating a config
 * for an organization that already has one will result in a 409 Conflict error.
 *
 * The response includes the SCIM bearer token which is only shown once.
 * Store it securely - it cannot be retrieved again.
 */
export const orgScimConfigCreateMutation = (
  options?: Partial<Options<OrgScimConfigCreateData>>
): UseMutationOptions<
  OrgScimConfigCreateResponse,
  OrgScimConfigCreateError,
  Options<OrgScimConfigCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgScimConfigCreateResponse,
    OrgScimConfigCreateError,
    Options<OrgScimConfigCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgScimConfigCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Rotate the SCIM bearer token for an organization
 *
 * Generates a new bearer token and invalidates the old one immediately.
 * The new token is returned only once - store it securely.
 */
export const orgScimConfigRotateTokenMutation = (
  options?: Partial<Options<OrgScimConfigRotateTokenData>>
): UseMutationOptions<
  OrgScimConfigRotateTokenResponse,
  OrgScimConfigRotateTokenError,
  Options<OrgScimConfigRotateTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgScimConfigRotateTokenResponse,
    OrgScimConfigRotateTokenError,
    Options<OrgScimConfigRotateTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgScimConfigRotateToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const serviceAccountListQueryKey = (options: Options<ServiceAccountListData>) =>
  createQueryKey("serviceAccountList", options);

/**
 * List service accounts in an organization
 */
export const serviceAccountListOptions = (options: Options<ServiceAccountListData>) =>
  queryOptions<
    ServiceAccountListResponse2,
    ServiceAccountListError,
    ServiceAccountListResponse2,
    ReturnType<typeof serviceAccountListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await serviceAccountList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: serviceAccountListQueryKey(options),
  });

export const serviceAccountListInfiniteQueryKey = (
  options: Options<ServiceAccountListData>
): QueryKey<Options<ServiceAccountListData>> => createQueryKey("serviceAccountList", options, true);

/**
 * List service accounts in an organization
 */
export const serviceAccountListInfiniteOptions = (options: Options<ServiceAccountListData>) =>
  infiniteQueryOptions<
    ServiceAccountListResponse2,
    ServiceAccountListError,
    InfiniteData<ServiceAccountListResponse2>,
    QueryKey<Options<ServiceAccountListData>>,
    | string
    | null
    | Pick<QueryKey<Options<ServiceAccountListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ServiceAccountListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await serviceAccountList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: serviceAccountListInfiniteQueryKey(options),
    }
  );

/**
 * Create a service account in an organization
 */
export const serviceAccountCreateMutation = (
  options?: Partial<Options<ServiceAccountCreateData>>
): UseMutationOptions<
  ServiceAccountCreateResponse,
  ServiceAccountCreateError,
  Options<ServiceAccountCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ServiceAccountCreateResponse,
    ServiceAccountCreateError,
    Options<ServiceAccountCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await serviceAccountCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a service account
 */
export const serviceAccountDeleteMutation = (
  options?: Partial<Options<ServiceAccountDeleteData>>
): UseMutationOptions<unknown, ServiceAccountDeleteError, Options<ServiceAccountDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ServiceAccountDeleteError,
    Options<ServiceAccountDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await serviceAccountDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const serviceAccountGetQueryKey = (options: Options<ServiceAccountGetData>) =>
  createQueryKey("serviceAccountGet", options);

/**
 * Get a service account by slug
 */
export const serviceAccountGetOptions = (options: Options<ServiceAccountGetData>) =>
  queryOptions<
    ServiceAccountGetResponse,
    ServiceAccountGetError,
    ServiceAccountGetResponse,
    ReturnType<typeof serviceAccountGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await serviceAccountGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: serviceAccountGetQueryKey(options),
  });

/**
 * Update a service account
 */
export const serviceAccountUpdateMutation = (
  options?: Partial<Options<ServiceAccountUpdateData>>
): UseMutationOptions<
  ServiceAccountUpdateResponse,
  ServiceAccountUpdateError,
  Options<ServiceAccountUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ServiceAccountUpdateResponse,
    ServiceAccountUpdateError,
    Options<ServiceAccountUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await serviceAccountUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiKeyListByServiceAccountQueryKey = (
  options: Options<ApiKeyListByServiceAccountData>
) => createQueryKey("apiKeyListByServiceAccount", options);

/**
 * List API keys by service account
 */
export const apiKeyListByServiceAccountOptions = (
  options: Options<ApiKeyListByServiceAccountData>
) =>
  queryOptions<
    ApiKeyListByServiceAccountResponse,
    ApiKeyListByServiceAccountError,
    ApiKeyListByServiceAccountResponse,
    ReturnType<typeof apiKeyListByServiceAccountQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiKeyListByServiceAccount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiKeyListByServiceAccountQueryKey(options),
  });

export const apiKeyListByServiceAccountInfiniteQueryKey = (
  options: Options<ApiKeyListByServiceAccountData>
): QueryKey<Options<ApiKeyListByServiceAccountData>> =>
  createQueryKey("apiKeyListByServiceAccount", options, true);

/**
 * List API keys by service account
 */
export const apiKeyListByServiceAccountInfiniteOptions = (
  options: Options<ApiKeyListByServiceAccountData>
) =>
  infiniteQueryOptions<
    ApiKeyListByServiceAccountResponse,
    ApiKeyListByServiceAccountError,
    InfiniteData<ApiKeyListByServiceAccountResponse>,
    QueryKey<Options<ApiKeyListByServiceAccountData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<ApiKeyListByServiceAccountData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApiKeyListByServiceAccountData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiKeyListByServiceAccount({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: apiKeyListByServiceAccountInfiniteQueryKey(options),
    }
  );

/**
 * Delete the SSO configuration for an organization
 */
export const orgSsoConfigDeleteMutation = (
  options?: Partial<Options<OrgSsoConfigDeleteData>>
): UseMutationOptions<unknown, OrgSsoConfigDeleteError, Options<OrgSsoConfigDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    OrgSsoConfigDeleteError,
    Options<OrgSsoConfigDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgSsoConfigDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const orgSsoConfigGetQueryKey = (options: Options<OrgSsoConfigGetData>) =>
  createQueryKey("orgSsoConfigGet", options);

/**
 * Get the SSO configuration for an organization
 */
export const orgSsoConfigGetOptions = (options: Options<OrgSsoConfigGetData>) =>
  queryOptions<
    OrgSsoConfigGetResponse,
    OrgSsoConfigGetError,
    OrgSsoConfigGetResponse,
    ReturnType<typeof orgSsoConfigGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await orgSsoConfigGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: orgSsoConfigGetQueryKey(options),
  });

/**
 * Update the SSO configuration for an organization
 */
export const orgSsoConfigUpdateMutation = (
  options?: Partial<Options<OrgSsoConfigUpdateData>>
): UseMutationOptions<
  OrgSsoConfigUpdateResponse,
  OrgSsoConfigUpdateError,
  Options<OrgSsoConfigUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgSsoConfigUpdateResponse,
    OrgSsoConfigUpdateError,
    Options<OrgSsoConfigUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgSsoConfigUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a new SSO configuration for an organization
 *
 * Each organization can have at most one SSO configuration. Creating a config
 * for an organization that already has one will result in a 409 Conflict error.
 */
export const orgSsoConfigCreateMutation = (
  options?: Partial<Options<OrgSsoConfigCreateData>>
): UseMutationOptions<
  OrgSsoConfigCreateResponse,
  OrgSsoConfigCreateError,
  Options<OrgSsoConfigCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgSsoConfigCreateResponse,
    OrgSsoConfigCreateError,
    Options<OrgSsoConfigCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgSsoConfigCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const domainVerificationsListQueryKey = (options: Options<DomainVerificationsListData>) =>
  createQueryKey("domainVerificationsList", options);

/**
 * List all domain verifications for an organization's SSO config
 */
export const domainVerificationsListOptions = (options: Options<DomainVerificationsListData>) =>
  queryOptions<
    DomainVerificationsListResponse,
    DomainVerificationsListError,
    DomainVerificationsListResponse,
    ReturnType<typeof domainVerificationsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await domainVerificationsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: domainVerificationsListQueryKey(options),
  });

/**
 * Initiate domain verification for an organization's SSO config
 *
 * Creates a new domain verification record with a unique verification token.
 * Returns the verification instructions with DNS record details.
 */
export const domainVerificationsCreateMutation = (
  options?: Partial<Options<DomainVerificationsCreateData>>
): UseMutationOptions<
  DomainVerificationsCreateResponse,
  DomainVerificationsCreateError,
  Options<DomainVerificationsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    DomainVerificationsCreateResponse,
    DomainVerificationsCreateError,
    Options<DomainVerificationsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await domainVerificationsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a domain verification
 */
export const domainVerificationsDeleteMutation = (
  options?: Partial<Options<DomainVerificationsDeleteData>>
): UseMutationOptions<
  unknown,
  DomainVerificationsDeleteError,
  Options<DomainVerificationsDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DomainVerificationsDeleteError,
    Options<DomainVerificationsDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await domainVerificationsDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const domainVerificationsGetQueryKey = (options: Options<DomainVerificationsGetData>) =>
  createQueryKey("domainVerificationsGet", options);

/**
 * Get a specific domain verification by ID
 */
export const domainVerificationsGetOptions = (options: Options<DomainVerificationsGetData>) =>
  queryOptions<
    DomainVerificationsGetResponse,
    DomainVerificationsGetError,
    DomainVerificationsGetResponse,
    ReturnType<typeof domainVerificationsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await domainVerificationsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: domainVerificationsGetQueryKey(options),
  });

export const domainVerificationsGetInstructionsQueryKey = (
  options: Options<DomainVerificationsGetInstructionsData>
) => createQueryKey("domainVerificationsGetInstructions", options);

/**
 * Get verification instructions for a domain
 */
export const domainVerificationsGetInstructionsOptions = (
  options: Options<DomainVerificationsGetInstructionsData>
) =>
  queryOptions<
    DomainVerificationsGetInstructionsResponse,
    DomainVerificationsGetInstructionsError,
    DomainVerificationsGetInstructionsResponse,
    ReturnType<typeof domainVerificationsGetInstructionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await domainVerificationsGetInstructions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: domainVerificationsGetInstructionsQueryKey(options),
  });

/**
 * Trigger DNS verification for a domain
 *
 * Performs a DNS TXT record lookup to verify domain ownership.
 */
export const domainVerificationsVerifyMutation = (
  options?: Partial<Options<DomainVerificationsVerifyData>>
): UseMutationOptions<
  DomainVerificationsVerifyResponse,
  DomainVerificationsVerifyError,
  Options<DomainVerificationsVerifyData>
> => {
  const mutationOptions: UseMutationOptions<
    DomainVerificationsVerifyResponse,
    DomainVerificationsVerifyError,
    Options<DomainVerificationsVerifyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await domainVerificationsVerify({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Parse SAML IdP metadata from a URL
 *
 * Fetches IdP metadata from the provided URL and extracts configuration fields.
 * This does NOT save the configuration - it returns the parsed data for admin review.
 * Use the returned values to populate the SSO config fields.
 */
export const orgSsoConfigParseSamlMetadataMutation = (
  options?: Partial<Options<OrgSsoConfigParseSamlMetadataData>>
): UseMutationOptions<
  OrgSsoConfigParseSamlMetadataResponse,
  OrgSsoConfigParseSamlMetadataError,
  Options<OrgSsoConfigParseSamlMetadataData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgSsoConfigParseSamlMetadataResponse,
    OrgSsoConfigParseSamlMetadataError,
    Options<OrgSsoConfigParseSamlMetadataData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgSsoConfigParseSamlMetadata({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const orgSsoConfigGetSpMetadataQueryKey = (
  options: Options<OrgSsoConfigGetSpMetadataData>
) => createQueryKey("orgSsoConfigGetSpMetadata", options);

/**
 * Get SP metadata for IdP configuration
 *
 * Returns Hadrian's Service Provider metadata XML that can be imported into
 * the IdP to configure the SAML integration automatically. The metadata includes
 * the SP entity ID, Assertion Consumer Service URL, and supported bindings.
 *
 * This endpoint requires an existing SAML SSO configuration for the organization.
 */
export const orgSsoConfigGetSpMetadataOptions = (options: Options<OrgSsoConfigGetSpMetadataData>) =>
  queryOptions<
    unknown,
    OrgSsoConfigGetSpMetadataError,
    unknown,
    ReturnType<typeof orgSsoConfigGetSpMetadataQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await orgSsoConfigGetSpMetadata({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: orgSsoConfigGetSpMetadataQueryKey(options),
  });

export const ssoGroupMappingListQueryKey = (options: Options<SsoGroupMappingListData>) =>
  createQueryKey("ssoGroupMappingList", options);

/**
 * List SSO group mappings for an organization
 */
export const ssoGroupMappingListOptions = (options: Options<SsoGroupMappingListData>) =>
  queryOptions<
    SsoGroupMappingListResponse2,
    SsoGroupMappingListError,
    SsoGroupMappingListResponse2,
    ReturnType<typeof ssoGroupMappingListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ssoGroupMappingList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ssoGroupMappingListQueryKey(options),
  });

export const ssoGroupMappingListInfiniteQueryKey = (
  options: Options<SsoGroupMappingListData>
): QueryKey<Options<SsoGroupMappingListData>> =>
  createQueryKey("ssoGroupMappingList", options, true);

/**
 * List SSO group mappings for an organization
 */
export const ssoGroupMappingListInfiniteOptions = (options: Options<SsoGroupMappingListData>) =>
  infiniteQueryOptions<
    SsoGroupMappingListResponse2,
    SsoGroupMappingListError,
    InfiniteData<SsoGroupMappingListResponse2>,
    QueryKey<Options<SsoGroupMappingListData>>,
    | string
    | null
    | Pick<QueryKey<Options<SsoGroupMappingListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SsoGroupMappingListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await ssoGroupMappingList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: ssoGroupMappingListInfiniteQueryKey(options),
    }
  );

/**
 * Create a new SSO group mapping
 */
export const ssoGroupMappingCreateMutation = (
  options?: Partial<Options<SsoGroupMappingCreateData>>
): UseMutationOptions<
  SsoGroupMappingCreateResponse,
  SsoGroupMappingCreateError,
  Options<SsoGroupMappingCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SsoGroupMappingCreateResponse,
    SsoGroupMappingCreateError,
    Options<SsoGroupMappingCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ssoGroupMappingCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const ssoGroupMappingExportQueryKey = (options: Options<SsoGroupMappingExportData>) =>
  createQueryKey("ssoGroupMappingExport", options);

/**
 * Export SSO group mappings
 *
 * Exports all SSO group mappings for an organization in JSON or CSV format.
 * Useful for backup, migration, or bulk editing in a spreadsheet.
 */
export const ssoGroupMappingExportOptions = (options: Options<SsoGroupMappingExportData>) =>
  queryOptions<
    unknown,
    SsoGroupMappingExportError,
    unknown,
    ReturnType<typeof ssoGroupMappingExportQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ssoGroupMappingExport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ssoGroupMappingExportQueryKey(options),
  });

/**
 * Import SSO group mappings
 *
 * Bulk import SSO group mappings from a JSON payload. Useful for migrating
 * mappings between environments or restoring from a backup.
 */
export const ssoGroupMappingImportMutation = (
  options?: Partial<Options<SsoGroupMappingImportData>>
): UseMutationOptions<
  SsoGroupMappingImportResponse,
  SsoGroupMappingImportError,
  Options<SsoGroupMappingImportData>
> => {
  const mutationOptions: UseMutationOptions<
    SsoGroupMappingImportResponse,
    SsoGroupMappingImportError,
    Options<SsoGroupMappingImportData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ssoGroupMappingImport({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Test SSO group mapping resolution
 *
 * Given a list of IdP group names, returns what teams/roles a user with those
 * groups would be resolved to. This is useful for debugging and verifying
 * mapping configuration.
 */
export const ssoGroupMappingTestMutation = (
  options?: Partial<Options<SsoGroupMappingTestData>>
): UseMutationOptions<
  SsoGroupMappingTestResponse,
  SsoGroupMappingTestError,
  Options<SsoGroupMappingTestData>
> => {
  const mutationOptions: UseMutationOptions<
    SsoGroupMappingTestResponse,
    SsoGroupMappingTestError,
    Options<SsoGroupMappingTestData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ssoGroupMappingTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete an SSO group mapping
 */
export const ssoGroupMappingDeleteMutation = (
  options?: Partial<Options<SsoGroupMappingDeleteData>>
): UseMutationOptions<unknown, SsoGroupMappingDeleteError, Options<SsoGroupMappingDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SsoGroupMappingDeleteError,
    Options<SsoGroupMappingDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ssoGroupMappingDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const ssoGroupMappingGetQueryKey = (options: Options<SsoGroupMappingGetData>) =>
  createQueryKey("ssoGroupMappingGet", options);

/**
 * Get an SSO group mapping by ID
 */
export const ssoGroupMappingGetOptions = (options: Options<SsoGroupMappingGetData>) =>
  queryOptions<
    SsoGroupMappingGetResponse,
    SsoGroupMappingGetError,
    SsoGroupMappingGetResponse,
    ReturnType<typeof ssoGroupMappingGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ssoGroupMappingGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ssoGroupMappingGetQueryKey(options),
  });

/**
 * Update an SSO group mapping
 */
export const ssoGroupMappingUpdateMutation = (
  options?: Partial<Options<SsoGroupMappingUpdateData>>
): UseMutationOptions<
  SsoGroupMappingUpdateResponse,
  SsoGroupMappingUpdateError,
  Options<SsoGroupMappingUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SsoGroupMappingUpdateResponse,
    SsoGroupMappingUpdateError,
    Options<SsoGroupMappingUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ssoGroupMappingUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const teamListQueryKey = (options: Options<TeamListData>) =>
  createQueryKey("teamList", options);

/**
 * List teams in an organization
 */
export const teamListOptions = (options: Options<TeamListData>) =>
  queryOptions<
    TeamListResponse2,
    TeamListError,
    TeamListResponse2,
    ReturnType<typeof teamListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teamList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: teamListQueryKey(options),
  });

export const teamListInfiniteQueryKey = (
  options: Options<TeamListData>
): QueryKey<Options<TeamListData>> => createQueryKey("teamList", options, true);

/**
 * List teams in an organization
 */
export const teamListInfiniteOptions = (options: Options<TeamListData>) =>
  infiniteQueryOptions<
    TeamListResponse2,
    TeamListError,
    InfiniteData<TeamListResponse2>,
    QueryKey<Options<TeamListData>>,
    string | null | Pick<QueryKey<Options<TeamListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TeamListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await teamList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: teamListInfiniteQueryKey(options),
    }
  );

/**
 * Create a team in an organization
 */
export const teamCreateMutation = (
  options?: Partial<Options<TeamCreateData>>
): UseMutationOptions<TeamCreateResponse, TeamCreateError, Options<TeamCreateData>> => {
  const mutationOptions: UseMutationOptions<
    TeamCreateResponse,
    TeamCreateError,
    Options<TeamCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teamCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a team
 */
export const teamDeleteMutation = (
  options?: Partial<Options<TeamDeleteData>>
): UseMutationOptions<unknown, TeamDeleteError, Options<TeamDeleteData>> => {
  const mutationOptions: UseMutationOptions<unknown, TeamDeleteError, Options<TeamDeleteData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await teamDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const teamGetQueryKey = (options: Options<TeamGetData>) =>
  createQueryKey("teamGet", options);

/**
 * Get a team by slug
 */
export const teamGetOptions = (options: Options<TeamGetData>) =>
  queryOptions<TeamGetResponse, TeamGetError, TeamGetResponse, ReturnType<typeof teamGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teamGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: teamGetQueryKey(options),
  });

/**
 * Update a team
 */
export const teamUpdateMutation = (
  options?: Partial<Options<TeamUpdateData>>
): UseMutationOptions<TeamUpdateResponse, TeamUpdateError, Options<TeamUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    TeamUpdateResponse,
    TeamUpdateError,
    Options<TeamUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teamUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const teamMemberListQueryKey = (options: Options<TeamMemberListData>) =>
  createQueryKey("teamMemberList", options);

/**
 * List team members
 */
export const teamMemberListOptions = (options: Options<TeamMemberListData>) =>
  queryOptions<
    TeamMemberListResponse2,
    TeamMemberListError,
    TeamMemberListResponse2,
    ReturnType<typeof teamMemberListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await teamMemberList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: teamMemberListQueryKey(options),
  });

export const teamMemberListInfiniteQueryKey = (
  options: Options<TeamMemberListData>
): QueryKey<Options<TeamMemberListData>> => createQueryKey("teamMemberList", options, true);

/**
 * List team members
 */
export const teamMemberListInfiniteOptions = (options: Options<TeamMemberListData>) =>
  infiniteQueryOptions<
    TeamMemberListResponse2,
    TeamMemberListError,
    InfiniteData<TeamMemberListResponse2>,
    QueryKey<Options<TeamMemberListData>>,
    | string
    | null
    | Pick<QueryKey<Options<TeamMemberListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TeamMemberListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await teamMemberList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: teamMemberListInfiniteQueryKey(options),
    }
  );

/**
 * Add a member to a team
 */
export const teamMemberAddMutation = (
  options?: Partial<Options<TeamMemberAddData>>
): UseMutationOptions<TeamMemberAddResponse, TeamMemberAddError, Options<TeamMemberAddData>> => {
  const mutationOptions: UseMutationOptions<
    TeamMemberAddResponse,
    TeamMemberAddError,
    Options<TeamMemberAddData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teamMemberAdd({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove a member from a team
 */
export const teamMemberRemoveMutation = (
  options?: Partial<Options<TeamMemberRemoveData>>
): UseMutationOptions<unknown, TeamMemberRemoveError, Options<TeamMemberRemoveData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    TeamMemberRemoveError,
    Options<TeamMemberRemoveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teamMemberRemove({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a team member's role
 */
export const teamMemberUpdateMutation = (
  options?: Partial<Options<TeamMemberUpdateData>>
): UseMutationOptions<
  TeamMemberUpdateResponse,
  TeamMemberUpdateError,
  Options<TeamMemberUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TeamMemberUpdateResponse,
    TeamMemberUpdateError,
    Options<TeamMemberUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await teamMemberUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const templateListByTeamQueryKey = (options: Options<TemplateListByTeamData>) =>
  createQueryKey("templateListByTeam", options);

/**
 * List templates by team
 */
export const templateListByTeamOptions = (options: Options<TemplateListByTeamData>) =>
  queryOptions<
    TemplateListByTeamResponse,
    TemplateListByTeamError,
    TemplateListByTeamResponse,
    ReturnType<typeof templateListByTeamQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateListByTeam({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: templateListByTeamQueryKey(options),
  });

export const templateListByTeamInfiniteQueryKey = (
  options: Options<TemplateListByTeamData>
): QueryKey<Options<TemplateListByTeamData>> => createQueryKey("templateListByTeam", options, true);

/**
 * List templates by team
 */
export const templateListByTeamInfiniteOptions = (options: Options<TemplateListByTeamData>) =>
  infiniteQueryOptions<
    TemplateListByTeamResponse,
    TemplateListByTeamError,
    InfiniteData<TemplateListByTeamResponse>,
    QueryKey<Options<TemplateListByTeamData>>,
    | string
    | null
    | Pick<QueryKey<Options<TemplateListByTeamData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TemplateListByTeamData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await templateListByTeam({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: templateListByTeamInfiniteQueryKey(options),
    }
  );

export const usageGetTeamSummaryQueryKey = (options: Options<UsageGetTeamSummaryData>) =>
  createQueryKey("usageGetTeamSummary", options);

/**
 * Get usage summary for a team
 */
export const usageGetTeamSummaryOptions = (options: Options<UsageGetTeamSummaryData>) =>
  queryOptions<
    UsageGetTeamSummaryResponse,
    UsageGetTeamSummaryError,
    UsageGetTeamSummaryResponse,
    ReturnType<typeof usageGetTeamSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamSummaryQueryKey(options),
  });

export const usageGetTeamByDateQueryKey = (options: Options<UsageGetTeamByDateData>) =>
  createQueryKey("usageGetTeamByDate", options);

/**
 * Get usage by date for a team
 */
export const usageGetTeamByDateOptions = (options: Options<UsageGetTeamByDateData>) =>
  queryOptions<
    UsageGetTeamByDateResponse,
    UsageGetTeamByDateError,
    UsageGetTeamByDateResponse,
    ReturnType<typeof usageGetTeamByDateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByDate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByDateQueryKey(options),
  });

export const usageGetTeamByDateModelQueryKey = (options: Options<UsageGetTeamByDateModelData>) =>
  createQueryKey("usageGetTeamByDateModel", options);

/**
 * Get usage by date and model for a team
 */
export const usageGetTeamByDateModelOptions = (options: Options<UsageGetTeamByDateModelData>) =>
  queryOptions<
    UsageGetTeamByDateModelResponse,
    DefaultError,
    UsageGetTeamByDateModelResponse,
    ReturnType<typeof usageGetTeamByDateModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByDateModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByDateModelQueryKey(options),
  });

export const usageGetTeamByDatePricingSourceQueryKey = (
  options: Options<UsageGetTeamByDatePricingSourceData>
) => createQueryKey("usageGetTeamByDatePricingSource", options);

/**
 * Get usage by date and pricing source for a team
 */
export const usageGetTeamByDatePricingSourceOptions = (
  options: Options<UsageGetTeamByDatePricingSourceData>
) =>
  queryOptions<
    UsageGetTeamByDatePricingSourceResponse,
    DefaultError,
    UsageGetTeamByDatePricingSourceResponse,
    ReturnType<typeof usageGetTeamByDatePricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByDatePricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByDatePricingSourceQueryKey(options),
  });

export const usageGetTeamByDateProjectQueryKey = (
  options: Options<UsageGetTeamByDateProjectData>
) => createQueryKey("usageGetTeamByDateProject", options);

/**
 * Get usage by date and project for a team
 */
export const usageGetTeamByDateProjectOptions = (options: Options<UsageGetTeamByDateProjectData>) =>
  queryOptions<
    UsageGetTeamByDateProjectResponse,
    UsageGetTeamByDateProjectError,
    UsageGetTeamByDateProjectResponse,
    ReturnType<typeof usageGetTeamByDateProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByDateProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByDateProjectQueryKey(options),
  });

export const usageGetTeamByDateProviderQueryKey = (
  options: Options<UsageGetTeamByDateProviderData>
) => createQueryKey("usageGetTeamByDateProvider", options);

/**
 * Get usage by date and provider for a team
 */
export const usageGetTeamByDateProviderOptions = (
  options: Options<UsageGetTeamByDateProviderData>
) =>
  queryOptions<
    UsageGetTeamByDateProviderResponse,
    DefaultError,
    UsageGetTeamByDateProviderResponse,
    ReturnType<typeof usageGetTeamByDateProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByDateProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByDateProviderQueryKey(options),
  });

export const usageGetTeamByDateUserQueryKey = (options: Options<UsageGetTeamByDateUserData>) =>
  createQueryKey("usageGetTeamByDateUser", options);

/**
 * Get usage by date and user for a team
 */
export const usageGetTeamByDateUserOptions = (options: Options<UsageGetTeamByDateUserData>) =>
  queryOptions<
    UsageGetTeamByDateUserResponse,
    UsageGetTeamByDateUserError,
    UsageGetTeamByDateUserResponse,
    ReturnType<typeof usageGetTeamByDateUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByDateUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByDateUserQueryKey(options),
  });

export const usageGetTeamByModelQueryKey = (options: Options<UsageGetTeamByModelData>) =>
  createQueryKey("usageGetTeamByModel", options);

/**
 * Get usage by model for a team
 */
export const usageGetTeamByModelOptions = (options: Options<UsageGetTeamByModelData>) =>
  queryOptions<
    UsageGetTeamByModelResponse,
    UsageGetTeamByModelError,
    UsageGetTeamByModelResponse,
    ReturnType<typeof usageGetTeamByModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByModelQueryKey(options),
  });

export const usageGetTeamByPricingSourceQueryKey = (
  options: Options<UsageGetTeamByPricingSourceData>
) => createQueryKey("usageGetTeamByPricingSource", options);

/**
 * Get usage by pricing source for a team
 */
export const usageGetTeamByPricingSourceOptions = (
  options: Options<UsageGetTeamByPricingSourceData>
) =>
  queryOptions<
    UsageGetTeamByPricingSourceResponse,
    DefaultError,
    UsageGetTeamByPricingSourceResponse,
    ReturnType<typeof usageGetTeamByPricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByPricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByPricingSourceQueryKey(options),
  });

export const usageGetTeamByProjectQueryKey = (options: Options<UsageGetTeamByProjectData>) =>
  createQueryKey("usageGetTeamByProject", options);

/**
 * Get usage by project for a team
 */
export const usageGetTeamByProjectOptions = (options: Options<UsageGetTeamByProjectData>) =>
  queryOptions<
    UsageGetTeamByProjectResponse,
    UsageGetTeamByProjectError,
    UsageGetTeamByProjectResponse,
    ReturnType<typeof usageGetTeamByProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByProjectQueryKey(options),
  });

export const usageGetTeamByProviderQueryKey = (options: Options<UsageGetTeamByProviderData>) =>
  createQueryKey("usageGetTeamByProvider", options);

/**
 * Get usage by provider for a team
 */
export const usageGetTeamByProviderOptions = (options: Options<UsageGetTeamByProviderData>) =>
  queryOptions<
    UsageGetTeamByProviderResponse,
    UsageGetTeamByProviderError,
    UsageGetTeamByProviderResponse,
    ReturnType<typeof usageGetTeamByProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByProviderQueryKey(options),
  });

export const usageGetTeamByUserQueryKey = (options: Options<UsageGetTeamByUserData>) =>
  createQueryKey("usageGetTeamByUser", options);

/**
 * Get usage by user for a team
 */
export const usageGetTeamByUserOptions = (options: Options<UsageGetTeamByUserData>) =>
  queryOptions<
    UsageGetTeamByUserResponse,
    UsageGetTeamByUserError,
    UsageGetTeamByUserResponse,
    ReturnType<typeof usageGetTeamByUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamByUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamByUserQueryKey(options),
  });

export const usageGetTeamForecastQueryKey = (options: Options<UsageGetTeamForecastData>) =>
  createQueryKey("usageGetTeamForecast", options);

/**
 * Get cost forecast for a team
 */
export const usageGetTeamForecastOptions = (options: Options<UsageGetTeamForecastData>) =>
  queryOptions<
    UsageGetTeamForecastResponse,
    UsageGetTeamForecastError,
    UsageGetTeamForecastResponse,
    ReturnType<typeof usageGetTeamForecastQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetTeamForecast({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetTeamForecastQueryKey(options),
  });

export const templateListByOrgQueryKey = (options: Options<TemplateListByOrgData>) =>
  createQueryKey("templateListByOrg", options);

/**
 * List templates by organization
 */
export const templateListByOrgOptions = (options: Options<TemplateListByOrgData>) =>
  queryOptions<
    TemplateListByOrgResponse,
    TemplateListByOrgError,
    TemplateListByOrgResponse,
    ReturnType<typeof templateListByOrgQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateListByOrg({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: templateListByOrgQueryKey(options),
  });

export const templateListByOrgInfiniteQueryKey = (
  options: Options<TemplateListByOrgData>
): QueryKey<Options<TemplateListByOrgData>> => createQueryKey("templateListByOrg", options, true);

/**
 * List templates by organization
 */
export const templateListByOrgInfiniteOptions = (options: Options<TemplateListByOrgData>) =>
  infiniteQueryOptions<
    TemplateListByOrgResponse,
    TemplateListByOrgError,
    InfiniteData<TemplateListByOrgResponse>,
    QueryKey<Options<TemplateListByOrgData>>,
    | string
    | null
    | Pick<QueryKey<Options<TemplateListByOrgData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TemplateListByOrgData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await templateListByOrg({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: templateListByOrgInfiniteQueryKey(options),
    }
  );

/**
 * Delete an organization
 */
export const organizationDeleteMutation = (
  options?: Partial<Options<OrganizationDeleteData>>
): UseMutationOptions<unknown, OrganizationDeleteError, Options<OrganizationDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    OrganizationDeleteError,
    Options<OrganizationDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const organizationGetQueryKey = (options: Options<OrganizationGetData>) =>
  createQueryKey("organizationGet", options);

/**
 * Get an organization by slug
 */
export const organizationGetOptions = (options: Options<OrganizationGetData>) =>
  queryOptions<
    OrganizationGetResponse,
    OrganizationGetError,
    OrganizationGetResponse,
    ReturnType<typeof organizationGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: organizationGetQueryKey(options),
  });

/**
 * Update an organization
 */
export const organizationUpdateMutation = (
  options?: Partial<Options<OrganizationUpdateData>>
): UseMutationOptions<
  OrganizationUpdateResponse,
  OrganizationUpdateError,
  Options<OrganizationUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationUpdateResponse,
    OrganizationUpdateError,
    Options<OrganizationUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const usageGetOrgSummaryQueryKey = (options: Options<UsageGetOrgSummaryData>) =>
  createQueryKey("usageGetOrgSummary", options);

/**
 * Get usage summary for an organization
 */
export const usageGetOrgSummaryOptions = (options: Options<UsageGetOrgSummaryData>) =>
  queryOptions<
    UsageGetOrgSummaryResponse,
    UsageGetOrgSummaryError,
    UsageGetOrgSummaryResponse,
    ReturnType<typeof usageGetOrgSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgSummaryQueryKey(options),
  });

export const usageGetOrgByDateQueryKey = (options: Options<UsageGetOrgByDateData>) =>
  createQueryKey("usageGetOrgByDate", options);

/**
 * Get usage by date for an organization
 */
export const usageGetOrgByDateOptions = (options: Options<UsageGetOrgByDateData>) =>
  queryOptions<
    UsageGetOrgByDateResponse,
    UsageGetOrgByDateError,
    UsageGetOrgByDateResponse,
    ReturnType<typeof usageGetOrgByDateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByDate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByDateQueryKey(options),
  });

export const usageGetOrgByDateModelQueryKey = (options: Options<UsageGetOrgByDateModelData>) =>
  createQueryKey("usageGetOrgByDateModel", options);

/**
 * Get usage by date and model for an organization
 */
export const usageGetOrgByDateModelOptions = (options: Options<UsageGetOrgByDateModelData>) =>
  queryOptions<
    UsageGetOrgByDateModelResponse,
    DefaultError,
    UsageGetOrgByDateModelResponse,
    ReturnType<typeof usageGetOrgByDateModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByDateModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByDateModelQueryKey(options),
  });

export const usageGetOrgByDatePricingSourceQueryKey = (
  options: Options<UsageGetOrgByDatePricingSourceData>
) => createQueryKey("usageGetOrgByDatePricingSource", options);

/**
 * Get usage by date and pricing source for an organization
 */
export const usageGetOrgByDatePricingSourceOptions = (
  options: Options<UsageGetOrgByDatePricingSourceData>
) =>
  queryOptions<
    UsageGetOrgByDatePricingSourceResponse,
    DefaultError,
    UsageGetOrgByDatePricingSourceResponse,
    ReturnType<typeof usageGetOrgByDatePricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByDatePricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByDatePricingSourceQueryKey(options),
  });

export const usageGetOrgByDateProjectQueryKey = (options: Options<UsageGetOrgByDateProjectData>) =>
  createQueryKey("usageGetOrgByDateProject", options);

/**
 * Get usage by date and project for an organization
 */
export const usageGetOrgByDateProjectOptions = (options: Options<UsageGetOrgByDateProjectData>) =>
  queryOptions<
    UsageGetOrgByDateProjectResponse,
    UsageGetOrgByDateProjectError,
    UsageGetOrgByDateProjectResponse,
    ReturnType<typeof usageGetOrgByDateProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByDateProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByDateProjectQueryKey(options),
  });

export const usageGetOrgByDateProviderQueryKey = (
  options: Options<UsageGetOrgByDateProviderData>
) => createQueryKey("usageGetOrgByDateProvider", options);

/**
 * Get usage by date and provider for an organization
 */
export const usageGetOrgByDateProviderOptions = (options: Options<UsageGetOrgByDateProviderData>) =>
  queryOptions<
    UsageGetOrgByDateProviderResponse,
    DefaultError,
    UsageGetOrgByDateProviderResponse,
    ReturnType<typeof usageGetOrgByDateProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByDateProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByDateProviderQueryKey(options),
  });

export const usageGetOrgByDateTeamQueryKey = (options: Options<UsageGetOrgByDateTeamData>) =>
  createQueryKey("usageGetOrgByDateTeam", options);

/**
 * Get usage by date and team for an organization
 */
export const usageGetOrgByDateTeamOptions = (options: Options<UsageGetOrgByDateTeamData>) =>
  queryOptions<
    UsageGetOrgByDateTeamResponse,
    UsageGetOrgByDateTeamError,
    UsageGetOrgByDateTeamResponse,
    ReturnType<typeof usageGetOrgByDateTeamQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByDateTeam({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByDateTeamQueryKey(options),
  });

export const usageGetOrgByDateUserQueryKey = (options: Options<UsageGetOrgByDateUserData>) =>
  createQueryKey("usageGetOrgByDateUser", options);

/**
 * Get usage by date and user for an organization
 */
export const usageGetOrgByDateUserOptions = (options: Options<UsageGetOrgByDateUserData>) =>
  queryOptions<
    UsageGetOrgByDateUserResponse,
    UsageGetOrgByDateUserError,
    UsageGetOrgByDateUserResponse,
    ReturnType<typeof usageGetOrgByDateUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByDateUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByDateUserQueryKey(options),
  });

export const usageGetOrgByModelQueryKey = (options: Options<UsageGetOrgByModelData>) =>
  createQueryKey("usageGetOrgByModel", options);

/**
 * Get usage by model for an organization
 */
export const usageGetOrgByModelOptions = (options: Options<UsageGetOrgByModelData>) =>
  queryOptions<
    UsageGetOrgByModelResponse,
    UsageGetOrgByModelError,
    UsageGetOrgByModelResponse,
    ReturnType<typeof usageGetOrgByModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByModelQueryKey(options),
  });

export const usageGetOrgByPricingSourceQueryKey = (
  options: Options<UsageGetOrgByPricingSourceData>
) => createQueryKey("usageGetOrgByPricingSource", options);

/**
 * Get usage by pricing source for an organization
 */
export const usageGetOrgByPricingSourceOptions = (
  options: Options<UsageGetOrgByPricingSourceData>
) =>
  queryOptions<
    UsageGetOrgByPricingSourceResponse,
    DefaultError,
    UsageGetOrgByPricingSourceResponse,
    ReturnType<typeof usageGetOrgByPricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByPricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByPricingSourceQueryKey(options),
  });

export const usageGetOrgByProjectQueryKey = (options: Options<UsageGetOrgByProjectData>) =>
  createQueryKey("usageGetOrgByProject", options);

/**
 * Get usage by project for an organization
 */
export const usageGetOrgByProjectOptions = (options: Options<UsageGetOrgByProjectData>) =>
  queryOptions<
    UsageGetOrgByProjectResponse,
    UsageGetOrgByProjectError,
    UsageGetOrgByProjectResponse,
    ReturnType<typeof usageGetOrgByProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByProjectQueryKey(options),
  });

export const usageGetOrgByProviderQueryKey = (options: Options<UsageGetOrgByProviderData>) =>
  createQueryKey("usageGetOrgByProvider", options);

/**
 * Get usage by provider for an organization
 */
export const usageGetOrgByProviderOptions = (options: Options<UsageGetOrgByProviderData>) =>
  queryOptions<
    UsageGetOrgByProviderResponse,
    UsageGetOrgByProviderError,
    UsageGetOrgByProviderResponse,
    ReturnType<typeof usageGetOrgByProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByProviderQueryKey(options),
  });

export const usageGetOrgByTeamQueryKey = (options: Options<UsageGetOrgByTeamData>) =>
  createQueryKey("usageGetOrgByTeam", options);

/**
 * Get usage by team for an organization
 */
export const usageGetOrgByTeamOptions = (options: Options<UsageGetOrgByTeamData>) =>
  queryOptions<
    UsageGetOrgByTeamResponse,
    UsageGetOrgByTeamError,
    UsageGetOrgByTeamResponse,
    ReturnType<typeof usageGetOrgByTeamQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByTeam({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByTeamQueryKey(options),
  });

export const usageGetOrgByUserQueryKey = (options: Options<UsageGetOrgByUserData>) =>
  createQueryKey("usageGetOrgByUser", options);

/**
 * Get usage by user for an organization
 */
export const usageGetOrgByUserOptions = (options: Options<UsageGetOrgByUserData>) =>
  queryOptions<
    UsageGetOrgByUserResponse,
    UsageGetOrgByUserError,
    UsageGetOrgByUserResponse,
    ReturnType<typeof usageGetOrgByUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgByUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgByUserQueryKey(options),
  });

export const usageGetOrgForecastQueryKey = (options: Options<UsageGetOrgForecastData>) =>
  createQueryKey("usageGetOrgForecast", options);

/**
 * Get cost forecast for an organization
 *
 * Uses historical usage data across all API keys in the organization to predict future spending.
 * Returns average daily spend, confidence intervals, and time series forecasts.
 */
export const usageGetOrgForecastOptions = (options: Options<UsageGetOrgForecastData>) =>
  queryOptions<
    UsageGetOrgForecastResponse,
    UsageGetOrgForecastError,
    UsageGetOrgForecastResponse,
    ReturnType<typeof usageGetOrgForecastQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetOrgForecast({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetOrgForecastQueryKey(options),
  });

export const listCircuitBreakersQueryKey = (options?: Options<ListCircuitBreakersData>) =>
  createQueryKey("listCircuitBreakers", options);

/**
 * Get circuit breaker status for all providers.
 *
 * Returns the current state and failure count for all configured
 * circuit breakers. Useful for monitoring provider health.
 */
export const listCircuitBreakersOptions = (options?: Options<ListCircuitBreakersData>) =>
  queryOptions<
    ListCircuitBreakersResponse,
    DefaultError,
    ListCircuitBreakersResponse,
    ReturnType<typeof listCircuitBreakersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listCircuitBreakers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listCircuitBreakersQueryKey(options),
  });

export const listProviderHealthQueryKey = (options?: Options<ListProviderHealthData>) =>
  createQueryKey("listProviderHealth", options);

/**
 * Get health status for all providers.
 *
 * Returns the current health status for all providers that have health checks
 * enabled. Includes status, latency, last check time, and consecutive
 * success/failure counts.
 *
 * Note: Only providers with `health_check.enabled = true` in their config
 * will appear in this list. Providers without health checks rely solely
 * on circuit breaker status.
 */
export const listProviderHealthOptions = (options?: Options<ListProviderHealthData>) =>
  queryOptions<
    ListProviderHealthResponse,
    DefaultError,
    ListProviderHealthResponse,
    ReturnType<typeof listProviderHealthQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProviderHealth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listProviderHealthQueryKey(options),
  });

export const listProviderStatsQueryKey = (options?: Options<ListProviderStatsData>) =>
  createQueryKey("listProviderStats", options);

/**
 * Get aggregated statistics for all providers.
 *
 * Returns current metrics including latency percentiles, error counts,
 * token usage, and costs for all providers.
 *
 * In single-node deployments, stats are derived from the local /metrics endpoint.
 * In multi-node deployments with Prometheus configured, stats are aggregated
 * from Prometheus queries.
 */
export const listProviderStatsOptions = (options?: Options<ListProviderStatsData>) =>
  queryOptions<
    ListProviderStatsResponse,
    DefaultError,
    ListProviderStatsResponse,
    ReturnType<typeof listProviderStatsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProviderStats({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listProviderStatsQueryKey(options),
  });

export const getCircuitBreakerQueryKey = (options: Options<GetCircuitBreakerData>) =>
  createQueryKey("getCircuitBreaker", options);

/**
 * Get circuit breaker status for a specific provider.
 *
 * Returns the current state and failure count for the specified provider's
 * circuit breaker.
 */
export const getCircuitBreakerOptions = (options: Options<GetCircuitBreakerData>) =>
  queryOptions<
    GetCircuitBreakerResponse,
    DefaultError,
    GetCircuitBreakerResponse,
    ReturnType<typeof getCircuitBreakerQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCircuitBreaker({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCircuitBreakerQueryKey(options),
  });

export const getProviderHealthQueryKey = (options: Options<GetProviderHealthData>) =>
  createQueryKey("getProviderHealth", options);

/**
 * Get health status for a specific provider.
 *
 * Returns the current health status for the specified provider. Only works
 * for providers that have health checks enabled.
 */
export const getProviderHealthOptions = (options: Options<GetProviderHealthData>) =>
  queryOptions<
    GetProviderHealthResponse,
    DefaultError,
    GetProviderHealthResponse,
    ReturnType<typeof getProviderHealthQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProviderHealth({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProviderHealthQueryKey(options),
  });

export const getProviderStatsQueryKey = (options: Options<GetProviderStatsData>) =>
  createQueryKey("getProviderStats", options);

/**
 * Get aggregated statistics for a specific provider.
 *
 * Returns current metrics including latency percentiles, error counts,
 * token usage, and costs for the specified provider.
 */
export const getProviderStatsOptions = (options: Options<GetProviderStatsData>) =>
  queryOptions<
    GetProviderStatsResponse,
    DefaultError,
    GetProviderStatsResponse,
    ReturnType<typeof getProviderStatsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProviderStats({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProviderStatsQueryKey(options),
  });

export const getProviderStatsHistoryQueryKey = (options: Options<GetProviderStatsHistoryData>) =>
  createQueryKey("getProviderStatsHistory", options);

/**
 * Get historical statistics for a specific provider.
 *
 * Returns time series data for the specified provider within the given
 * time range. Data is returned as hourly or daily buckets depending
 * on the granularity parameter.
 *
 * **Note:** Historical stats require Prometheus to be configured via
 * `observability.metrics.prometheus_query_url`. In single-node deployments
 * without Prometheus, this endpoint returns an error.
 */
export const getProviderStatsHistoryOptions = (options: Options<GetProviderStatsHistoryData>) =>
  queryOptions<
    GetProviderStatsHistoryResponse,
    DefaultError,
    GetProviderStatsHistoryResponse,
    ReturnType<typeof getProviderStatsHistoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProviderStatsHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProviderStatsHistoryQueryKey(options),
  });

export const getProviderStatsHistoryInfiniteQueryKey = (
  options: Options<GetProviderStatsHistoryData>
): QueryKey<Options<GetProviderStatsHistoryData>> =>
  createQueryKey("getProviderStatsHistory", options, true);

/**
 * Get historical statistics for a specific provider.
 *
 * Returns time series data for the specified provider within the given
 * time range. Data is returned as hourly or daily buckets depending
 * on the granularity parameter.
 *
 * **Note:** Historical stats require Prometheus to be configured via
 * `observability.metrics.prometheus_query_url`. In single-node deployments
 * without Prometheus, this endpoint returns an error.
 */
export const getProviderStatsHistoryInfiniteOptions = (
  options: Options<GetProviderStatsHistoryData>
) =>
  infiniteQueryOptions<
    GetProviderStatsHistoryResponse,
    DefaultError,
    InfiniteData<GetProviderStatsHistoryResponse>,
    QueryKey<Options<GetProviderStatsHistoryData>>,
    | string
    | null
    | Pick<QueryKey<Options<GetProviderStatsHistoryData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetProviderStatsHistoryData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getProviderStatsHistory({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getProviderStatsHistoryInfiniteQueryKey(options),
    }
  );

export const usageGetProviderSummaryQueryKey = (options: Options<UsageGetProviderSummaryData>) =>
  createQueryKey("usageGetProviderSummary", options);

/**
 * Get usage summary for a provider
 */
export const usageGetProviderSummaryOptions = (options: Options<UsageGetProviderSummaryData>) =>
  queryOptions<
    UsageGetProviderSummaryResponse,
    DefaultError,
    UsageGetProviderSummaryResponse,
    ReturnType<typeof usageGetProviderSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProviderSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProviderSummaryQueryKey(options),
  });

export const usageGetProviderByDateQueryKey = (options: Options<UsageGetProviderByDateData>) =>
  createQueryKey("usageGetProviderByDate", options);

/**
 * Get usage by date for a provider
 */
export const usageGetProviderByDateOptions = (options: Options<UsageGetProviderByDateData>) =>
  queryOptions<
    UsageGetProviderByDateResponse,
    DefaultError,
    UsageGetProviderByDateResponse,
    ReturnType<typeof usageGetProviderByDateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProviderByDate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProviderByDateQueryKey(options),
  });

export const usageGetProviderByModelQueryKey = (options: Options<UsageGetProviderByModelData>) =>
  createQueryKey("usageGetProviderByModel", options);

/**
 * Get usage by model for a provider
 */
export const usageGetProviderByModelOptions = (options: Options<UsageGetProviderByModelData>) =>
  queryOptions<
    UsageGetProviderByModelResponse,
    DefaultError,
    UsageGetProviderByModelResponse,
    ReturnType<typeof usageGetProviderByModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProviderByModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProviderByModelQueryKey(options),
  });

export const usageGetProviderForecastQueryKey = (options: Options<UsageGetProviderForecastData>) =>
  createQueryKey("usageGetProviderForecast", options);

/**
 * Get cost forecast for a provider
 *
 * Uses historical usage data across all API keys using this provider to predict future spending.
 * Returns average daily spend, confidence intervals, and time series forecasts.
 */
export const usageGetProviderForecastOptions = (options: Options<UsageGetProviderForecastData>) =>
  queryOptions<
    UsageGetProviderForecastResponse,
    DefaultError,
    UsageGetProviderForecastResponse,
    ReturnType<typeof usageGetProviderForecastQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetProviderForecast({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetProviderForecastQueryKey(options),
  });

/**
 * Validate a CEL expression
 *
 * Checks if a CEL expression is syntactically valid without creating a policy.
 * Useful for validating expressions before saving.
 */
export const orgRbacPolicyValidateMutation = (
  options?: Partial<Options<OrgRbacPolicyValidateData>>
): UseMutationOptions<
  OrgRbacPolicyValidateResponse,
  OrgRbacPolicyValidateError,
  Options<OrgRbacPolicyValidateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrgRbacPolicyValidateResponse,
    OrgRbacPolicyValidateError,
    Options<OrgRbacPolicyValidateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await orgRbacPolicyValidate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const sessionInfoGetQueryKey = (options?: Options<SessionInfoGetData>) =>
  createQueryKey("sessionInfoGet", options);

/**
 * Get comprehensive session and access information.
 *
 * Returns detailed information about the current user's authentication state,
 * database profile, organization/team/project memberships, and SSO configuration.
 * Useful for debugging authentication and authorization issues.
 */
export const sessionInfoGetOptions = (options?: Options<SessionInfoGetData>) =>
  queryOptions<
    SessionInfoGetResponse,
    SessionInfoGetError,
    SessionInfoGetResponse,
    ReturnType<typeof sessionInfoGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sessionInfoGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: sessionInfoGetQueryKey(options),
  });

export const ssoConnectionsListQueryKey = (options?: Options<SsoConnectionsListData>) =>
  createQueryKey("ssoConnectionsList", options);

/**
 * List configured SSO connections
 *
 * Returns read-only information about SSO connections configured in the gateway.
 * SSO connections are defined in the config file (hadrian.toml), not the database.
 * Currently only one OIDC connection is supported per deployment.
 */
export const ssoConnectionsListOptions = (options?: Options<SsoConnectionsListData>) =>
  queryOptions<
    SsoConnectionsListResponse,
    SsoConnectionsListError,
    SsoConnectionsListResponse,
    ReturnType<typeof ssoConnectionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ssoConnectionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ssoConnectionsListQueryKey(options),
  });

export const ssoConnectionGetQueryKey = (options: Options<SsoConnectionGetData>) =>
  createQueryKey("ssoConnectionGet", options);

/**
 * Get a specific SSO connection by name
 */
export const ssoConnectionGetOptions = (options: Options<SsoConnectionGetData>) =>
  queryOptions<
    SsoConnectionGetResponse,
    SsoConnectionGetError,
    SsoConnectionGetResponse,
    ReturnType<typeof ssoConnectionGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ssoConnectionGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ssoConnectionGetQueryKey(options),
  });

/**
 * Create a template
 */
export const templateCreateMutation = (
  options?: Partial<Options<TemplateCreateData>>
): UseMutationOptions<TemplateCreateResponse, TemplateCreateError, Options<TemplateCreateData>> => {
  const mutationOptions: UseMutationOptions<
    TemplateCreateResponse,
    TemplateCreateError,
    Options<TemplateCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await templateCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a template
 */
export const templateDeleteMutation = (
  options?: Partial<Options<TemplateDeleteData>>
): UseMutationOptions<unknown, TemplateDeleteError, Options<TemplateDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    TemplateDeleteError,
    Options<TemplateDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await templateDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const templateGetQueryKey = (options: Options<TemplateGetData>) =>
  createQueryKey("templateGet", options);

/**
 * Get a template by ID
 */
export const templateGetOptions = (options: Options<TemplateGetData>) =>
  queryOptions<
    TemplateGetResponse,
    TemplateGetError,
    TemplateGetResponse,
    ReturnType<typeof templateGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: templateGetQueryKey(options),
  });

/**
 * Update a template
 */
export const templateUpdateMutation = (
  options?: Partial<Options<TemplateUpdateData>>
): UseMutationOptions<TemplateUpdateResponse, TemplateUpdateError, Options<TemplateUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    TemplateUpdateResponse,
    TemplateUpdateError,
    Options<TemplateUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await templateUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const usageGetGlobalSummaryQueryKey = (options?: Options<UsageGetGlobalSummaryData>) =>
  createQueryKey("usageGetGlobalSummary", options);

/**
 * Get global usage summary
 */
export const usageGetGlobalSummaryOptions = (options?: Options<UsageGetGlobalSummaryData>) =>
  queryOptions<
    UsageGetGlobalSummaryResponse,
    DefaultError,
    UsageGetGlobalSummaryResponse,
    ReturnType<typeof usageGetGlobalSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalSummaryQueryKey(options),
  });

export const usageGetGlobalByDateQueryKey = (options?: Options<UsageGetGlobalByDateData>) =>
  createQueryKey("usageGetGlobalByDate", options);

/**
 * Get global usage by date
 */
export const usageGetGlobalByDateOptions = (options?: Options<UsageGetGlobalByDateData>) =>
  queryOptions<
    UsageGetGlobalByDateResponse,
    DefaultError,
    UsageGetGlobalByDateResponse,
    ReturnType<typeof usageGetGlobalByDateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByDate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByDateQueryKey(options),
  });

export const usageGetGlobalByDateModelQueryKey = (
  options?: Options<UsageGetGlobalByDateModelData>
) => createQueryKey("usageGetGlobalByDateModel", options);

/**
 * Get global usage by date and model
 */
export const usageGetGlobalByDateModelOptions = (
  options?: Options<UsageGetGlobalByDateModelData>
) =>
  queryOptions<
    UsageGetGlobalByDateModelResponse,
    DefaultError,
    UsageGetGlobalByDateModelResponse,
    ReturnType<typeof usageGetGlobalByDateModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByDateModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByDateModelQueryKey(options),
  });

export const usageGetGlobalByDateOrgQueryKey = (options?: Options<UsageGetGlobalByDateOrgData>) =>
  createQueryKey("usageGetGlobalByDateOrg", options);

/**
 * Get global usage by date and organization
 */
export const usageGetGlobalByDateOrgOptions = (options?: Options<UsageGetGlobalByDateOrgData>) =>
  queryOptions<
    UsageGetGlobalByDateOrgResponse,
    DefaultError,
    UsageGetGlobalByDateOrgResponse,
    ReturnType<typeof usageGetGlobalByDateOrgQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByDateOrg({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByDateOrgQueryKey(options),
  });

export const usageGetGlobalByDatePricingSourceQueryKey = (
  options?: Options<UsageGetGlobalByDatePricingSourceData>
) => createQueryKey("usageGetGlobalByDatePricingSource", options);

/**
 * Get global usage by date and pricing source
 */
export const usageGetGlobalByDatePricingSourceOptions = (
  options?: Options<UsageGetGlobalByDatePricingSourceData>
) =>
  queryOptions<
    UsageGetGlobalByDatePricingSourceResponse,
    DefaultError,
    UsageGetGlobalByDatePricingSourceResponse,
    ReturnType<typeof usageGetGlobalByDatePricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByDatePricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByDatePricingSourceQueryKey(options),
  });

export const usageGetGlobalByDateProjectQueryKey = (
  options?: Options<UsageGetGlobalByDateProjectData>
) => createQueryKey("usageGetGlobalByDateProject", options);

/**
 * Get global usage by date and project
 */
export const usageGetGlobalByDateProjectOptions = (
  options?: Options<UsageGetGlobalByDateProjectData>
) =>
  queryOptions<
    UsageGetGlobalByDateProjectResponse,
    DefaultError,
    UsageGetGlobalByDateProjectResponse,
    ReturnType<typeof usageGetGlobalByDateProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByDateProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByDateProjectQueryKey(options),
  });

export const usageGetGlobalByDateProviderQueryKey = (
  options?: Options<UsageGetGlobalByDateProviderData>
) => createQueryKey("usageGetGlobalByDateProvider", options);

/**
 * Get global usage by date and provider
 */
export const usageGetGlobalByDateProviderOptions = (
  options?: Options<UsageGetGlobalByDateProviderData>
) =>
  queryOptions<
    UsageGetGlobalByDateProviderResponse,
    DefaultError,
    UsageGetGlobalByDateProviderResponse,
    ReturnType<typeof usageGetGlobalByDateProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByDateProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByDateProviderQueryKey(options),
  });

export const usageGetGlobalByDateTeamQueryKey = (options?: Options<UsageGetGlobalByDateTeamData>) =>
  createQueryKey("usageGetGlobalByDateTeam", options);

/**
 * Get global usage by date and team
 */
export const usageGetGlobalByDateTeamOptions = (options?: Options<UsageGetGlobalByDateTeamData>) =>
  queryOptions<
    UsageGetGlobalByDateTeamResponse,
    DefaultError,
    UsageGetGlobalByDateTeamResponse,
    ReturnType<typeof usageGetGlobalByDateTeamQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByDateTeam({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByDateTeamQueryKey(options),
  });

export const usageGetGlobalByDateUserQueryKey = (options?: Options<UsageGetGlobalByDateUserData>) =>
  createQueryKey("usageGetGlobalByDateUser", options);

/**
 * Get global usage by date and user
 */
export const usageGetGlobalByDateUserOptions = (options?: Options<UsageGetGlobalByDateUserData>) =>
  queryOptions<
    UsageGetGlobalByDateUserResponse,
    DefaultError,
    UsageGetGlobalByDateUserResponse,
    ReturnType<typeof usageGetGlobalByDateUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByDateUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByDateUserQueryKey(options),
  });

export const usageGetGlobalByModelQueryKey = (options?: Options<UsageGetGlobalByModelData>) =>
  createQueryKey("usageGetGlobalByModel", options);

/**
 * Get global usage by model
 */
export const usageGetGlobalByModelOptions = (options?: Options<UsageGetGlobalByModelData>) =>
  queryOptions<
    UsageGetGlobalByModelResponse,
    DefaultError,
    UsageGetGlobalByModelResponse,
    ReturnType<typeof usageGetGlobalByModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByModelQueryKey(options),
  });

export const usageGetGlobalByOrgQueryKey = (options?: Options<UsageGetGlobalByOrgData>) =>
  createQueryKey("usageGetGlobalByOrg", options);

/**
 * Get global usage by organization
 */
export const usageGetGlobalByOrgOptions = (options?: Options<UsageGetGlobalByOrgData>) =>
  queryOptions<
    UsageGetGlobalByOrgResponse,
    DefaultError,
    UsageGetGlobalByOrgResponse,
    ReturnType<typeof usageGetGlobalByOrgQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByOrg({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByOrgQueryKey(options),
  });

export const usageGetGlobalByPricingSourceQueryKey = (
  options?: Options<UsageGetGlobalByPricingSourceData>
) => createQueryKey("usageGetGlobalByPricingSource", options);

/**
 * Get global usage by pricing source
 */
export const usageGetGlobalByPricingSourceOptions = (
  options?: Options<UsageGetGlobalByPricingSourceData>
) =>
  queryOptions<
    UsageGetGlobalByPricingSourceResponse,
    DefaultError,
    UsageGetGlobalByPricingSourceResponse,
    ReturnType<typeof usageGetGlobalByPricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByPricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByPricingSourceQueryKey(options),
  });

export const usageGetGlobalByProjectQueryKey = (options?: Options<UsageGetGlobalByProjectData>) =>
  createQueryKey("usageGetGlobalByProject", options);

/**
 * Get global usage by project
 */
export const usageGetGlobalByProjectOptions = (options?: Options<UsageGetGlobalByProjectData>) =>
  queryOptions<
    UsageGetGlobalByProjectResponse,
    DefaultError,
    UsageGetGlobalByProjectResponse,
    ReturnType<typeof usageGetGlobalByProjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByProjectQueryKey(options),
  });

export const usageGetGlobalByProviderQueryKey = (options?: Options<UsageGetGlobalByProviderData>) =>
  createQueryKey("usageGetGlobalByProvider", options);

/**
 * Get global usage by provider
 */
export const usageGetGlobalByProviderOptions = (options?: Options<UsageGetGlobalByProviderData>) =>
  queryOptions<
    UsageGetGlobalByProviderResponse,
    DefaultError,
    UsageGetGlobalByProviderResponse,
    ReturnType<typeof usageGetGlobalByProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByProviderQueryKey(options),
  });

export const usageGetGlobalByTeamQueryKey = (options?: Options<UsageGetGlobalByTeamData>) =>
  createQueryKey("usageGetGlobalByTeam", options);

/**
 * Get global usage by team
 */
export const usageGetGlobalByTeamOptions = (options?: Options<UsageGetGlobalByTeamData>) =>
  queryOptions<
    UsageGetGlobalByTeamResponse,
    DefaultError,
    UsageGetGlobalByTeamResponse,
    ReturnType<typeof usageGetGlobalByTeamQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByTeam({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByTeamQueryKey(options),
  });

export const usageGetGlobalByUserQueryKey = (options?: Options<UsageGetGlobalByUserData>) =>
  createQueryKey("usageGetGlobalByUser", options);

/**
 * Get global usage by user
 */
export const usageGetGlobalByUserOptions = (options?: Options<UsageGetGlobalByUserData>) =>
  queryOptions<
    UsageGetGlobalByUserResponse,
    DefaultError,
    UsageGetGlobalByUserResponse,
    ReturnType<typeof usageGetGlobalByUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetGlobalByUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetGlobalByUserQueryKey(options),
  });

export const usageLogListQueryKey = (options?: Options<UsageLogListData>) =>
  createQueryKey("usageLogList", options);

/**
 * List usage logs (admin global)
 */
export const usageLogListOptions = (options?: Options<UsageLogListData>) =>
  queryOptions<
    UsageLogListResponse2,
    DefaultError,
    UsageLogListResponse2,
    ReturnType<typeof usageLogListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageLogList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageLogListQueryKey(options),
  });

export const usageLogListInfiniteQueryKey = (
  options?: Options<UsageLogListData>
): QueryKey<Options<UsageLogListData>> => createQueryKey("usageLogList", options, true);

/**
 * List usage logs (admin global)
 */
export const usageLogListInfiniteOptions = (options?: Options<UsageLogListData>) =>
  infiniteQueryOptions<
    UsageLogListResponse2,
    DefaultError,
    InfiniteData<UsageLogListResponse2>,
    QueryKey<Options<UsageLogListData>>,
    | string
    | null
    | Pick<QueryKey<Options<UsageLogListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<UsageLogListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await usageLogList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: usageLogListInfiniteQueryKey(options),
    }
  );

export const usageLogExportQueryKey = (options?: Options<UsageLogExportData>) =>
  createQueryKey("usageLogExport", options);

/**
 * Export usage logs (admin global)
 */
export const usageLogExportOptions = (options?: Options<UsageLogExportData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof usageLogExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageLogExport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageLogExportQueryKey(options),
  });

export const userListQueryKey = (options?: Options<UserListData>) =>
  createQueryKey("userList", options);

/**
 * List all users
 */
export const userListOptions = (options?: Options<UserListData>) =>
  queryOptions<
    UserListResponse2,
    UserListError,
    UserListResponse2,
    ReturnType<typeof userListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: userListQueryKey(options),
  });

export const userListInfiniteQueryKey = (
  options?: Options<UserListData>
): QueryKey<Options<UserListData>> => createQueryKey("userList", options, true);

/**
 * List all users
 */
export const userListInfiniteOptions = (options?: Options<UserListData>) =>
  infiniteQueryOptions<
    UserListResponse2,
    UserListError,
    InfiniteData<UserListResponse2>,
    QueryKey<Options<UserListData>>,
    string | null | Pick<QueryKey<Options<UserListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<UserListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await userList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: userListInfiniteQueryKey(options),
    }
  );

/**
 * Create a user
 */
export const userCreateMutation = (
  options?: Partial<Options<UserCreateData>>
): UseMutationOptions<UserCreateResponse, UserCreateError, Options<UserCreateData>> => {
  const mutationOptions: UseMutationOptions<
    UserCreateResponse,
    UserCreateError,
    Options<UserCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await userCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a user and all associated data (GDPR Article 17 - Right to Erasure)
 *
 * Permanently deletes the user and all associated data including:
 * - User record
 * - Organization and project memberships
 * - API keys owned by the user
 * - Conversations owned by the user
 * - Dynamic providers owned by the user
 * - Usage records for user's API keys
 *
 * This operation is irreversible.
 */
export const userDeleteMutation = (
  options?: Partial<Options<UserDeleteData>>
): UseMutationOptions<UserDeleteResponse, UserDeleteError, Options<UserDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    UserDeleteResponse,
    UserDeleteError,
    Options<UserDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await userDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const userGetQueryKey = (options: Options<UserGetData>) =>
  createQueryKey("userGet", options);

/**
 * Get a user by ID
 */
export const userGetOptions = (options: Options<UserGetData>) =>
  queryOptions<UserGetResponse, UserGetError, UserGetResponse, ReturnType<typeof userGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: userGetQueryKey(options),
  });

/**
 * Update a user
 */
export const userUpdateMutation = (
  options?: Partial<Options<UserUpdateData>>
): UseMutationOptions<UserUpdateResponse, UserUpdateError, Options<UserUpdateData>> => {
  const mutationOptions: UseMutationOptions<
    UserUpdateResponse,
    UserUpdateError,
    Options<UserUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await userUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const userAccessSummaryQueryKey = (options: Options<UserAccessSummaryData>) =>
  createQueryKey("userAccessSummary", options);

/**
 * Get access summary for a specific user
 *
 * Returns a comprehensive access summary for the specified user including:
 * - All organizations the user belongs to with roles and grant dates
 * - All projects the user belongs to with roles and grant dates
 * - All API keys owned by the user
 * - Last activity timestamps per resource
 * - Summary statistics
 *
 * Use `format=csv` for CSV export suitable for auditors and spreadsheets.
 */
export const userAccessSummaryOptions = (options: Options<UserAccessSummaryData>) =>
  queryOptions<
    UserAccessSummaryResponse2,
    UserAccessSummaryError,
    UserAccessSummaryResponse2,
    ReturnType<typeof userAccessSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userAccessSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: userAccessSummaryQueryKey(options),
  });

export const apiKeyListByUserQueryKey = (options: Options<ApiKeyListByUserData>) =>
  createQueryKey("apiKeyListByUser", options);

/**
 * List API keys by user
 */
export const apiKeyListByUserOptions = (options: Options<ApiKeyListByUserData>) =>
  queryOptions<
    ApiKeyListByUserResponse,
    ApiKeyListByUserError,
    ApiKeyListByUserResponse,
    ReturnType<typeof apiKeyListByUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiKeyListByUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiKeyListByUserQueryKey(options),
  });

export const apiKeyListByUserInfiniteQueryKey = (
  options: Options<ApiKeyListByUserData>
): QueryKey<Options<ApiKeyListByUserData>> => createQueryKey("apiKeyListByUser", options, true);

/**
 * List API keys by user
 */
export const apiKeyListByUserInfiniteOptions = (options: Options<ApiKeyListByUserData>) =>
  infiniteQueryOptions<
    ApiKeyListByUserResponse,
    ApiKeyListByUserError,
    InfiniteData<ApiKeyListByUserResponse>,
    QueryKey<Options<ApiKeyListByUserData>>,
    | string
    | null
    | Pick<QueryKey<Options<ApiKeyListByUserData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApiKeyListByUserData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiKeyListByUser({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: apiKeyListByUserInfiniteQueryKey(options),
    }
  );

export const conversationListByUserQueryKey = (options: Options<ConversationListByUserData>) =>
  createQueryKey("conversationListByUser", options);

/**
 * List conversations by user
 */
export const conversationListByUserOptions = (options: Options<ConversationListByUserData>) =>
  queryOptions<
    ConversationListByUserResponse,
    ConversationListByUserError,
    ConversationListByUserResponse,
    ReturnType<typeof conversationListByUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await conversationListByUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: conversationListByUserQueryKey(options),
  });

export const conversationListByUserInfiniteQueryKey = (
  options: Options<ConversationListByUserData>
): QueryKey<Options<ConversationListByUserData>> =>
  createQueryKey("conversationListByUser", options, true);

/**
 * List conversations by user
 */
export const conversationListByUserInfiniteOptions = (
  options: Options<ConversationListByUserData>
) =>
  infiniteQueryOptions<
    ConversationListByUserResponse,
    ConversationListByUserError,
    InfiniteData<ConversationListByUserResponse>,
    QueryKey<Options<ConversationListByUserData>>,
    | string
    | null
    | Pick<QueryKey<Options<ConversationListByUserData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ConversationListByUserData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await conversationListByUser({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: conversationListByUserInfiniteQueryKey(options),
    }
  );

export const conversationListAccessibleForUserQueryKey = (
  options: Options<ConversationListAccessibleForUserData>
) => createQueryKey("conversationListAccessibleForUser", options);

/**
 * List all conversations accessible to a user
 *
 * Returns both user's personal conversations and conversations from projects they belong to.
 * Results include project metadata when applicable.
 */
export const conversationListAccessibleForUserOptions = (
  options: Options<ConversationListAccessibleForUserData>
) =>
  queryOptions<
    ConversationListAccessibleForUserResponse,
    ConversationListAccessibleForUserError,
    ConversationListAccessibleForUserResponse,
    ReturnType<typeof conversationListAccessibleForUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await conversationListAccessibleForUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: conversationListAccessibleForUserQueryKey(options),
  });

export const dynamicProviderListByUserQueryKey = (
  options: Options<DynamicProviderListByUserData>
) => createQueryKey("dynamicProviderListByUser", options);

/**
 * List dynamic providers by user
 */
export const dynamicProviderListByUserOptions = (options: Options<DynamicProviderListByUserData>) =>
  queryOptions<
    DynamicProviderListByUserResponse,
    DynamicProviderListByUserError,
    DynamicProviderListByUserResponse,
    ReturnType<typeof dynamicProviderListByUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dynamicProviderListByUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: dynamicProviderListByUserQueryKey(options),
  });

export const dynamicProviderListByUserInfiniteQueryKey = (
  options: Options<DynamicProviderListByUserData>
): QueryKey<Options<DynamicProviderListByUserData>> =>
  createQueryKey("dynamicProviderListByUser", options, true);

/**
 * List dynamic providers by user
 */
export const dynamicProviderListByUserInfiniteOptions = (
  options: Options<DynamicProviderListByUserData>
) =>
  infiniteQueryOptions<
    DynamicProviderListByUserResponse,
    DynamicProviderListByUserError,
    InfiniteData<DynamicProviderListByUserResponse>,
    QueryKey<Options<DynamicProviderListByUserData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<DynamicProviderListByUserData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<DynamicProviderListByUserData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await dynamicProviderListByUser({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: dynamicProviderListByUserInfiniteQueryKey(options),
    }
  );

export const userExportQueryKey = (options: Options<UserExportData>) =>
  createQueryKey("userExport", options);

/**
 * Export all user data (GDPR Article 15 - Right of Access)
 *
 * Returns all personal data associated with the user including:
 * - User profile
 * - Organization and project memberships
 * - API keys (excluding sensitive hash)
 * - Conversations
 * - Usage summary
 * - Audit logs where user was the actor
 */
export const userExportOptions = (options: Options<UserExportData>) =>
  queryOptions<
    UserExportResponse,
    UserExportError,
    UserExportResponse,
    ReturnType<typeof userExportQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userExport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: userExportQueryKey(options),
  });

export const modelPricingListByUserQueryKey = (options: Options<ModelPricingListByUserData>) =>
  createQueryKey("modelPricingListByUser", options);

/**
 * List model pricing for a user
 */
export const modelPricingListByUserOptions = (options: Options<ModelPricingListByUserData>) =>
  queryOptions<
    ModelPricingListByUserResponse,
    ModelPricingListByUserError,
    ModelPricingListByUserResponse,
    ReturnType<typeof modelPricingListByUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await modelPricingListByUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: modelPricingListByUserQueryKey(options),
  });

export const modelPricingListByUserInfiniteQueryKey = (
  options: Options<ModelPricingListByUserData>
): QueryKey<Options<ModelPricingListByUserData>> =>
  createQueryKey("modelPricingListByUser", options, true);

/**
 * List model pricing for a user
 */
export const modelPricingListByUserInfiniteOptions = (
  options: Options<ModelPricingListByUserData>
) =>
  infiniteQueryOptions<
    ModelPricingListByUserResponse,
    ModelPricingListByUserError,
    InfiniteData<ModelPricingListByUserResponse>,
    QueryKey<Options<ModelPricingListByUserData>>,
    | string
    | null
    | Pick<QueryKey<Options<ModelPricingListByUserData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ModelPricingListByUserData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await modelPricingListByUser({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: modelPricingListByUserInfiniteQueryKey(options),
    }
  );

/**
 * Revoke all sessions for a user (force logout).
 *
 * This is the critical endpoint for the "terminated employee" use case.
 * Returns 0 sessions revoked if enhanced session management is not enabled.
 */
export const userSessionsDeleteAllMutation = (
  options?: Partial<Options<UserSessionsDeleteAllData>>
): UseMutationOptions<
  UserSessionsDeleteAllResponse,
  UserSessionsDeleteAllError,
  Options<UserSessionsDeleteAllData>
> => {
  const mutationOptions: UseMutationOptions<
    UserSessionsDeleteAllResponse,
    UserSessionsDeleteAllError,
    Options<UserSessionsDeleteAllData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await userSessionsDeleteAll({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const userSessionsListQueryKey = (options: Options<UserSessionsListData>) =>
  createQueryKey("userSessionsList", options);

/**
 * List all active sessions for a user.
 *
 * Returns an empty list if enhanced session management is not enabled.
 * The `enhanced_enabled` field indicates whether session tracking is active.
 */
export const userSessionsListOptions = (options: Options<UserSessionsListData>) =>
  queryOptions<
    UserSessionsListResponse,
    UserSessionsListError,
    UserSessionsListResponse,
    ReturnType<typeof userSessionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userSessionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: userSessionsListQueryKey(options),
  });

/**
 * Revoke a specific session for a user.
 *
 * Returns success even if the session doesn't exist (idempotent).
 */
export const userSessionsDeleteOneMutation = (
  options?: Partial<Options<UserSessionsDeleteOneData>>
): UseMutationOptions<
  UserSessionsDeleteOneResponse,
  UserSessionsDeleteOneError,
  Options<UserSessionsDeleteOneData>
> => {
  const mutationOptions: UseMutationOptions<
    UserSessionsDeleteOneResponse,
    UserSessionsDeleteOneError,
    Options<UserSessionsDeleteOneData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await userSessionsDeleteOne({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const templateListByUserQueryKey = (options: Options<TemplateListByUserData>) =>
  createQueryKey("templateListByUser", options);

/**
 * List templates by user
 */
export const templateListByUserOptions = (options: Options<TemplateListByUserData>) =>
  queryOptions<
    TemplateListByUserResponse,
    TemplateListByUserError,
    TemplateListByUserResponse,
    ReturnType<typeof templateListByUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateListByUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: templateListByUserQueryKey(options),
  });

export const templateListByUserInfiniteQueryKey = (
  options: Options<TemplateListByUserData>
): QueryKey<Options<TemplateListByUserData>> => createQueryKey("templateListByUser", options, true);

/**
 * List templates by user
 */
export const templateListByUserInfiniteOptions = (options: Options<TemplateListByUserData>) =>
  infiniteQueryOptions<
    TemplateListByUserResponse,
    TemplateListByUserError,
    InfiniteData<TemplateListByUserResponse>,
    QueryKey<Options<TemplateListByUserData>>,
    | string
    | null
    | Pick<QueryKey<Options<TemplateListByUserData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TemplateListByUserData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  cursor: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await templateListByUser({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: templateListByUserInfiniteQueryKey(options),
    }
  );

export const usageGetUserSummaryQueryKey = (options: Options<UsageGetUserSummaryData>) =>
  createQueryKey("usageGetUserSummary", options);

/**
 * Get usage summary for a user
 */
export const usageGetUserSummaryOptions = (options: Options<UsageGetUserSummaryData>) =>
  queryOptions<
    UsageGetUserSummaryResponse,
    UsageGetUserSummaryError,
    UsageGetUserSummaryResponse,
    ReturnType<typeof usageGetUserSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetUserSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetUserSummaryQueryKey(options),
  });

export const usageGetUserByDateQueryKey = (options: Options<UsageGetUserByDateData>) =>
  createQueryKey("usageGetUserByDate", options);

/**
 * Get usage by date for a user
 */
export const usageGetUserByDateOptions = (options: Options<UsageGetUserByDateData>) =>
  queryOptions<
    UsageGetUserByDateResponse,
    UsageGetUserByDateError,
    UsageGetUserByDateResponse,
    ReturnType<typeof usageGetUserByDateQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetUserByDate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetUserByDateQueryKey(options),
  });

export const usageGetUserByDateModelQueryKey = (options: Options<UsageGetUserByDateModelData>) =>
  createQueryKey("usageGetUserByDateModel", options);

/**
 * Get usage by date and model for a user
 */
export const usageGetUserByDateModelOptions = (options: Options<UsageGetUserByDateModelData>) =>
  queryOptions<
    UsageGetUserByDateModelResponse,
    DefaultError,
    UsageGetUserByDateModelResponse,
    ReturnType<typeof usageGetUserByDateModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetUserByDateModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetUserByDateModelQueryKey(options),
  });

export const usageGetUserByDatePricingSourceQueryKey = (
  options: Options<UsageGetUserByDatePricingSourceData>
) => createQueryKey("usageGetUserByDatePricingSource", options);

/**
 * Get usage by date and pricing source for a user
 */
export const usageGetUserByDatePricingSourceOptions = (
  options: Options<UsageGetUserByDatePricingSourceData>
) =>
  queryOptions<
    UsageGetUserByDatePricingSourceResponse,
    DefaultError,
    UsageGetUserByDatePricingSourceResponse,
    ReturnType<typeof usageGetUserByDatePricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetUserByDatePricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetUserByDatePricingSourceQueryKey(options),
  });

export const usageGetUserByDateProviderQueryKey = (
  options: Options<UsageGetUserByDateProviderData>
) => createQueryKey("usageGetUserByDateProvider", options);

/**
 * Get usage by date and provider for a user
 */
export const usageGetUserByDateProviderOptions = (
  options: Options<UsageGetUserByDateProviderData>
) =>
  queryOptions<
    UsageGetUserByDateProviderResponse,
    DefaultError,
    UsageGetUserByDateProviderResponse,
    ReturnType<typeof usageGetUserByDateProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetUserByDateProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetUserByDateProviderQueryKey(options),
  });

export const usageGetUserByModelQueryKey = (options: Options<UsageGetUserByModelData>) =>
  createQueryKey("usageGetUserByModel", options);

/**
 * Get usage by model for a user
 */
export const usageGetUserByModelOptions = (options: Options<UsageGetUserByModelData>) =>
  queryOptions<
    UsageGetUserByModelResponse,
    UsageGetUserByModelError,
    UsageGetUserByModelResponse,
    ReturnType<typeof usageGetUserByModelQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetUserByModel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetUserByModelQueryKey(options),
  });

export const usageGetUserByPricingSourceQueryKey = (
  options: Options<UsageGetUserByPricingSourceData>
) => createQueryKey("usageGetUserByPricingSource", options);

/**
 * Get usage by pricing source for a user
 */
export const usageGetUserByPricingSourceOptions = (
  options: Options<UsageGetUserByPricingSourceData>
) =>
  queryOptions<
    UsageGetUserByPricingSourceResponse,
    DefaultError,
    UsageGetUserByPricingSourceResponse,
    ReturnType<typeof usageGetUserByPricingSourceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetUserByPricingSource({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetUserByPricingSourceQueryKey(options),
  });

export const usageGetUserByProviderQueryKey = (options: Options<UsageGetUserByProviderData>) =>
  createQueryKey("usageGetUserByProvider", options);

/**
 * Get usage by provider for a user
 */
export const usageGetUserByProviderOptions = (options: Options<UsageGetUserByProviderData>) =>
  queryOptions<
    UsageGetUserByProviderResponse,
    UsageGetUserByProviderError,
    UsageGetUserByProviderResponse,
    ReturnType<typeof usageGetUserByProviderQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetUserByProvider({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetUserByProviderQueryKey(options),
  });

export const usageGetUserForecastQueryKey = (options: Options<UsageGetUserForecastData>) =>
  createQueryKey("usageGetUserForecast", options);

/**
 * Get cost forecast for a user
 *
 * Uses historical usage data across all API keys owned by the user to predict future spending.
 * Returns average daily spend, confidence intervals, and time series forecasts.
 */
export const usageGetUserForecastOptions = (options: Options<UsageGetUserForecastData>) =>
  queryOptions<
    UsageGetUserForecastResponse,
    UsageGetUserForecastError,
    UsageGetUserForecastResponse,
    ReturnType<typeof usageGetUserForecastQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usageGetUserForecast({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: usageGetUserForecastQueryKey(options),
  });

/**
 * Generate speech from text
 *
 * POST /v1/audio/speech
 */
export const apiV1AudioSpeechMutation = (
  options?: Partial<Options<ApiV1AudioSpeechData>>
): UseMutationOptions<ApiV1AudioSpeechResponse, DefaultError, Options<ApiV1AudioSpeechData>> => {
  const mutationOptions: UseMutationOptions<
    ApiV1AudioSpeechResponse,
    DefaultError,
    Options<ApiV1AudioSpeechData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1AudioSpeech({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Transcribe audio to text
 *
 * POST /v1/audio/transcriptions
 */
export const apiV1AudioTranscriptionsMutation = (
  options?: Partial<Options<ApiV1AudioTranscriptionsData>>
): UseMutationOptions<
  ApiV1AudioTranscriptionsResponse,
  DefaultError,
  Options<ApiV1AudioTranscriptionsData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiV1AudioTranscriptionsResponse,
    DefaultError,
    Options<ApiV1AudioTranscriptionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1AudioTranscriptions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Translate audio to English text
 *
 * POST /v1/audio/translations
 */
export const apiV1AudioTranslationsMutation = (
  options?: Partial<Options<ApiV1AudioTranslationsData>>
): UseMutationOptions<
  ApiV1AudioTranslationsResponse,
  DefaultError,
  Options<ApiV1AudioTranslationsData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiV1AudioTranslationsResponse,
    DefaultError,
    Options<ApiV1AudioTranslationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1AudioTranslations({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a chat completion
 *
 * Creates a model response for the given chat conversation. Supports both streaming and
 * non-streaming responses. The model can be specified using provider prefixes (e.g.,
 * `openai/gpt-4o`) or with dynamic routing for multi-tenant configurations.
 */
export const apiV1ChatCompletionsMutation = (
  options?: Partial<Options<ApiV1ChatCompletionsData>>
): UseMutationOptions<unknown, ApiV1ChatCompletionsError, Options<ApiV1ChatCompletionsData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiV1ChatCompletionsError,
    Options<ApiV1ChatCompletionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ChatCompletions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a text completion
 *
 * Creates a completion for the provided prompt and parameters.
 */
export const apiV1CompletionsMutation = (
  options?: Partial<Options<ApiV1CompletionsData>>
): UseMutationOptions<unknown, ApiV1CompletionsError, Options<ApiV1CompletionsData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiV1CompletionsError,
    Options<ApiV1CompletionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1Completions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiV1ContainersListQueryKey = (options?: Options<ApiV1ContainersListData>) =>
  createQueryKey("apiV1ContainersList", options);

/**
 * `GET /v1/containers` — list containers in the caller's org,
 * newest-first. Matches OpenAI's cursor pagination shape.
 */
export const apiV1ContainersListOptions = (options?: Options<ApiV1ContainersListData>) =>
  queryOptions<
    unknown,
    ApiV1ContainersListError,
    unknown,
    ReturnType<typeof apiV1ContainersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1ContainersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1ContainersListQueryKey(options),
  });

export const apiV1ContainersListInfiniteQueryKey = (
  options?: Options<ApiV1ContainersListData>
): QueryKey<Options<ApiV1ContainersListData>> =>
  createQueryKey("apiV1ContainersList", options, true);

/**
 * `GET /v1/containers` — list containers in the caller's org,
 * newest-first. Matches OpenAI's cursor pagination shape.
 */
export const apiV1ContainersListInfiniteOptions = (options?: Options<ApiV1ContainersListData>) =>
  infiniteQueryOptions<
    unknown,
    ApiV1ContainersListError,
    InfiniteData<unknown>,
    QueryKey<Options<ApiV1ContainersListData>>,
    | string
    | Pick<QueryKey<Options<ApiV1ContainersListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApiV1ContainersListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await apiV1ContainersList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: apiV1ContainersListInfiniteQueryKey(options),
    }
  );

/**
 * `POST /v1/containers` — create an unattached container.
 */
export const apiV1ContainersCreateMutation = (
  options?: Partial<Options<ApiV1ContainersCreateData>>
): UseMutationOptions<unknown, ApiV1ContainersCreateError, Options<ApiV1ContainersCreateData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiV1ContainersCreateError,
    Options<ApiV1ContainersCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ContainersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * `DELETE /v1/containers/{container_id}` — soft-delete a container.
 *
 * Sets `status='deleted'` and evicts the matching in-memory session
 * from the registry so the VM is torn down on the next Arc drop.
 * The underlying `container_files` rows cascade-delete with the
 * container row.
 */
export const apiV1ContainersDeleteMutation = (
  options?: Partial<Options<ApiV1ContainersDeleteData>>
): UseMutationOptions<
  ApiV1ContainersDeleteResponse,
  ApiV1ContainersDeleteError,
  Options<ApiV1ContainersDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiV1ContainersDeleteResponse,
    ApiV1ContainersDeleteError,
    Options<ApiV1ContainersDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ContainersDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiV1ContainersGetQueryKey = (options: Options<ApiV1ContainersGetData>) =>
  createQueryKey("apiV1ContainersGet", options);

/**
 * `GET /v1/containers/{container_id}` — retrieve a container.
 */
export const apiV1ContainersGetOptions = (options: Options<ApiV1ContainersGetData>) =>
  queryOptions<
    unknown,
    ApiV1ContainersGetError,
    unknown,
    ReturnType<typeof apiV1ContainersGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1ContainersGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1ContainersGetQueryKey(options),
  });

export const apiV1ContainersListFilesQueryKey = (options: Options<ApiV1ContainersListFilesData>) =>
  createQueryKey("apiV1ContainersListFiles", options);

/**
 * `GET /v1/containers/{container_id}/files` — list files.
 */
export const apiV1ContainersListFilesOptions = (options: Options<ApiV1ContainersListFilesData>) =>
  queryOptions<
    unknown,
    ApiV1ContainersListFilesError,
    unknown,
    ReturnType<typeof apiV1ContainersListFilesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1ContainersListFiles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1ContainersListFilesQueryKey(options),
  });

/**
 * `POST /v1/containers/{container_id}/files` — upload a file into a
 * container's `/mnt/data`. Accepts either:
 *
 * - `multipart/form-data` with a `file` part (required) and optional
 * `path` / `content_type` parts — streams bytes directly.
 * - `application/json` with `{file_id: "file_..."}` — copies an
 * existing Files-API upload into the container (same resolver as
 * the `file_ids` array on `POST /v1/containers`).
 *
 * Matches OpenAI's upload contract.
 */
export const apiV1ContainersFileUploadMutation = (
  options?: Partial<Options<ApiV1ContainersFileUploadData>>
): UseMutationOptions<
  unknown,
  ApiV1ContainersFileUploadError,
  Options<ApiV1ContainersFileUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiV1ContainersFileUploadError,
    Options<ApiV1ContainersFileUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ContainersFileUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * `DELETE /v1/containers/{container_id}/files/{file_id}` — remove
 * a file from a container.
 */
export const apiV1ContainersFileDeleteMutation = (
  options?: Partial<Options<ApiV1ContainersFileDeleteData>>
): UseMutationOptions<
  ApiV1ContainersFileDeleteResponse,
  ApiV1ContainersFileDeleteError,
  Options<ApiV1ContainersFileDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiV1ContainersFileDeleteResponse,
    ApiV1ContainersFileDeleteError,
    Options<ApiV1ContainersFileDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ContainersFileDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiV1ContainersFileGetQueryKey = (options: Options<ApiV1ContainersFileGetData>) =>
  createQueryKey("apiV1ContainersFileGet", options);

/**
 * `GET /v1/containers/{container_id}/files/{file_id}` — file metadata.
 */
export const apiV1ContainersFileGetOptions = (options: Options<ApiV1ContainersFileGetData>) =>
  queryOptions<
    unknown,
    ApiV1ContainersFileGetError,
    unknown,
    ReturnType<typeof apiV1ContainersFileGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1ContainersFileGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1ContainersFileGetQueryKey(options),
  });

export const apiV1ContainersFileContentQueryKey = (
  options: Options<ApiV1ContainersFileContentData>
) => createQueryKey("apiV1ContainersFileContent", options);

/**
 * `GET /v1/containers/{container_id}/files/{file_id}/content` — raw bytes.
 */
export const apiV1ContainersFileContentOptions = (
  options: Options<ApiV1ContainersFileContentData>
) =>
  queryOptions<
    unknown,
    ApiV1ContainersFileContentError,
    unknown,
    ReturnType<typeof apiV1ContainersFileContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1ContainersFileContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1ContainersFileContentQueryKey(options),
  });

/**
 * Create embeddings
 *
 * Creates an embedding vector representing the input text. Embeddings are useful for
 * semantic search, clustering, classification, and similarity comparisons.
 */
export const apiV1EmbeddingsMutation = (
  options?: Partial<Options<ApiV1EmbeddingsData>>
): UseMutationOptions<unknown, ApiV1EmbeddingsError, Options<ApiV1EmbeddingsData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiV1EmbeddingsError,
    Options<ApiV1EmbeddingsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1Embeddings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const fileListQueryKey = (options: Options<FileListData>) =>
  createQueryKey("fileList", options);

/**
 * List files
 *
 * Returns a list of files owned by the specified owner.
 */
export const fileListOptions = (options: Options<FileListData>) =>
  queryOptions<
    FileListResponse2,
    FileListError,
    FileListResponse2,
    ReturnType<typeof fileListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: fileListQueryKey(options),
  });

export const fileListInfiniteQueryKey = (
  options: Options<FileListData>
): QueryKey<Options<FileListData>> => createQueryKey("fileList", options, true);

/**
 * List files
 *
 * Returns a list of files owned by the specified owner.
 */
export const fileListInfiniteOptions = (options: Options<FileListData>) =>
  infiniteQueryOptions<
    FileListResponse2,
    FileListError,
    InfiniteData<FileListResponse2>,
    QueryKey<Options<FileListData>>,
    string | null | Pick<QueryKey<Options<FileListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<FileListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await fileList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: fileListInfiniteQueryKey(options),
    }
  );

/**
 * Upload a file
 *
 * Uploads a file that can be used with vector stores for RAG.
 * Files are uploaded as multipart/form-data with the following fields:
 * - `file`: The file to upload (required)
 * - `purpose`: The intended purpose of the file (default: "assistants")
 * - `owner_type`: Owner type - "organization", "project", or "user" (required)
 * - `owner_id`: Owner ID (required)
 */
export const fileUploadMutation = (
  options?: Partial<Options<FileUploadData>>
): UseMutationOptions<FileUploadResponse, FileUploadError, Options<FileUploadData>> => {
  const mutationOptions: UseMutationOptions<
    FileUploadResponse,
    FileUploadError,
    Options<FileUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await fileUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a file
 *
 * Deletes a file. The file cannot be deleted if it is still referenced by any vector stores.
 */
export const fileDeleteMutation = (
  options?: Partial<Options<FileDeleteData>>
): UseMutationOptions<FileDeleteResponse, FileDeleteError, Options<FileDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    FileDeleteResponse,
    FileDeleteError,
    Options<FileDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await fileDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const fileGetQueryKey = (options: Options<FileGetData>) =>
  createQueryKey("fileGet", options);

/**
 * Get file metadata
 *
 * Returns information about a specific file.
 */
export const fileGetOptions = (options: Options<FileGetData>) =>
  queryOptions<FileGetResponse, FileGetError, FileGetResponse, ReturnType<typeof fileGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: fileGetQueryKey(options),
  });

export const fileGetContentQueryKey = (options: Options<FileGetContentData>) =>
  createQueryKey("fileGetContent", options);

/**
 * Get file content
 *
 * Returns the content of a file.
 */
export const fileGetContentOptions = (options: Options<FileGetContentData>) =>
  queryOptions<
    FileGetContentResponse,
    FileGetContentError,
    FileGetContentResponse,
    ReturnType<typeof fileGetContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileGetContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: fileGetContentQueryKey(options),
  });

/**
 * Edit image with text instructions
 *
 * POST /v1/images/edits
 */
export const apiV1ImagesEditsMutation = (
  options?: Partial<Options<ApiV1ImagesEditsData>>
): UseMutationOptions<ApiV1ImagesEditsResponse, DefaultError, Options<ApiV1ImagesEditsData>> => {
  const mutationOptions: UseMutationOptions<
    ApiV1ImagesEditsResponse,
    DefaultError,
    Options<ApiV1ImagesEditsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ImagesEdits({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create image from text prompt
 *
 * POST /v1/images/generations
 */
export const apiV1ImagesGenerationsMutation = (
  options?: Partial<Options<ApiV1ImagesGenerationsData>>
): UseMutationOptions<
  ApiV1ImagesGenerationsResponse,
  DefaultError,
  Options<ApiV1ImagesGenerationsData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiV1ImagesGenerationsResponse,
    DefaultError,
    Options<ApiV1ImagesGenerationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ImagesGenerations({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create image variations
 *
 * POST /v1/images/variations
 */
export const apiV1ImagesVariationsMutation = (
  options?: Partial<Options<ApiV1ImagesVariationsData>>
): UseMutationOptions<
  ApiV1ImagesVariationsResponse,
  DefaultError,
  Options<ApiV1ImagesVariationsData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiV1ImagesVariationsResponse,
    DefaultError,
    Options<ApiV1ImagesVariationsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ImagesVariations({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiV1ModelsQueryKey = (options?: Options<ApiV1ModelsData>) =>
  createQueryKey("apiV1Models", options);

/**
 * List available models
 *
 * Lists all models available from all configured providers.
 */
export const apiV1ModelsOptions = (options?: Options<ApiV1ModelsData>) =>
  queryOptions<
    ApiV1ModelsResponse,
    ApiV1ModelsError,
    ApiV1ModelsResponse,
    ReturnType<typeof apiV1ModelsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1Models({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1ModelsQueryKey(options),
  });

/**
 * Create a response
 *
 * Creates a model response using the Responses API format.
 */
export const apiV1ResponsesMutation = (
  options?: Partial<Options<ApiV1ResponsesData>>
): UseMutationOptions<unknown, ApiV1ResponsesError, Options<ApiV1ResponsesData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiV1ResponsesError,
    Options<ApiV1ResponsesData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1Responses({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Compact a context window via the provider's standalone compact
 * endpoint.
 *
 * Stateless passthrough: forwards `model` + `input` (and any other
 * fields the provider accepts) to the upstream `/responses/compact`
 * endpoint and streams the compacted window back. Only OpenAI and
 * Azure OpenAI implement this; routing to any other provider returns
 * 501 with `error_code = "not_supported"`.
 */
export const apiV1ResponsesCompactMutation = (
  options?: Partial<Options<ApiV1ResponsesCompactData>>
): UseMutationOptions<unknown, ApiV1ResponsesCompactError, Options<ApiV1ResponsesCompactData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiV1ResponsesCompactError,
    Options<ApiV1ResponsesCompactData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ResponsesCompact({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * `DELETE /v1/responses/{response_id}` — remove a stored response.
 * Returns the OpenAI-spec deletion confirmation shape.
 */
export const apiV1ResponsesDeleteMutation = (
  options?: Partial<Options<ApiV1ResponsesDeleteData>>
): UseMutationOptions<unknown, ApiV1ResponsesDeleteError, Options<ApiV1ResponsesDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiV1ResponsesDeleteError,
    Options<ApiV1ResponsesDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ResponsesDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiV1ResponsesGetQueryKey = (options: Options<ApiV1ResponsesGetData>) =>
  createQueryKey("apiV1ResponsesGet", options);

/**
 * `GET /v1/responses/{response_id}` — retrieve a stored response.
 *
 * When `?stream=true` is set, returns the persisted event log as an
 * SSE stream (matching OpenAI's retrieve-with-stream behavior). The
 * `starting_after` query parameter resumes replay from a specific
 * sequence number so a client reconnecting after a disconnect picks
 * up exactly where it stopped.
 */
export const apiV1ResponsesGetOptions = (options: Options<ApiV1ResponsesGetData>) =>
  queryOptions<
    unknown,
    ApiV1ResponsesGetError,
    unknown,
    ReturnType<typeof apiV1ResponsesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1ResponsesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1ResponsesGetQueryKey(options),
  });

/**
 * `POST /v1/responses/{response_id}/cancel` — cancel an in-progress
 * background response. Per OpenAI's spec, returns 400 if the response
 * is not in background mode. Idempotent for already-terminal rows.
 */
export const apiV1ResponsesCancelMutation = (
  options?: Partial<Options<ApiV1ResponsesCancelData>>
): UseMutationOptions<unknown, ApiV1ResponsesCancelError, Options<ApiV1ResponsesCancelData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ApiV1ResponsesCancelError,
    Options<ApiV1ResponsesCancelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1ResponsesCancel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const skillListQueryKey = (options?: Options<SkillListData>) =>
  createQueryKey("skillList", options);

/**
 * List skills for the current project (or a specific owner / accessible set).
 */
export const skillListOptions = (options?: Options<SkillListData>) =>
  queryOptions<
    SkillListResponse,
    SkillListError,
    SkillListResponse,
    ReturnType<typeof skillListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await skillList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: skillListQueryKey(options),
  });

export const skillListInfiniteQueryKey = (
  options?: Options<SkillListData>
): QueryKey<Options<SkillListData>> => createQueryKey("skillList", options, true);

/**
 * List skills for the current project (or a specific owner / accessible set).
 */
export const skillListInfiniteOptions = (options?: Options<SkillListData>) =>
  infiniteQueryOptions<
    SkillListResponse,
    SkillListError,
    InfiniteData<SkillListResponse>,
    QueryKey<Options<SkillListData>>,
    string | null | Pick<QueryKey<Options<SkillListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SkillListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await skillList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: skillListInfiniteQueryKey(options),
    }
  );

/**
 * Create a new skill (and its first version).
 */
export const skillCreateMutation = (
  options?: Partial<Options<SkillCreateData>>
): UseMutationOptions<SkillCreateResponse, SkillCreateError, Options<SkillCreateData>> => {
  const mutationOptions: UseMutationOptions<
    SkillCreateResponse,
    SkillCreateError,
    Options<SkillCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await skillCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a skill.
 */
export const skillDeleteMutation = (
  options?: Partial<Options<SkillDeleteData>>
): UseMutationOptions<SkillDeleteResponse, SkillDeleteError, Options<SkillDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    SkillDeleteResponse,
    SkillDeleteError,
    Options<SkillDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await skillDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const skillGetQueryKey = (options: Options<SkillGetData>) =>
  createQueryKey("skillGet", options);

/**
 * Get a skill by id.
 */
export const skillGetOptions = (options: Options<SkillGetData>) =>
  queryOptions<
    SkillGetResponse,
    SkillGetError,
    SkillGetResponse,
    ReturnType<typeof skillGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await skillGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: skillGetQueryKey(options),
  });

/**
 * Set the default version pointer for a skill.
 */
export const skillSetDefaultVersionMutation = (
  options?: Partial<Options<SkillSetDefaultVersionData>>
): UseMutationOptions<
  SkillSetDefaultVersionResponse,
  SkillSetDefaultVersionError,
  Options<SkillSetDefaultVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    SkillSetDefaultVersionResponse,
    SkillSetDefaultVersionError,
    Options<SkillSetDefaultVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await skillSetDefaultVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const skillGetContentQueryKey = (options: Options<SkillGetContentData>) =>
  createQueryKey("skillGetContent", options);

/**
 * Download the default version of a skill as a zip bundle.
 */
export const skillGetContentOptions = (options: Options<SkillGetContentData>) =>
  queryOptions<
    SkillGetContentResponse,
    SkillGetContentError,
    SkillGetContentResponse,
    ReturnType<typeof skillGetContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await skillGetContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: skillGetContentQueryKey(options),
  });

export const skillListVersionsQueryKey = (options: Options<SkillListVersionsData>) =>
  createQueryKey("skillListVersions", options);

/**
 * List a skill's versions.
 */
export const skillListVersionsOptions = (options: Options<SkillListVersionsData>) =>
  queryOptions<
    SkillListVersionsResponse,
    SkillListVersionsError,
    SkillListVersionsResponse,
    ReturnType<typeof skillListVersionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await skillListVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: skillListVersionsQueryKey(options),
  });

export const skillListVersionsInfiniteQueryKey = (
  options: Options<SkillListVersionsData>
): QueryKey<Options<SkillListVersionsData>> => createQueryKey("skillListVersions", options, true);

/**
 * List a skill's versions.
 */
export const skillListVersionsInfiniteOptions = (options: Options<SkillListVersionsData>) =>
  infiniteQueryOptions<
    SkillListVersionsResponse,
    SkillListVersionsError,
    InfiniteData<SkillListVersionsResponse>,
    QueryKey<Options<SkillListVersionsData>>,
    | string
    | null
    | Pick<QueryKey<Options<SkillListVersionsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SkillListVersionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await skillListVersions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: skillListVersionsInfiniteQueryKey(options),
    }
  );

/**
 * Create a new immutable version of a skill.
 */
export const skillCreateVersionMutation = (
  options?: Partial<Options<SkillCreateVersionData>>
): UseMutationOptions<
  SkillCreateVersionResponse,
  SkillCreateVersionError,
  Options<SkillCreateVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    SkillCreateVersionResponse,
    SkillCreateVersionError,
    Options<SkillCreateVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await skillCreateVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a skill version.
 */
export const skillDeleteVersionMutation = (
  options?: Partial<Options<SkillDeleteVersionData>>
): UseMutationOptions<
  SkillDeleteVersionResponse,
  SkillDeleteVersionError,
  Options<SkillDeleteVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    SkillDeleteVersionResponse,
    SkillDeleteVersionError,
    Options<SkillDeleteVersionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await skillDeleteVersion({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const skillGetVersionQueryKey = (options: Options<SkillGetVersionData>) =>
  createQueryKey("skillGetVersion", options);

/**
 * Get a specific skill version.
 */
export const skillGetVersionOptions = (options: Options<SkillGetVersionData>) =>
  queryOptions<
    SkillGetVersionResponse,
    SkillGetVersionError,
    SkillGetVersionResponse,
    ReturnType<typeof skillGetVersionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await skillGetVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: skillGetVersionQueryKey(options),
  });

export const skillGetVersionContentQueryKey = (options: Options<SkillGetVersionContentData>) =>
  createQueryKey("skillGetVersionContent", options);

/**
 * Download a specific skill version as a zip bundle.
 */
export const skillGetVersionContentOptions = (options: Options<SkillGetVersionContentData>) =>
  queryOptions<
    SkillGetVersionContentResponse,
    SkillGetVersionContentError,
    SkillGetVersionContentResponse,
    ReturnType<typeof skillGetVersionContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await skillGetVersionContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: skillGetVersionContentQueryKey(options),
  });

/**
 * Fetch a web page
 *
 * Fetches a URL and returns its content, optionally stripping HTML tags.
 *
 * **Hadrian Extension:** This endpoint is not part of the OpenAI API specification.
 */
export const webFetchMutation = (
  options?: Partial<Options<WebFetchData>>
): UseMutationOptions<WebFetchResponse2, DefaultError, Options<WebFetchData>> => {
  const mutationOptions: UseMutationOptions<
    WebFetchResponse2,
    DefaultError,
    Options<WebFetchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await webFetch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Search the web
 *
 * Performs a web search using the configured search provider (Tavily or Exa).
 *
 * **Hadrian Extension:** This endpoint is not part of the OpenAI API specification.
 */
export const webSearchMutation = (
  options?: Partial<Options<WebSearchData>>
): UseMutationOptions<WebSearchResponse2, DefaultError, Options<WebSearchData>> => {
  const mutationOptions: UseMutationOptions<
    WebSearchResponse2,
    DefaultError,
    Options<WebSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await webSearch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const vectorStoreListQueryKey = (options?: Options<VectorStoreListData>) =>
  createQueryKey("vectorStoreList", options);

/**
 * List vector stores
 *
 * Returns a list of vector stores owned by the specified owner.
 */
export const vectorStoreListOptions = (options?: Options<VectorStoreListData>) =>
  queryOptions<
    VectorStoreListResponse2,
    VectorStoreListError,
    VectorStoreListResponse2,
    ReturnType<typeof vectorStoreListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vectorStoreList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: vectorStoreListQueryKey(options),
  });

export const vectorStoreListInfiniteQueryKey = (
  options?: Options<VectorStoreListData>
): QueryKey<Options<VectorStoreListData>> => createQueryKey("vectorStoreList", options, true);

/**
 * List vector stores
 *
 * Returns a list of vector stores owned by the specified owner.
 */
export const vectorStoreListInfiniteOptions = (options?: Options<VectorStoreListData>) =>
  infiniteQueryOptions<
    VectorStoreListResponse2,
    VectorStoreListError,
    InfiniteData<VectorStoreListResponse2>,
    QueryKey<Options<VectorStoreListData>>,
    | string
    | null
    | Pick<QueryKey<Options<VectorStoreListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<VectorStoreListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await vectorStoreList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: vectorStoreListInfiniteQueryKey(options),
    }
  );

/**
 * Create a vector store
 *
 * Creates a new vector store for storing file embeddings.
 * Optionally attaches files to the vector store at creation time via `file_ids`.
 */
export const vectorStoreCreateMutation = (
  options?: Partial<Options<VectorStoreCreateData>>
): UseMutationOptions<
  VectorStoreCreateResponse,
  VectorStoreCreateError,
  Options<VectorStoreCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    VectorStoreCreateResponse,
    VectorStoreCreateError,
    Options<VectorStoreCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await vectorStoreCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a vector store
 *
 * Deletes a vector store and all its files (soft delete).
 */
export const vectorStoreDeleteMutation = (
  options?: Partial<Options<VectorStoreDeleteData>>
): UseMutationOptions<
  VectorStoreDeleteResponse,
  VectorStoreDeleteError,
  Options<VectorStoreDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    VectorStoreDeleteResponse,
    VectorStoreDeleteError,
    Options<VectorStoreDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await vectorStoreDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const vectorStoreGetQueryKey = (options: Options<VectorStoreGetData>) =>
  createQueryKey("vectorStoreGet", options);

/**
 * Get a vector store
 *
 * Retrieves a vector store by ID.
 */
export const vectorStoreGetOptions = (options: Options<VectorStoreGetData>) =>
  queryOptions<
    VectorStoreGetResponse,
    VectorStoreGetError,
    VectorStoreGetResponse,
    ReturnType<typeof vectorStoreGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vectorStoreGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: vectorStoreGetQueryKey(options),
  });

/**
 * Modify a vector store
 *
 * Modifies a vector store's metadata.
 */
export const vectorStoreModifyMutation = (
  options?: Partial<Options<VectorStoreModifyData>>
): UseMutationOptions<
  VectorStoreModifyResponse,
  VectorStoreModifyError,
  Options<VectorStoreModifyData>
> => {
  const mutationOptions: UseMutationOptions<
    VectorStoreModifyResponse,
    VectorStoreModifyError,
    Options<VectorStoreModifyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await vectorStoreModify({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a file batch
 *
 * Creates a batch of files to be added to a vector store.
 * Note: File batches are not yet fully implemented. This endpoint creates
 * files individually and returns a batch representation.
 *
 * ## Content Deduplication
 *
 * Files are deduplicated by content hash (SHA-256). If a file with identical content
 * already exists in the vector store, it is counted as "completed" in the batch
 * response but no re-processing occurs. This prevents duplicate chunks and wasted
 * compute while still reporting success for the file.
 *
 * The `file_counts.completed` field in the response includes both newly processed
 * files and deduplicated files.
 *
 * ## Embedding Model Validation
 *
 * The gateway validates that its configured embedding model matches the vector store's
 * embedding model before processing any files in the batch. This prevents incompatible
 * embeddings from being stored together. If there's a mismatch, a 409 Conflict error
 * is returned with details about the expected vs. configured models.
 */
export const vectorStoreFileBatchCreateMutation = (
  options?: Partial<Options<VectorStoreFileBatchCreateData>>
): UseMutationOptions<
  VectorStoreFileBatchCreateResponse,
  VectorStoreFileBatchCreateError,
  Options<VectorStoreFileBatchCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    VectorStoreFileBatchCreateResponse,
    VectorStoreFileBatchCreateError,
    Options<VectorStoreFileBatchCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await vectorStoreFileBatchCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Cancel a file batch
 *
 * Cancels a file batch. Note: File batches are executed synchronously,
 * so cancellation is not supported.
 */
export const vectorStoreFileBatchCancelMutation = (
  options?: Partial<Options<VectorStoreFileBatchCancelData>>
): UseMutationOptions<
  unknown,
  VectorStoreFileBatchCancelError,
  Options<VectorStoreFileBatchCancelData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    VectorStoreFileBatchCancelError,
    Options<VectorStoreFileBatchCancelData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await vectorStoreFileBatchCancel({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const vectorStoreFileBatchGetQueryKey = (options: Options<VectorStoreFileBatchGetData>) =>
  createQueryKey("vectorStoreFileBatchGet", options);

/**
 * Get a file batch
 *
 * Retrieves a file batch. Note: File batches are executed synchronously,
 * so this endpoint returns a "completed" or "failed" status.
 */
export const vectorStoreFileBatchGetOptions = (options: Options<VectorStoreFileBatchGetData>) =>
  queryOptions<
    unknown,
    VectorStoreFileBatchGetError,
    unknown,
    ReturnType<typeof vectorStoreFileBatchGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vectorStoreFileBatchGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: vectorStoreFileBatchGetQueryKey(options),
  });

export const vectorStoreFileBatchListFilesQueryKey = (
  options: Options<VectorStoreFileBatchListFilesData>
) => createQueryKey("vectorStoreFileBatchListFiles", options);

/**
 * List files in a batch
 *
 * Lists files in a file batch. Note: File batches are not persisted.
 */
export const vectorStoreFileBatchListFilesOptions = (
  options: Options<VectorStoreFileBatchListFilesData>
) =>
  queryOptions<
    unknown,
    VectorStoreFileBatchListFilesError,
    unknown,
    ReturnType<typeof vectorStoreFileBatchListFilesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vectorStoreFileBatchListFiles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: vectorStoreFileBatchListFilesQueryKey(options),
  });

export const vectorStoreFileListQueryKey = (options: Options<VectorStoreFileListData>) =>
  createQueryKey("vectorStoreFileList", options);

/**
 * List vector store files
 *
 * Returns a list of files in a vector store.
 */
export const vectorStoreFileListOptions = (options: Options<VectorStoreFileListData>) =>
  queryOptions<
    VectorStoreFileListResponse2,
    VectorStoreFileListError,
    VectorStoreFileListResponse2,
    ReturnType<typeof vectorStoreFileListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vectorStoreFileList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: vectorStoreFileListQueryKey(options),
  });

export const vectorStoreFileListInfiniteQueryKey = (
  options: Options<VectorStoreFileListData>
): QueryKey<Options<VectorStoreFileListData>> =>
  createQueryKey("vectorStoreFileList", options, true);

/**
 * List vector store files
 *
 * Returns a list of files in a vector store.
 */
export const vectorStoreFileListInfiniteOptions = (options: Options<VectorStoreFileListData>) =>
  infiniteQueryOptions<
    VectorStoreFileListResponse2,
    VectorStoreFileListError,
    InfiniteData<VectorStoreFileListResponse2>,
    QueryKey<Options<VectorStoreFileListData>>,
    | string
    | null
    | Pick<QueryKey<Options<VectorStoreFileListData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<VectorStoreFileListData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  after: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await vectorStoreFileList({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: vectorStoreFileListInfiniteQueryKey(options),
    }
  );

/**
 * Create a vector store file
 *
 * Adds a file to a vector store. The file must already exist in the Files API.
 * Processing will start automatically after the file is added.
 *
 * ## Content Deduplication
 *
 * Files are deduplicated by content hash (SHA-256). If a file with identical content
 * already exists in the vector store, the existing file is returned with status 200
 * instead of creating a duplicate. This is idempotent behavior—uploading the same
 * content multiple times has no additional effect.
 *
 * ## Embedding Model Validation
 *
 * The gateway validates that its configured embedding model matches the vector store's
 * embedding model before adding files. This prevents incompatible embeddings from being
 * stored together. If there's a mismatch, a 409 Conflict error is returned with details
 * about the expected vs. configured models.
 *
 * - **201 Created**: New file added, processing started
 * - **200 OK**: Duplicate content detected, existing file returned (no re-processing)
 * - **409 Conflict**: Embedding model mismatch between gateway configuration and vector store
 */
export const vectorStoreFileCreateMutation = (
  options?: Partial<Options<VectorStoreFileCreateData>>
): UseMutationOptions<
  VectorStoreFileCreateResponse,
  VectorStoreFileCreateError,
  Options<VectorStoreFileCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    VectorStoreFileCreateResponse,
    VectorStoreFileCreateError,
    Options<VectorStoreFileCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await vectorStoreFileCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a vector store file
 *
 * Removes a file from a vector store. This does not delete the underlying file
 * from the Files API.
 */
export const vectorStoreFileDeleteMutation = (
  options?: Partial<Options<VectorStoreFileDeleteData>>
): UseMutationOptions<
  VectorStoreFileDeleteResponse,
  VectorStoreFileDeleteError,
  Options<VectorStoreFileDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    VectorStoreFileDeleteResponse,
    VectorStoreFileDeleteError,
    Options<VectorStoreFileDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await vectorStoreFileDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const vectorStoreFileGetQueryKey = (options: Options<VectorStoreFileGetData>) =>
  createQueryKey("vectorStoreFileGet", options);

/**
 * Get a vector store file
 *
 * Retrieves a file from a vector store.
 */
export const vectorStoreFileGetOptions = (options: Options<VectorStoreFileGetData>) =>
  queryOptions<
    VectorStoreFileGetResponse,
    VectorStoreFileGetError,
    VectorStoreFileGetResponse,
    ReturnType<typeof vectorStoreFileGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vectorStoreFileGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: vectorStoreFileGetQueryKey(options),
  });

export const vectorStoreFileChunksListQueryKey = (
  options: Options<VectorStoreFileChunksListData>
) => createQueryKey("vectorStoreFileChunksList", options);

/**
 * List chunks for a file [Hadrian Extension]
 *
 * **Hadrian Extension** - This endpoint is not part of the standard OpenAI API.
 *
 * Returns all chunks that have been extracted and embedded from a file. Useful for debugging chunking behavior and verifying embeddings.
 */
export const vectorStoreFileChunksListOptions = (options: Options<VectorStoreFileChunksListData>) =>
  queryOptions<
    VectorStoreFileChunksListResponse,
    VectorStoreFileChunksListError,
    VectorStoreFileChunksListResponse,
    ReturnType<typeof vectorStoreFileChunksListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vectorStoreFileChunksList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: vectorStoreFileChunksListQueryKey(options),
  });

/**
 * Search vector store
 *
 * Performs a semantic search against a vector store.
 *
 * **Hadrian Extensions:** The response schema includes additional fields not in the standard OpenAI API:
 * - `chunk_id`, `vector_store_id`, `chunk_index` (debugging info)
 */
export const vectorStoreSearchMutation = (
  options?: Partial<Options<VectorStoreSearchData>>
): UseMutationOptions<
  VectorStoreSearchResponse2,
  VectorStoreSearchError,
  Options<VectorStoreSearchData>
> => {
  const mutationOptions: UseMutationOptions<
    VectorStoreSearchResponse2,
    VectorStoreSearchError,
    Options<VectorStoreSearchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await vectorStoreSearch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiV1VideosListQueryKey = (options?: Options<ApiV1VideosListData>) =>
  createQueryKey("apiV1VideosList", options);

/**
 * List video jobs
 *
 * GET /v1/videos
 */
export const apiV1VideosListOptions = (options?: Options<ApiV1VideosListData>) =>
  queryOptions<
    ApiV1VideosListResponse,
    DefaultError,
    ApiV1VideosListResponse,
    ReturnType<typeof apiV1VideosListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1VideosList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1VideosListQueryKey(options),
  });

/**
 * Create a video generation job
 *
 * POST /v1/videos
 */
export const apiV1VideosCreateMutation = (
  options?: Partial<Options<ApiV1VideosCreateData>>
): UseMutationOptions<ApiV1VideosCreateResponse, DefaultError, Options<ApiV1VideosCreateData>> => {
  const mutationOptions: UseMutationOptions<
    ApiV1VideosCreateResponse,
    DefaultError,
    Options<ApiV1VideosCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1VideosCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a character from a reference video
 *
 * POST /v1/videos/characters (multipart/form-data: name, video, [model])
 */
export const apiV1VideosCharactersCreateMutation = (
  options?: Partial<Options<ApiV1VideosCharactersCreateData>>
): UseMutationOptions<
  ApiV1VideosCharactersCreateResponse,
  DefaultError,
  Options<ApiV1VideosCharactersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiV1VideosCharactersCreateResponse,
    DefaultError,
    Options<ApiV1VideosCharactersCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1VideosCharactersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiV1VideosCharactersRetrieveQueryKey = (
  options: Options<ApiV1VideosCharactersRetrieveData>
) => createQueryKey("apiV1VideosCharactersRetrieve", options);

/**
 * Retrieve a character
 *
 * GET /v1/videos/characters/{character_id}
 */
export const apiV1VideosCharactersRetrieveOptions = (
  options: Options<ApiV1VideosCharactersRetrieveData>
) =>
  queryOptions<
    ApiV1VideosCharactersRetrieveResponse,
    DefaultError,
    ApiV1VideosCharactersRetrieveResponse,
    ReturnType<typeof apiV1VideosCharactersRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1VideosCharactersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1VideosCharactersRetrieveQueryKey(options),
  });

/**
 * Edit a video into a new job
 *
 * POST /v1/videos/edits
 */
export const apiV1VideosEditsMutation = (
  options?: Partial<Options<ApiV1VideosEditsData>>
): UseMutationOptions<ApiV1VideosEditsResponse, DefaultError, Options<ApiV1VideosEditsData>> => {
  const mutationOptions: UseMutationOptions<
    ApiV1VideosEditsResponse,
    DefaultError,
    Options<ApiV1VideosEditsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1VideosEdits({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Extend a video into a new job
 *
 * POST /v1/videos/extensions
 */
export const apiV1VideosExtensionsMutation = (
  options?: Partial<Options<ApiV1VideosExtensionsData>>
): UseMutationOptions<
  ApiV1VideosExtensionsResponse,
  DefaultError,
  Options<ApiV1VideosExtensionsData>
> => {
  const mutationOptions: UseMutationOptions<
    ApiV1VideosExtensionsResponse,
    DefaultError,
    Options<ApiV1VideosExtensionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1VideosExtensions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete a video job
 *
 * DELETE /v1/videos/{video_id}
 */
export const apiV1VideosDeleteMutation = (
  options?: Partial<Options<ApiV1VideosDeleteData>>
): UseMutationOptions<ApiV1VideosDeleteResponse, DefaultError, Options<ApiV1VideosDeleteData>> => {
  const mutationOptions: UseMutationOptions<
    ApiV1VideosDeleteResponse,
    DefaultError,
    Options<ApiV1VideosDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1VideosDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const apiV1VideosRetrieveQueryKey = (options: Options<ApiV1VideosRetrieveData>) =>
  createQueryKey("apiV1VideosRetrieve", options);

/**
 * Retrieve a video job (refreshes status from the provider)
 *
 * GET /v1/videos/{video_id}
 */
export const apiV1VideosRetrieveOptions = (options: Options<ApiV1VideosRetrieveData>) =>
  queryOptions<
    ApiV1VideosRetrieveResponse,
    DefaultError,
    ApiV1VideosRetrieveResponse,
    ReturnType<typeof apiV1VideosRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1VideosRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1VideosRetrieveQueryKey(options),
  });

export const apiV1VideosContentQueryKey = (options: Options<ApiV1VideosContentData>) =>
  createQueryKey("apiV1VideosContent", options);

/**
 * Download the rendered asset for a video job
 *
 * GET /v1/videos/{video_id}/content
 */
export const apiV1VideosContentOptions = (options: Options<ApiV1VideosContentData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof apiV1VideosContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await apiV1VideosContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: apiV1VideosContentQueryKey(options),
  });

/**
 * Remix a video into a new job
 *
 * POST /v1/videos/{video_id}/remix
 */
export const apiV1VideosRemixMutation = (
  options?: Partial<Options<ApiV1VideosRemixData>>
): UseMutationOptions<ApiV1VideosRemixResponse, DefaultError, Options<ApiV1VideosRemixData>> => {
  const mutationOptions: UseMutationOptions<
    ApiV1VideosRemixResponse,
    DefaultError,
    Options<ApiV1VideosRemixData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await apiV1VideosRemix({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const authDiscoverQueryKey = (options: Options<AuthDiscoverData>) =>
  createQueryKey("authDiscover", options);

/**
 * Discover SSO configuration for an email address.
 *
 * This endpoint allows the frontend to determine which IdP to use for login
 * based on the user's email domain. If the email domain matches an organization
 * with SSO configured, the response includes the organization details and IdP info.
 *
 * SSO is only available when the email domain has been verified via DNS TXT record.
 * The response includes domain verification status to help users understand why
 * SSO may not be available.
 */
export const authDiscoverOptions = (options: Options<AuthDiscoverData>) =>
  queryOptions<
    AuthDiscoverResponse,
    AuthDiscoverError,
    AuthDiscoverResponse,
    ReturnType<typeof authDiscoverQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authDiscover({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: authDiscoverQueryKey(options),
  });

export const authMeQueryKey = (options?: Options<AuthMeData>) => createQueryKey("authMe", options);

/**
 * Get current user identity.
 */
export const authMeOptions = (options?: Options<AuthMeData>) =>
  queryOptions<AuthMeResponse, AuthMeError, AuthMeResponse, ReturnType<typeof authMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authMe({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: authMeQueryKey(options),
  });

export const healthCheckQueryKey = (options?: Options<HealthCheckData>) =>
  createQueryKey("healthCheck", options);

/**
 * Full health check with subsystem status.
 *
 * Returns detailed status of all subsystems including database, cache, and secrets manager.
 * Use this endpoint for comprehensive health monitoring and dashboards.
 */
export const healthCheckOptions = (options?: Options<HealthCheckData>) =>
  queryOptions<
    HealthCheckResponse,
    HealthCheckError,
    HealthCheckResponse,
    ReturnType<typeof healthCheckQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: healthCheckQueryKey(options),
  });

export const healthLivenessQueryKey = (options?: Options<HealthLivenessData>) =>
  createQueryKey("healthLiveness", options);

/**
 * Kubernetes liveness probe.
 *
 * Returns 200 if the service is running. This endpoint should always succeed
 * unless the service process is completely broken. Use this for Kubernetes
 * liveness probes to detect and restart unhealthy pods.
 */
export const healthLivenessOptions = (options?: Options<HealthLivenessData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof healthLivenessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthLiveness({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: healthLivenessQueryKey(options),
  });

export const healthReadinessQueryKey = (options?: Options<HealthReadinessData>) =>
  createQueryKey("healthReadiness", options);

/**
 * Kubernetes readiness probe.
 *
 * Returns 200 if the service is ready to accept traffic. Checks that critical
 * dependencies (database) are available. Use this for Kubernetes readiness
 * probes to control traffic routing to pods.
 */
export const healthReadinessOptions = (options?: Options<HealthReadinessData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof healthReadinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthReadiness({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: healthReadinessQueryKey(options),
  });

/**
 * Exchange a PKCE authorization code for a user-scoped API key.
 */
export const oauthTokenMutation = (
  options?: Partial<Options<OauthTokenData>>
): UseMutationOptions<OauthTokenResponse, OauthTokenError, Options<OauthTokenData>> => {
  const mutationOptions: UseMutationOptions<
    OauthTokenResponse,
    OauthTokenError,
    Options<OauthTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await oauthToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
